webpackJsonp([0],{

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var NUMBER_ERROR_MESSAGE = exports.NUMBER_ERROR_MESSAGE = 'Invalid number. eg: 55, 43a, 12-14';
var POSTCODE_ERROR_MESSAGE = exports.POSTCODE_ERROR_MESSAGE = 'Postcode invalid';
var REQUIRED_ERROR_MESSAGE = exports.REQUIRED_ERROR_MESSAGE = 'This field is required';

var UNIT_NUMBER_KEY = exports.UNIT_NUMBER_KEY = 'address_unit_number';
var UNIT_TYPE_KEY = exports.UNIT_TYPE_KEY = 'address_unit_type';
var STREET_NUMBER_KEY = exports.STREET_NUMBER_KEY = 'address_street_number';
var STREET_NAME_KEY = exports.STREET_NAME_KEY = 'address_street_name';
var STREET_TYPE_KEY = exports.STREET_TYPE_KEY = 'address_street_type';
var SUBURB_KEY = exports.SUBURB_KEY = 'address_suburb';
var STATE_KEY = exports.STATE_KEY = 'address_state';
var POSTCODE_KEY = exports.POSTCODE_KEY = 'address_postcode';
var STATE_SELECTION = exports.STATE_SELECTION = ['VIC', 'NSW', 'ACT', 'QLD', 'NT', 'SA', 'TAS', 'WA'];
var UNIT_TYPE_SELECTION = exports.UNIT_TYPE_SELECTION = ['Apartment', 'Flat', 'Level', 'Suite', 'Shop', 'Unit'];
// List taken from https://shop.vodafone.com.au/checkout
// JSON.stringify(Array.from(document.querySelectorAll('#homeAddressStreetType option')).map(opt => opt.innerHTML))
var STREET_TYPE_SELECTION = exports.STREET_TYPE_SELECTION = [
/* Common */
'Avenue', 'Crescent', 'Highway', 'Lane', 'Parade', 'Place', 'Road', 'Street',

/* The rest */
'Alley', 'Alleyway', 'Amble', 'Anchorage', 'Approach', 'Arcade', 'Artery', 'Basin', 'Beach', 'Bend', 'Block', 'Boulevard', 'Brace', 'Brae', 'Break', 'Bridge', 'Broadway', 'Brow', 'Bypass', 'Byway', 'Causeway', 'Centre', 'Centreway', 'Chase', 'Circle', 'Circlet', 'Circuit', 'Circus', 'Close', 'Colonnade', 'Common', 'Concourse', 'Copse', 'Corner', 'Corso', 'Court', 'Courtyard', 'Cove', 'Crest', 'Cross', 'Crossing', 'Crossroad', 'Crossway', 'Cruiseway', 'Cutting', 'Dale', 'Dell', 'Deviation', 'Dip', 'Distributor', 'Drive', 'Driveway', 'Edge', 'Elbow', 'End', 'Entrance', 'Esplanade', 'Estate', 'Expressway', 'Extension', 'Fairway', 'Firetrail', 'Flat', 'Follow', 'Footway', 'Foreshore', 'Formation', 'Freeway', 'Front', 'Frontage', 'Gap', 'Garden', 'Gardens', 'Gate', 'Gates', 'Glade', 'Glen', 'Grange', 'Green', 'Ground', 'Grove', 'Gully', 'Heights', 'Highroad', 'Hill', 'Interchange', 'Intersection', 'Junction', 'Key', 'Landing', 'Laneway', 'Lees', 'Line', 'Link', 'Little', 'Lookout', 'Loop', 'Lower', 'Mall', 'Meander', 'Mew', 'Mews', 'Motorway', 'Mount', 'Nook', 'Outlook', 'Park', 'Parklands', 'Parkway', 'Part', 'Pass', 'Path', 'Pathway', 'Piazza', 'Plateau', 'Plaza', 'Pocket', 'Point', 'Port', 'Promenade', 'Quad', 'Quadrangle', 'Quadrant', 'Quay', 'Quays', 'Ramble', 'Ramp', 'Range', 'Reach', 'Reserve', 'Rest', 'Retreat', 'Ride', 'Ridge', 'Ridgeway', 'Ring', 'Rise', 'River', 'Riverway', 'Riviera', 'Roads', 'Roadside', 'Roadway', 'Ronde', 'Rosebowl', 'Rotary', 'Round', 'Route', 'Row', 'Rue', 'Run', 'Siding', 'Slope', 'Sound', 'Spur', 'Square', 'Stairs', 'Steps', 'Strand', 'Strip', 'Subway', 'Tarn', 'Terrace', 'Thoroughfare', 'Tollway', 'Top', 'Tor', 'Towers', 'Track', 'Trail', 'Trailer', 'Triangle', 'Trunkway', 'Turn', 'Underpass', 'Upper', 'Vale', 'Viaduct', 'View', 'Villas', 'Vista', 'Wade', 'Walk', 'Walkway', 'Way', 'Wharf', 'Wynd', 'Yard'];

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleTrackingOnChange = exports.handleTrackingOnBlur = exports.getValue = exports.getAction = exports.sendEvent = undefined;

var _tracking = __webpack_require__(28);

var _tracking2 = _interopRequireDefault(_tracking);

var _constants = __webpack_require__(161);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Record an event for input fields and optionally track timing and also count towards
 * form abandonment
 * @param {String} label
 * @param {String} action
 * @param {String} category
 * @param {Number} elapsedTime
 */
var sendEvent = exports.sendEvent = function () {
  function sendEvent(label, action, category, value, elapsedTime) {
    var non_interaction = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;

    // Record the event
    (0, _tracking2['default'])(action, {
      event_category: category,
      event_label: label,
      value: value,
      non_interaction: non_interaction
    });

    // Store in history for form abandonment event
    if (action === _constants.GA_ACTION_COMPLETED) {
      _tracking.fieldTouchHistory.push(label);
    }

    // Prefilled fields will have no elapsed time, so we should not record
    // timings
    if (elapsedTime && elapsedTime < 1800000 && action === _constants.GA_ACTION_COMPLETED) {
      // Record the time spent in the field
      (0, _tracking2['default'])('timing_complete', {
        event_category: category,
        event_label: label,
        name: 'Time in field',
        value: elapsedTime
      });
    }
  }

  return sendEvent;
}();

var getAction = exports.getAction = function () {
  function getAction(value) {
    return value.length || value === true || value === 'true' ? _constants.GA_ACTION_COMPLETED : _constants.GA_ACTION_SKIPPED;
  }

  return getAction;
}();
var getValue = exports.getValue = function () {
  function getValue(input) {
    return input.value || input.checked;
  }

  return getValue;
}();
var handleTrackingOnBlur = exports.handleTrackingOnBlur = function () {
  function handleTrackingOnBlur(e, category, startTime) {
    var name = e.target.name || e.target.id;
    var value = getValue(e.target);
    var action = getAction(value);

    // Only track elapsed time if we're given a start time
    var elapsedTime = startTime ? new Date().getTime() - startTime : undefined;

    var trackedCompleted = e.target.getAttribute('data-completed') === 'true' || false;
    var trackedSkipped = e.target.getAttribute('data-skipped') === 'true' || false;

    if (!trackedCompleted && action === _constants.GA_ACTION_COMPLETED) {
      sendEvent(name, action, category, undefined, elapsedTime);
      e.target.setAttribute('data-completed', true);
    } else if (!trackedSkipped && !trackedCompleted) {
      e.target.setAttribute('data-skipped', true);
      sendEvent(name, action, category, undefined, elapsedTime);
    }
  }

  return handleTrackingOnBlur;
}();
var handleTrackingOnChange = exports.handleTrackingOnChange = function () {
  function handleTrackingOnChange(e, category, startTime) {
    var name = e.target.name || e.target.id;
    var value = getValue(e.target);
    var action = getAction(value);

    // Only track elapsed time if we're given a start time
    var elapsedTime = startTime ? new Date().getTime() - startTime : undefined;

    var trackedCompleted = e.target.getAttribute('data-completed') === 'true' || false;

    if (!trackedCompleted && action === _constants.GA_ACTION_COMPLETED) {
      sendEvent(name, action, category, undefined, elapsedTime);
      e.target.setAttribute('data-completed', true);
    }
  }

  return handleTrackingOnChange;
}();

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(161);

var _utils = __webpack_require__(125);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WithInputAnalytics = function () {
  function WithInputAnalytics(category) {
    return function (WrappedComponent) {
      var WrappedInputComponent = function (_PureComponent) {
        _inherits(WrappedInputComponent, _PureComponent);

        function WrappedInputComponent(props) {
          _classCallCheck(this, WrappedInputComponent);

          var _this = _possibleConstructorReturn(this, (WrappedInputComponent.__proto__ || Object.getPrototypeOf(WrappedInputComponent)).call(this, props));

          _initialiseProps.call(_this);

          _this.startTime = null;
          _this.trackedCompleted = false;
          _this.trackedSkipped = false;
          return _this;
        }

        _createClass(WrappedInputComponent, [{
          key: 'componentDidMount',
          value: function () {
            function componentDidMount() {
              var _props = this.props,
                  value = _props.value,
                  options = _props.options;
              // Track prefilled values - send completed event immediately
              // Except for radio fields

              if (options && options.length) {
                return;
              }
              var name = this.getName(this.props);
              if (value && value.length) {
                (0, _utils.sendEvent)(name, _constants.GA_ACTION_COMPLETED, category);
                this.trackedCompleted = true;
              }
            }

            return componentDidMount;
          }()
        }, {
          key: 'render',
          value: function () {
            function render() {
              var _props2 = this.props,
                  onBlur = _props2.onBlur,
                  onChange = _props2.onChange,
                  otherProps = _objectWithoutProperties(_props2, ['onBlur', 'onChange']);

              return _react2['default'].createElement(WrappedComponent, _extends({}, otherProps, { onBlur: this.onBlur, onFocus: this.onFocus, onChange: this.onChange }));
            }

            return render;
          }()
        }]);

        return WrappedInputComponent;
      }(_react.PureComponent);

      var _initialiseProps = function () {
        function _initialiseProps() {
          var _this2 = this;

          this.onFocus = function () {
            var _props3;

            _this2.startTime = new Date().getTime();
            (_props3 = _this2.props).onFocus.apply(_props3, arguments);
          };

          this.onBlur = function (e) {
            var _props4;

            for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              rest[_key - 1] = arguments[_key];
            }

            var name = _this2.getName(_this2.props);
            var value = (0, _utils.getValue)(e.currentTarget);
            var action = (0, _utils.getAction)(value);
            var elapsedTime = new Date().getTime() - _this2.startTime;

            if (!_this2.trackedCompleted && action === _constants.GA_ACTION_COMPLETED) {
              (0, _utils.sendEvent)(name, action, category, undefined, elapsedTime, false);
              _this2.trackedCompleted = true;
            } else if (!_this2.trackedSkipped && !_this2.trackedCompleted) {
              _this2.trackedSkipped = true;
              (0, _utils.sendEvent)(name, action, category, undefined, elapsedTime, false);
            }
            (_props4 = _this2.props).onBlur.apply(_props4, [e].concat(rest));
          };

          this.onChange = function (e) {
            var _props5;

            for (var _len2 = arguments.length, rest = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              rest[_key2 - 1] = arguments[_key2];
            }

            // Only track onChange for radio fields (ChoicField)
            if (_this2.props.options && _this2.props.options.length) {
              var _name = _this2.getName(_this2.props);
              var value = (0, _utils.getValue)(e.currentTarget);
              var action = (0, _utils.getAction)(value);
              var elapsedTime = new Date().getTime() - _this2.startTime;

              if (!_this2.trackedCompleted && action === _constants.GA_ACTION_COMPLETED) {
                (0, _utils.sendEvent)(_name, action, category, undefined, elapsedTime, false);
                _this2.trackedCompleted = true;
              }
            }
            (_props5 = _this2.props).onChange.apply(_props5, [e].concat(rest));
          };

          this.getName = function (props) {
            return props.name || props.fieldName || props.id;
          };
        }

        return _initialiseProps;
      }();

      var name = WrappedComponent.displayName || WrappedComponent.name || 'Component';
      WrappedInputComponent.displayName = 'withInputAnalytics(' + name + ')';

      WrappedInputComponent.defaultProps = {
        onBlur: function () {
          function onBlur(f) {
            return f;
          }

          return onBlur;
        }(),
        onFocus: function () {
          function onFocus(f) {
            return f;
          }

          return onFocus;
        }(),
        onChange: function () {
          function onChange(f) {
            return f;
          }

          return onChange;
        }(),
        options: [],
        value: ''
      };
      return WrappedInputComponent;
    };
  }

  return WithInputAnalytics;
}();

exports['default'] = WithInputAnalytics;

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ContactPhone = __webpack_require__(686);

var _ContactPhone2 = _interopRequireDefault(_ContactPhone);

var _classnames = __webpack_require__(37);

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = __webpack_require__(688);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ErrorScreen = function (_PureComponent) {
  _inherits(ErrorScreen, _PureComponent);

  function ErrorScreen() {
    _classCallCheck(this, ErrorScreen);

    return _possibleConstructorReturn(this, (ErrorScreen.__proto__ || Object.getPrototypeOf(ErrorScreen)).apply(this, arguments));
  }

  _createClass(ErrorScreen, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            text = _props.text,
            phoneNumber = _props.phoneNumber,
            children = _props.children;
        var _props2 = this.props,
            linkTarget = _props2.linkTarget,
            linkText = _props2.linkText,
            textClass = _props2.textClass;

        return _jsx('div', {
          className: _styles2['default'].wrapper
        }, void 0, _jsx('div', {
          className: (0, _classnames2['default'])(textClass, _styles2['default'].content),
          dangerouslySetInnerHTML: { __html: text }
        }), phoneNumber && _jsx(_ContactPhone2.default, {
          phoneNumber: phoneNumber
        }), children, _jsx('a', {
          className: _styles2['default'].actionLink,
          href: linkTarget
        }, void 0, linkText));
      }

      return render;
    }()
  }]);

  return ErrorScreen;
}(_react.PureComponent);

ErrorScreen.defaultProps = {
  text: '<h2>Something went wrong...</h2><p>Unfortunately, something didn\'t go as planned. ' + 'Please try again later or call us on the number below ' + 'to find out if we can service your address.</p>',
  phoneNumber: undefined,
  children: null,
  linkTarget: '.',
  linkText: 'Try Again',
  textClass: undefined
};
exports['default'] = ErrorScreen;

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(37);

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = __webpack_require__(695);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BackButton = function (_PureComponent) {
  _inherits(BackButton, _PureComponent);

  function BackButton() {
    _classCallCheck(this, BackButton);

    return _possibleConstructorReturn(this, (BackButton.__proto__ || Object.getPrototypeOf(BackButton)).apply(this, arguments));
  }

  _createClass(BackButton, [{
    key: 'render',
    value: function () {
      function render() {
        return _jsx('button', {
          type: 'button',
          onClick: this.props.onClick,
          className: (0, _classnames2['default'])(_styles2['default'].back, this.props.className)
        }, void 0, 'Back');
      }

      return render;
    }()
  }]);

  return BackButton;
}(_react.PureComponent);

BackButton.defaultProps = {
  onClick: function () {
    function onClick(f) {
      return f;
    }

    return onClick;
  }(),
  className: ''
};
exports['default'] = BackButton;

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _FormFieldLayout = __webpack_require__(43);

var _FormFieldLayout2 = _interopRequireDefault(_FormFieldLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var GenericNameField = function () {
  function GenericNameField(_ref) {
    var onBlur = _ref.onBlur,
        onFocus = _ref.onFocus,
        onChange = _ref.onChange,
        value = _ref.value,
        loading = _ref.loading,
        errorMessage = _ref.errorMessage,
        fieldName = _ref.fieldName,
        labelText = _ref.labelText,
        placeholder = _ref.placeholder,
        description = _ref.description,
        isRequired = _ref.isRequired;

    var hasError = !!errorMessage;
    var errorObject = { status: hasError, message: errorMessage };
    var fieldElement = _jsx('input', {
      type: 'text',
      name: fieldName,
      className: 'form-input',
      id: fieldName,
      maxLength: '140',
      value: value,
      onChange: onChange,
      onBlur: onBlur,
      onFocus: onFocus,
      disabled: loading,
      required: isRequired,
      placeholder: placeholder || labelText
    });
    return _jsx(_FormFieldLayout2.default, {
      fieldName: fieldName,
      labelText: labelText,
      fieldElement: fieldElement,
      description: description,
      error: errorObject
    });
  }

  return GenericNameField;
}();

GenericNameField.defaultProps = {
  value: '',
  fieldName: 'genericNameField',
  labelText: 'Generic Name Field',
  placeholder: '',
  loading: false,
  onBlur: function () {
    function onBlur(f) {
      return f;
    }

    return onBlur;
  }(),
  onFocus: function () {
    function onFocus(f) {
      return f;
    }

    return onFocus;
  }(),
  onChange: function () {
    function onChange(f) {
      return f;
    }

    return onChange;
  }(),
  errorMessage: '',
  description: '',
  isRequired: false
};

exports['default'] = GenericNameField;

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadVoucher = exports.loadVoucherSuccess = exports.loadVoucherFailure = exports.loadVoucherRequest = exports.clearVoucher = exports.setFieldErrors = exports.setFieldValues = exports.PLAN_SELECT_SUCCESS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.planSelectSuccess = planSelectSuccess;
exports.selectPlan = selectPlan;

var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

var _tracking = __webpack_require__(28);

var _tracking2 = _interopRequireDefault(_tracking);

var _constants = __webpack_require__(67);

var _actions = __webpack_require__(31);

var _constants2 = __webpack_require__(173);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PLAN_SELECT_SUCCESS = exports.PLAN_SELECT_SUCCESS = 'PLAN_SELECT_SUCCESS';

function planSelectSuccess(nextStage, plan, voucherCode) {
  return {
    type: PLAN_SELECT_SUCCESS,
    payload: {
      nextStage: nextStage,
      plan: plan,
      voucher: voucherCode
    }
  };
}

function selectPlan(plan, voucherCode) {
  return function (dispatch) {
    var options = {
      headers: _extends({}, _constants.CSRF_HEADERS)
    };
    _axios2['default'].post(_constants2.API_PLAN_SELECT_URL, { id: plan.id, code: voucherCode }, options).then(function (response) {
      if (response.data.success) {
        dispatch(planSelectSuccess(response.data.next, plan, voucherCode));
        (0, _tracking2['default'])('Success', {
          event_category: _constants2.GA_EVENT_CATEGORY,
          event_label: voucherCode ? 'Plan select - Use Voucher' : 'Plan select - Selected'
        });
      } else {
        dispatch((0, _actions.setError)(true));
        (0, _tracking2['default'])('Error', {
          event_category: _constants2.GA_EVENT_CATEGORY,
          event_label: 'Plan select - Backend Failure Response'
        });
      }
    })['catch'](function (error) {
      if (error.response && error.response.message) {
        dispatch((0, _actions.setError)(error.response.message));
        (0, _tracking2['default'])('Error', {
          event_category: _constants2.GA_EVENT_CATEGORY,
          event_label: 'Plan select - Backend Failure Response'
        });
      } else {
        dispatch((0, _actions.setError)(true));
        (0, _tracking2['default'])('Error', {
          event_category: _constants2.GA_EVENT_CATEGORY,
          event_label: 'Plan select - Network Error'
        });
      }
    });
  };
}

var setFieldValues = exports.setFieldValues = function () {
  function setFieldValues(fields) {
    return {
      type: _constants2.PLAN_SET_FIELDS,
      payload: fields
    };
  }

  return setFieldValues;
}();

var setFieldErrors = exports.setFieldErrors = function () {
  function setFieldErrors(errors) {
    Object.keys(errors).forEach(function (field) {
      (0, _tracking2['default'])('Invalid', {
        event_category: _constants2.GA_EVENT_CATEGORY,
        event_label: field,
        field_name: field,
        error_message: errors[field],
        non_interaction: true
      });
    });
    return {
      type: _constants2.PLAN_SET_ERRORS,
      payload: errors
    };
  }

  return setFieldErrors;
}();

var clearVoucher = exports.clearVoucher = function () {
  function clearVoucher() {
    return {
      type: _constants2.CLEAR_VOUCHER
    };
  }

  return clearVoucher;
}();

var loadVoucherRequest = exports.loadVoucherRequest = function () {
  function loadVoucherRequest(voucherCode) {
    return {
      type: _constants2.LOAD_VOUCHER_REQUEST,
      payload: voucherCode
    };
  }

  return loadVoucherRequest;
}();

var loadVoucherFailure = exports.loadVoucherFailure = function () {
  function loadVoucherFailure() {
    return {
      type: _constants2.LOAD_VOUCHER_FAILURE
    };
  }

  return loadVoucherFailure;
}();

var loadVoucherSuccess = exports.loadVoucherSuccess = function () {
  function loadVoucherSuccess(payload) {
    return {
      type: _constants2.LOAD_VOUCHER_SUCCESS,
      payload: payload
    };
  }

  return loadVoucherSuccess;
}();

var loadVoucher = exports.loadVoucher = function () {
  function loadVoucher(voucherCode, errorAction) {
    return function (dispatch) {
      dispatch(loadVoucherRequest(voucherCode));
      _axios2['default'].get('/api/signup/vouchers/' + voucherCode + '/').then(function (data) {
        dispatch(loadVoucherSuccess(data.data));
      })['catch'](function (error) {
        if (error.response && error.response.data) {
          if (error.response.status === 412) {
            dispatch(loadVoucherFailure());
            if (errorAction) dispatch(errorAction(error.response.data.type));
          } else {
            dispatch(loadVoucherFailure());
            if (errorAction) dispatch(errorAction(error.response.data.code));
          }
        } else {
          dispatch(loadVoucherFailure());
          if (errorAction) {
            errorAction(['There was an error loading your voucher. Please try again']);
          }
        }
      });
    };
  }

  return loadVoucher;
}();

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GA_ACTION_SKIPPED = exports.GA_ACTION_SKIPPED = 'Skipped';
var GA_ACTION_COMPLETED = exports.GA_ACTION_COMPLETED = 'Completed';

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _FormFieldLayout = __webpack_require__(43);

var _FormFieldLayout2 = _interopRequireDefault(_FormFieldLayout);

var _constants = __webpack_require__(95);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var EmailField = function () {
  function EmailField(_ref) {
    var onBlur = _ref.onBlur,
        onChange = _ref.onChange,
        onFocus = _ref.onFocus,
        value = _ref.value,
        loading = _ref.loading,
        errorMessage = _ref.errorMessage,
        inputRef = _ref.inputRef;

    var hasValueClass = value ? 'has-value' : '';
    var hasError = !!errorMessage;

    var errorObject = { status: hasError, message: errorMessage };
    var fieldElement = _react2['default'].createElement('input', {
      ref: inputRef,
      type: 'email',
      name: _constants.LEAD_EMAIL_KEY,
      className: 'form-input ' + hasValueClass,
      id: _constants.LEAD_EMAIL_KEY,
      value: value,
      onChange: onChange,
      onBlur: onBlur,
      onFocus: onFocus,
      disabled: loading,
      required: true,
      placeholder: 'Email'
    });
    return _jsx(_FormFieldLayout2.default, {
      fieldName: _constants.LEAD_EMAIL_KEY,
      labelText: 'Email',
      fieldElement: fieldElement,
      error: errorObject
    });
  }

  return EmailField;
}();

EmailField.defaultProps = {
  value: '',
  loading: false,
  onBlur: function () {
    function onBlur(f) {
      return f;
    }

    return onBlur;
  }(),
  onChange: function () {
    function onChange(f) {
      return f;
    }

    return onChange;
  }(),
  onFocus: function () {
    function onFocus(f) {
      return f;
    }

    return onFocus;
  }(),
  errorMessage: '',
  inputRef: function () {
    function inputRef(f) {
      return f;
    }

    return inputRef;
  }()
};

exports['default'] = EmailField;

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FIRST_NAME_KEY = exports.FIRST_NAME_KEY = 'first_name';
var MIDDLE_NAME_KEY = exports.MIDDLE_NAME_KEY = 'middle_name';
var LAST_NAME_KEY = exports.LAST_NAME_KEY = 'last_name';
var PHONE_KEY = exports.PHONE_KEY = 'phone';
var DATE_BIRTH_KEY = exports.DATE_BIRTH_KEY = 'date_of_birth';
var ACCOUNT_PIN_KEY = exports.ACCOUNT_PIN_KEY = 'account_pin';
var EMAIL_KEY = exports.EMAIL_KEY = 'email';

var PHONE_ERROR_MESSAGE = exports.PHONE_ERROR_MESSAGE = 'Enter a valid Australian phone number, e.g. 0411111111';
var DATE_ERROR_MESSAGE = exports.DATE_ERROR_MESSAGE = 'Enter a valid date, e.g. for 10 December 1990 enter 10/12/1990';
var ACCOUNT_PIN_ERROR_MESSAGE = exports.ACCOUNT_PIN_ERROR_MESSAGE = 'Account PIN must be 4 digits.';

var REQUIRED_ERROR_MESSAGE = exports.REQUIRED_ERROR_MESSAGE = 'This field is required';
var DEFAULT_RESPONSE_ERROR = exports.DEFAULT_RESPONSE_ERROR = 'We encountered an issue while trying to save your details, please try again';

var GA_CATEGORY = exports.GA_CATEGORY = 'Personal';

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var OWNS_SERVICE_KEY = exports.OWNS_SERVICE_KEY = 'owns_service';
var LANDLINE_KEY = exports.LANDLINE_KEY = 'landline_phone';
var KNOWS_AVC_ID_KEY = exports.KNOWS_AVC_ID_KEY = 'knows_avc_id';
var AVC_ID_KEY = exports.AVC_ID_KEY = 'avc_id';
var GA_EVENT_CATEGORY = exports.GA_EVENT_CATEGORY = 'Owner';

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateUpfront = calculateUpfront;
// eslint-disable-next-line import/prefer-default-export
function calculateUpfront(reduxState) {
  var _reduxState$checkoutR = reduxState.checkoutReducer,
      planSelected = _reduxState$checkoutR.planSelected,
      voucher = _reduxState$checkoutR.voucher;


  return voucher ? 0 : planSelected.rate;
}

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IDENTIFICATION_SUCCESS = exports.IDENTIFICATION_ERROR = exports.IDENTIFICATION_INIT_DONE = exports.IDENTIFICATION_INIT_LOADING = exports.SET_ERROR = exports.IS_LOADING = undefined;
exports.isLoading = isLoading;
exports.setError = setError;
exports.identificationInitLoading = identificationInitLoading;
exports.identificationInitDone = identificationInitDone;
exports.identicationSetError = identicationSetError;
exports.identificationSuccess = identificationSuccess;
exports.identificationInit = identificationInit;
exports.identificationComplete = identificationComplete;

var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

var _tracking = __webpack_require__(28);

var _tracking2 = _interopRequireDefault(_tracking);

var _constants = __webpack_require__(277);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var IS_LOADING = exports.IS_LOADING = 'IS_LOADING';
var SET_ERROR = exports.SET_ERROR = 'SET_ERROR';
var IDENTIFICATION_INIT_LOADING = exports.IDENTIFICATION_INIT_LOADING = 'IDENTIFICATION_INIT_LOADING';
var IDENTIFICATION_INIT_DONE = exports.IDENTIFICATION_INIT_DONE = 'IDENTIFICATION_INIT_DONE';
var IDENTIFICATION_ERROR = exports.IDENTIFICATION_ERROR = 'IDENTIFICATION_ERROR';
var IDENTIFICATION_SUCCESS = exports.IDENTIFICATION_SUCCESS = 'IDENTIFICATION_SUCCESS';

function isLoading(state) {
  return {
    type: IS_LOADING,
    payload: state
  };
}

function setError(errorMessage) {
  return {
    type: SET_ERROR,
    payload: errorMessage
  };
}
function identificationInitLoading() {
  return {
    type: IDENTIFICATION_INIT_LOADING
  };
}

function identificationInitDone(verificationToken) {
  return {
    type: IDENTIFICATION_INIT_DONE,
    verificationToken: verificationToken
  };
}

function identicationSetError(message) {
  return {
    type: IDENTIFICATION_ERROR,
    payload: message
  };
}

function identificationSuccess(nextStage) {
  return {
    type: IDENTIFICATION_SUCCESS,
    payload: nextStage
  };
}

function identificationInit() {
  return function (dispatch) {
    dispatch(identificationInitLoading());
    _axios2['default'].get(_constants.API_IDENTIFICATION_URL).then(function (response) {
      if (response.data && response.data.success) {
        dispatch(identificationInitDone(response.data.vrf_token));
        (0, _tracking2['default'])('Success', {
          event_category: _constants.GA_EVENT_CATEGORY,
          event_label: 'Identification Init - Success',
          non_interaction: true
        });
      } else {
        dispatch(setError(true));
        dispatch(isLoading(false));
        (0, _tracking2['default'])('Error', {
          event_category: _constants.GA_EVENT_CATEGORY,
          event_label: 'Identification Init - Backend Error',
          non_interaction: true
        });
      }
    })['catch'](function (error) {
      if (error.response && error.response.message) {
        dispatch(setError(error.response.message));
        dispatch(isLoading(false));
        (0, _tracking2['default'])('Error', {
          event_category: _constants.GA_EVENT_CATEGORY,
          event_label: 'Identification Init - Backend Error',
          non_interaction: true
        });
      } else {
        dispatch(setError(true));
        dispatch(isLoading(false));
        (0, _tracking2['default'])('Error', {
          event_category: _constants.GA_EVENT_CATEGORY,
          event_label: 'Identification Init - Network Error',
          non_interaction: true
        });
      }
    });
  };
}

function identificationComplete(veritificationToken) {
  return function (dispatch) {
    var data = {
      vrf_token: veritificationToken
    };
    _axios2['default'].post(_constants.API_IDENTIFICATION_URL, data).then(function (response) {
      if (response.data.success) {
        dispatch(identificationSuccess(response.data.next));
        (0, _tracking2['default'])('Success', {
          event_category: _constants.GA_EVENT_CATEGORY,
          event_label: 'Identification Complete - Success',
          non_interaction: true
        });
      } else {
        dispatch(identicationSetError(true));
        (0, _tracking2['default'])('Error', {
          event_category: _constants.GA_EVENT_CATEGORY,
          event_label: 'Identification Complete - Backend Error',
          non_interaction: true
        });
      }
    })['catch'](function () {
      dispatch(identicationSetError(true));
      (0, _tracking2['default'])('Error', {
        event_category: _constants.GA_EVENT_CATEGORY,
        event_label: 'Identification Complete - Network Error',
        non_interaction: true
      });
    });
  };
}

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MODEM_DELIVERY_ADDRESS_MANUAL = exports.MODEM_DELIVERY_ADDRESS_SAME_AS_DELIVERY = exports.PERSONAL_CLEAR_FIELD_ERROR = exports.PERSONAL_SUBMIT_SUCCESS = exports.PERSONAL_FIELD_ERRORS = exports.PERSONAL_SET_FIELDS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.setModemAddressSameAsDelivery = setModemAddressSameAsDelivery;
exports.setModemDeliveryAddressManual = setModemDeliveryAddressManual;
exports.setFieldValues = setFieldValues;
exports.setFieldErrors = setFieldErrors;
exports.clearFieldError = clearFieldError;
exports.loadDetails = loadDetails;
exports.submitPersonalInfo = submitPersonalInfo;

var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

var _tracking = __webpack_require__(28);

var _tracking2 = _interopRequireDefault(_tracking);

var _constants = __webpack_require__(29);

var _actions = __webpack_require__(31);

var _formValidator = __webpack_require__(61);

var _constants2 = __webpack_require__(163);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PERSONAL_SET_FIELDS = exports.PERSONAL_SET_FIELDS = 'PERSONAL_SET_FIELDS';
var PERSONAL_FIELD_ERRORS = exports.PERSONAL_FIELD_ERRORS = 'PERSONAL_SUBMIT_ERRORS';
var PERSONAL_SUBMIT_SUCCESS = exports.PERSONAL_SUBMIT_SUCCESS = 'PERSONAL_SUBMIT_SUCCESS';
var PERSONAL_CLEAR_FIELD_ERROR = exports.PERSONAL_CLEAR_FIELD_ERROR = 'PERSONAL_CLEAR_FIELD_ERROR';

var MODEM_DELIVERY_ADDRESS_SAME_AS_DELIVERY = exports.MODEM_DELIVERY_ADDRESS_SAME_AS_DELIVERY = 'MODEM_DELIVERY_ADDRESS_SAME_AS_DELIVERY';
var MODEM_DELIVERY_ADDRESS_MANUAL = exports.MODEM_DELIVERY_ADDRESS_MANUAL = 'MODEM_DELIVERY_ADDRESS_MANUAL';

function setModemAddressSameAsDelivery(yesOrNo) {
  return {
    type: MODEM_DELIVERY_ADDRESS_SAME_AS_DELIVERY,
    payload: yesOrNo
  };
}

function setModemDeliveryAddressManual(state) {
  return {
    type: MODEM_DELIVERY_ADDRESS_MANUAL,
    payload: state
  };
}

function setFieldValues(fields) {
  return {
    type: PERSONAL_SET_FIELDS,
    payload: fields
  };
}

function personalSubmitSuccess(newStage, address) {
  return {
    type: PERSONAL_SUBMIT_SUCCESS,
    payload: {
      next: newStage,
      address: address
    }
  };
}

function setFieldErrors(errors) {
  Object.keys(errors).forEach(function (field) {
    (0, _tracking2['default'])('Invalid', {
      event_category: _constants2.GA_CATEGORY,
      event_label: field,
      field_name: field,
      error_message: errors[field],
      non_interaction: true
    });
  });
  return {
    type: PERSONAL_FIELD_ERRORS,
    payload: errors
  };
}

function clearFieldError(fieldName) {
  return {
    type: PERSONAL_CLEAR_FIELD_ERROR,
    payload: fieldName
  };
}

function loadDetails() {
  return function (dispatch) {
    dispatch((0, _actions.isLoading)(true));
    _axios2['default'].get(_constants.API_PERSONAL_URL).then(function (response) {
      if (response.data.success) {
        dispatch(setFieldValues(response.data.fields));
      } else {
        dispatch((0, _actions.setError)(true));
      }
    })['catch'](function () {
      dispatch((0, _actions.setError)(true));
    });
  };
}

function submitPersonalInfo(data, manualAddress, sameAddressAsDelivery) {
  return function (dispatch) {
    dispatch(setFieldValues(data));
    dispatch((0, _actions.isLoading)(true));

    var payload = _extends({}, data, {
      is_manual_address: manualAddress,
      same_as_delivery_address: sameAddressAsDelivery
    });

    _axios2['default'].post(_constants.API_PERSONAL_URL, payload).then(function (response) {
      if (response.data.success) {
        dispatch(personalSubmitSuccess(response.data.next, response.data.address));
        (0, _tracking2['default'])('Success', {
          event_category: _constants2.GA_CATEGORY
        });
      } else {
        dispatch((0, _actions.setError)(true));
        (0, _tracking2['default'])('Failed', {
          event_category: _constants2.GA_CATEGORY,
          event_label: 'Rejected'
        });
      }
    })['catch'](function (error) {
      if (error.response.data && error.response.data.errors) {
        dispatch(setFieldErrors((0, _formValidator.flattenErrors)(error.response.data.errors)));
      } else {
        dispatch((0, _actions.setError)(true));
        (0, _tracking2['default'])('Failed', {
          event_category: _constants2.GA_CATEGORY,
          event_label: error.response && error.response.statusText || 'Network Error'
        });
      }
    });
  };
}

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MODEM_DELIVERY_SUCCESS = exports.MODEM_RESPONSE_MESSAGE = exports.MODEM_CLEAR_ERROR = exports.MODEM_SET_ERRORS = exports.MODEM_SET_FIELDS = exports.MODEM_ADDRESS_MANUAL = exports.MODEM_ADDRESS_SAME_AS_INSTALL = exports.MODEM_REQUIRED = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.setDeliverySameAsInstall = setDeliverySameAsInstall;
exports.setManualAddress = setManualAddress;
exports.setModemRequired = setModemRequired;
exports.setFieldValues = setFieldValues;
exports.setFieldErrors = setFieldErrors;
exports.clearFieldError = clearFieldError;
exports.setResponseMessage = setResponseMessage;
exports.modemDeliverySuccess = modemDeliverySuccess;
exports.submitData = submitData;

var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

var _tracking = __webpack_require__(28);

var _tracking2 = _interopRequireDefault(_tracking);

var _actions = __webpack_require__(31);

var _constants = __webpack_require__(29);

var _constants2 = __webpack_require__(280);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var MODEM_REQUIRED = exports.MODEM_REQUIRED = 'MODEM_REQUIRED';
var MODEM_ADDRESS_SAME_AS_INSTALL = exports.MODEM_ADDRESS_SAME_AS_INSTALL = 'MODEM_ADDRESS_SAME_AS_INSTALL';
var MODEM_ADDRESS_MANUAL = exports.MODEM_ADDRESS_MANUAL = 'MODEM_ADDRESS_MANUAL';
var MODEM_SET_FIELDS = exports.MODEM_SET_FIELDS = 'MODEM_SET_FIELDS';
var MODEM_SET_ERRORS = exports.MODEM_SET_ERRORS = 'MODEM_SET_ERRORS';
var MODEM_CLEAR_ERROR = exports.MODEM_CLEAR_ERROR = 'MODEM_CLEAR_ERROR';
var MODEM_RESPONSE_MESSAGE = exports.MODEM_RESPONSE_MESSAGE = 'MODEM_RESPONSE_MESSAGE';
var MODEM_DELIVERY_SUCCESS = exports.MODEM_DELIVERY_SUCCESS = 'MODEM_DELIVERY_SUCCESS';

function setDeliverySameAsInstall(yesOrNo) {
  return {
    type: MODEM_ADDRESS_SAME_AS_INSTALL,
    payload: yesOrNo
  };
}

function setManualAddress(yesOrNo) {
  return {
    type: MODEM_ADDRESS_MANUAL,
    payload: yesOrNo
  };
}

function setModemRequired(yesOrNo) {
  return {
    type: MODEM_REQUIRED,
    payload: yesOrNo
  };
}

function setFieldValues(fields) {
  return {
    type: MODEM_SET_FIELDS,
    payload: fields
  };
}

function setFieldErrors(errors) {
  Object.keys(errors).forEach(function (field) {
    (0, _tracking2['default'])('Invalid', {
      event_category: 'Modem',
      event_label: field,
      field_name: field,
      error_message: errors[field],
      non_interaction: true
    });
  });
  return {
    type: MODEM_SET_ERRORS,
    payload: errors
  };
}

function clearFieldError(fieldName) {
  return {
    type: MODEM_CLEAR_ERROR,
    payload: fieldName
  };
}

function setResponseMessage(status) {
  return {
    type: MODEM_RESPONSE_MESSAGE,
    payload: status
  };
}

function modemDeliverySuccess(nextStage, address) {
  return {
    type: MODEM_DELIVERY_SUCCESS,
    payload: {
      next: nextStage,
      address: address
    }
  };
}

function submitData() {
  var _this = this;

  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function () {
      function _callee(dispatch, getState) {
        var _getState$checkoutRed, modemFields, modemSameAsInstallAddress, modemRequired, modemManualAddress, postData, response, _response;

        return regeneratorRuntime.wrap(function () {
          function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  dispatch((0, _actions.isLoading)(true));

                  _context.prev = 1;
                  _getState$checkoutRed = getState().checkoutReducer, modemFields = _getState$checkoutRed.modemFields, modemSameAsInstallAddress = _getState$checkoutRed.modemSameAsInstallAddress, modemRequired = _getState$checkoutRed.modemRequired, modemManualAddress = _getState$checkoutRed.modemManualAddress;
                  postData = _extends({}, modemFields, {
                    requires_modem: modemRequired,
                    same_as_install_address: modemSameAsInstallAddress,
                    is_manual_address: modemManualAddress
                  });
                  _context.next = 6;
                  return _axios2['default'].post(_constants.API_MODEM_URL, postData);

                case 6:
                  response = _context.sent;

                  dispatch((0, _actions.isLoading)(false));

                  if (response.data.success) {
                    (0, _tracking2['default'])('Success', {
                      event_category: 'Modem',
                      event_label: modemSameAsInstallAddress ? 'same address' : 'other address'
                    });
                    dispatch(modemDeliverySuccess(response.data.next, response.data.address));
                  } else {
                    dispatch(setResponseMessage(_constants2.DEFAULT_RESPONSE_ERROR));
                    (0, _tracking2['default'])('Failed', {
                      event_category: 'Modem',
                      event_label: 'Rejected'
                    });
                  }
                  _context.next = 16;
                  break;

                case 11:
                  _context.prev = 11;
                  _context.t0 = _context['catch'](1);

                  dispatch((0, _actions.isLoading)(false));
                  dispatch(setResponseMessage(_constants2.DEFAULT_RESPONSE_ERROR));
                  if (!_context.t0.response || !_context.t0.response.data.errors) {
                    // network error
                    (0, _tracking2['default'])('Failed', {
                      event_category: 'Modem',
                      event_label: _context.t0.response && _context.t0.response.statusText || 'Network Error'
                    });
                  } else {
                    // response data
                    _response = _context.t0.response.data;

                    dispatch(setFieldErrors(_response.errors));
                  }

                case 16:
                case 'end':
                  return _context.stop();
              }
            }
          }

          return _callee$;
        }(), _callee, _this, [[1, 11]]);
      }

      return _callee;
    }()));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var API_PLAN_SELECT_URL = exports.API_PLAN_SELECT_URL = '/api/signup/plan_select/';
var GA_EVENT_CATEGORY = exports.GA_EVENT_CATEGORY = 'Plan Chooser';
var VOUCHER_CODE = exports.VOUCHER_CODE = 'voucher_code';

var LOAD_VOUCHER_REQUEST = exports.LOAD_VOUCHER_REQUEST = 'LOAD_VOUCHER_REQUEST';
var LOAD_VOUCHER_FAILURE = exports.LOAD_VOUCHER_FAILURE = 'LOAD_VOUCHER_FAILURE';
var LOAD_VOUCHER_SUCCESS = exports.LOAD_VOUCHER_SUCCESS = 'LOAD_VOUCHER_SUCCESS';

var PLAN_SET_FIELDS = exports.PLAN_SET_FIELDS = 'PLAN_SET_FIELDS';
var PLAN_SET_ERRORS = exports.PLAN_SET_ERRORS = 'PLAN_SET_ERRORS';
var CLEAR_VOUCHER = exports.CLEAR_VOUCHER = 'CLEAR_VOUCHER';

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUBMIT_LEAD_SUCCESS = undefined;
exports.submitLeadSuccess = submitLeadSuccess;
exports.submitLead = submitLead;

var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

var _tracking = __webpack_require__(28);

var _tracking2 = _interopRequireDefault(_tracking);

var _actions = __webpack_require__(31);

var _constants = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var SUBMIT_LEAD_SUCCESS = exports.SUBMIT_LEAD_SUCCESS = 'SUBMIT_LEAD_SUCCESS';

function submitLeadSuccess(next, reference) {
  return { type: SUBMIT_LEAD_SUCCESS, payload: { next: next, reference: reference } };
}

function submitLead() {
  return function (dispatch) {
    dispatch((0, _actions.isLoading)(true));

    _axios2['default'].post(_constants.API_SUBMIT_URL).then(function (response) {
      dispatch(submitLeadSuccess(response.data.next, response.data.reference));
    })['catch'](function (error) {
      dispatch((0, _actions.setError)(true));
      var reason = error.response.data && !error.response.data.success ? 'Server Error' : 'Network Error';
      (0, _tracking2['default'])('Error', {
        event_category: 'Web2case',
        event_label: reason,
        non_interaction: true
      });
    });
  };
}

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MULTI_ADDRESS_LOADED = exports.MULTI_ADDRESS_UPDATE_SUCCESS = exports.MULTI_ADDRESS_SELECT_SINGLE_OF_MULTIPLE = exports.MULTI_ADDRESS_SHOW_MORE_ADDRESSES = undefined;
exports.updateAddressSuccess = updateAddressSuccess;
exports.displayMoreAddresses = displayMoreAddresses;
exports.selectSingleAddress = selectSingleAddress;
exports.loadedAddresses = loadedAddresses;
exports.updateAddress = updateAddress;
exports.loadAddresses = loadAddresses;

var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

var _tracking = __webpack_require__(28);

var _tracking2 = _interopRequireDefault(_tracking);

var _actions = __webpack_require__(31);

var _constants = __webpack_require__(29);

var _constants2 = __webpack_require__(260);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var MULTI_ADDRESS_SHOW_MORE_ADDRESSES = exports.MULTI_ADDRESS_SHOW_MORE_ADDRESSES = 'MULTI_ADDRESS_SHOW_MORE_ADDRESSES';
var MULTI_ADDRESS_SELECT_SINGLE_OF_MULTIPLE = exports.MULTI_ADDRESS_SELECT_SINGLE_OF_MULTIPLE = 'MULTI_ADDRESS_SELECT_SINGLE_OF_MULTIPLE';
var MULTI_ADDRESS_UPDATE_SUCCESS = exports.MULTI_ADDRESS_UPDATE_SUCCESS = 'MULTI_ADDRESS_UPDATE_SUCCESS';
var MULTI_ADDRESS_LOADED = exports.MULTI_ADDRESS_LOADED = 'MULTI_ADDRESS_LOADED';

function updateAddressSuccess(address, nextStage) {
  return {
    type: MULTI_ADDRESS_UPDATE_SUCCESS,
    payload: { address: address, nextStage: nextStage }
  };
}

function displayMoreAddresses() {
  return { type: MULTI_ADDRESS_SHOW_MORE_ADDRESSES };
}

function selectSingleAddress(address) {
  return {
    type: MULTI_ADDRESS_SELECT_SINGLE_OF_MULTIPLE,
    payload: address
  };
}

function loadedAddresses(addresses) {
  return {
    type: MULTI_ADDRESS_LOADED,
    payload: addresses
  };
}

function updateAddress(newAddressId) {
  return function (dispatch) {
    dispatch((0, _actions.isLoading)(true));
    _axios2['default'].put(_constants.API_ADDRESS_UPDATE_URL, { id: newAddressId }).then(function (response) {
      if (response.data.success) {
        dispatch(updateAddressSuccess(response.data.address, response.data.next));
        (0, _tracking2['default'])('Success', {
          event_category: _constants2.GA_EVENT_CATEGORY,
          event_label: 'Address Updated'
        });
      } else {
        dispatch((0, _actions.setError)(true));
        (0, _tracking2['default'])('Error', {
          event_category: _constants2.GA_EVENT_CATEGORY,
          event_label: 'Network Error'
        });
      }
    })['catch'](function () {
      dispatch((0, _actions.setError)(true));
      (0, _tracking2['default'])('Error', {
        event_category: _constants2.GA_EVENT_CATEGORY,
        event_label: 'Network Error'
      });
    });
  };
}

function loadAddresses() {
  return function (dispatch) {
    dispatch((0, _actions.isLoading)(true));
    _axios2['default'].get(_constants.API_ADDRESS_UPDATE_URL).then(function (response) {
      dispatch(loadedAddresses(response.data.addresses));
      (0, _tracking2['default'])('Success', {
        event_category: _constants2.GA_EVENT_CATEGORY,
        event_label: 'Addresses Loaded',
        non_interaction: true
      });
    })['catch'](function () {
      dispatch((0, _actions.setError)(true));
      (0, _tracking2['default'])('Error', {
        event_category: _constants2.GA_EVENT_CATEGORY,
        event_label: 'Network Error',
        non_interaction: true
      });
    });
  };
}

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fieldValues, _fieldErrors;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Address = __webpack_require__(585);

var _Address2 = _interopRequireDefault(_Address);

var _constants = __webpack_require__(124);

var _AutocompleteAddress = __webpack_require__(591);

var _AutocompleteAddress2 = _interopRequireDefault(_AutocompleteAddress);

var _actions = __webpack_require__(258);

var _constants2 = __webpack_require__(96);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddressForm = function (_Component) {
  _inherits(AddressForm, _Component);

  function AddressForm(props) {
    _classCallCheck(this, AddressForm);

    var _this = _possibleConstructorReturn(this, (AddressForm.__proto__ || Object.getPrototypeOf(AddressForm)).call(this, props));

    _this.focus = function () {
      _this.focusRef.current.focus();
    };

    _this.search = function (address) {
      return _this.focusRef.current.handleSearchDebounced(address);
    };

    _this.focusRef = _react2['default'].createRef();
    return _this;
  }

  _createClass(AddressForm, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            manual = _props.manual,
            loading = _props.loading,
            fieldValues = _props.fieldValues,
            fieldErrors = _props.fieldErrors,
            onAddressSelected = _props.onAddressSelected,
            onFieldUpdated = _props.onFieldUpdated,
            onManualEntry = _props.onManualEntry,
            gaCategory = _props.gaCategory;


        var autoCompleteValue = fieldValues[_constants2.ADDRESS_TEXT_KEY];
        var autoCompleteError = fieldErrors[_constants2.ADDRESS_TEXT_KEY];

        return _jsx(_react.Fragment, {}, void 0, manual ? _react2['default'].createElement(_Address2['default'], {
          ref: this.focusRef,
          fieldValues: fieldValues,
          fieldErrors: fieldErrors,
          loading: loading,
          onFieldUpdated: onFieldUpdated
        }) : _react2['default'].createElement(_AutocompleteAddress2['default'], {
          ref: this.focusRef,
          value: autoCompleteValue,
          loading: loading,
          errorMessage: autoCompleteError,
          onManualEntry: onManualEntry,
          onSelect: onAddressSelected,
          searchForAddress: _actions.searchForAddress,
          gaCategory: gaCategory
        }));
      }

      return render;
    }()
  }]);

  return AddressForm;
}(_react.Component);

AddressForm.defaultProps = {
  manual: false,
  loading: false,
  onFieldUpdated: function () {
    function onFieldUpdated(f) {
      return f;
    }

    return onFieldUpdated;
  }(),
  onAddressSelected: function () {
    function onAddressSelected(f) {
      return f;
    }

    return onAddressSelected;
  }(),
  onManualEntry: function () {
    function onManualEntry(f) {
      return f;
    }

    return onManualEntry;
  }(),
  gaCategory: '',
  fieldValues: (_fieldValues = {}, _defineProperty(_fieldValues, _constants.UNIT_NUMBER_KEY, ''), _defineProperty(_fieldValues, _constants.UNIT_TYPE_KEY, ''), _defineProperty(_fieldValues, _constants.STREET_NUMBER_KEY, ''), _defineProperty(_fieldValues, _constants.STREET_NAME_KEY, ''), _defineProperty(_fieldValues, _constants.STREET_TYPE_KEY, ''), _defineProperty(_fieldValues, _constants.SUBURB_KEY, ''), _defineProperty(_fieldValues, _constants.STATE_KEY, ''), _defineProperty(_fieldValues, _constants.POSTCODE_KEY, ''), _defineProperty(_fieldValues, _constants2.ADDRESS_ID_KEY, ''), _defineProperty(_fieldValues, _constants2.ADDRESS_TEXT_KEY, ''), _fieldValues),
  fieldErrors: (_fieldErrors = {}, _defineProperty(_fieldErrors, _constants.UNIT_NUMBER_KEY, ''), _defineProperty(_fieldErrors, _constants.UNIT_TYPE_KEY, ''), _defineProperty(_fieldErrors, _constants.STREET_NUMBER_KEY, ''), _defineProperty(_fieldErrors, _constants.STREET_NAME_KEY, ''), _defineProperty(_fieldErrors, _constants.STREET_TYPE_KEY, ''), _defineProperty(_fieldErrors, _constants.SUBURB_KEY, ''), _defineProperty(_fieldErrors, _constants.STATE_KEY, ''), _defineProperty(_fieldErrors, _constants.POSTCODE_KEY, ''), _defineProperty(_fieldErrors, _constants2.ADDRESS_ID_KEY, ''), _defineProperty(_fieldErrors, _constants2.ADDRESS_TEXT_KEY, ''), _fieldErrors)
};
exports['default'] = AddressForm;

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _styles = __webpack_require__(598);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var AutocompleteItem = function () {
  function AutocompleteItem(_ref) {
    var isHighlighted = _ref.isHighlighted,
        className = _ref.className,
        children = _ref.children,
        onMouseEnter = _ref.onMouseEnter,
        onClick = _ref.onClick;
    return _jsx('li', {
      className: _styles2['default'].autocomplete_item + ' ' + (isHighlighted ? _styles2['default'].highlighted : '') + ' ' + className,
      onMouseEnter: onMouseEnter,
      onClick: onClick,
      onKeyPress: function () {
        function onKeyPress() {}

        return onKeyPress;
      }(),
      role: 'presentation'
    }, void 0, children);
  }

  return AutocompleteItem;
}();

AutocompleteItem.defaultProps = {
  isHighlighted: false,
  className: '',
  children: [],
  onMouseEnter: function () {
    function onMouseEnter(f) {
      return f;
    }

    return onMouseEnter;
  }(),
  onClick: function () {
    function onClick(f) {
      return f;
    }

    return onClick;
  }()
};

exports['default'] = AutocompleteItem;

/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.searchForAddress = searchForAddress;
exports.parseAddress = parseAddress;

var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

var _constants = __webpack_require__(67);

var _constants2 = __webpack_require__(96);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function buildSearchResults(results, state) {
  return {
    results: results,
    state: state
  };
}

function handleSearchAPI(searchTerm, cancelToken) {
  var params = {
    params: {
      address: searchTerm
    }
  };
  var options = {
    headers: _extends({}, _constants.CSRF_HEADERS),
    cancelToken: cancelToken
  };

  return _axios2['default'].get(_constants2.API_SEARCH_URL, params, options)['catch'](function () {
    return Promise.reject(_constants2.DEFAULT_ERROR);
  }).then(function (response) {
    if (response.status === 200 && response.data.success) {
      return Promise.resolve(buildSearchResults(response.data.results, response.data.state));
    } else if (response.data.message) {
      return Promise.reject(response.data.message);
    } else if (response.data.errors && response.data.errors.qasearch) {
      return Promise.reject(response.data.errors.qasearch[0]);
    }
    return Promise.reject(_constants2.DEFAULT_ERROR);
  });
}

function searchForAddress(searchTerm, cancelToken) {
  if (searchTerm) {
    return handleSearchAPI(searchTerm, cancelToken);
  }
  return Promise.resolve(buildSearchResults([]));
}

function parseAddress(address) {
  if (address) {
    return address.replace(/Unit ([0-9]{1,3})\s\s/i, 'Unit $1/');
  }
  return address;
}

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _FormFieldLayout = __webpack_require__(43);

var _FormFieldLayout2 = _interopRequireDefault(_FormFieldLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var FullNameField = function () {
  function FullNameField(_ref) {
    var onBlur = _ref.onBlur,
        onChange = _ref.onChange,
        value = _ref.value,
        loading = _ref.loading,
        errorMessage = _ref.errorMessage,
        name = _ref.name,
        label = _ref.label,
        inputRef = _ref.inputRef;

    var hasValueClass = value ? 'has-value' : '';
    var hasError = !!errorMessage;

    var errorObject = { status: hasError, message: errorMessage };
    var fieldElement = _react2['default'].createElement('input', {
      ref: inputRef,
      type: 'text',
      name: name,
      className: 'form-input ' + hasValueClass,
      id: name,
      maxLength: '140',
      value: value,
      onChange: onChange,
      onBlur: onBlur,
      disabled: loading,
      required: true,
      placeholder: label
    });
    return _jsx(_FormFieldLayout2.default, {
      fieldName: name,
      labelText: label,
      fieldElement: fieldElement,
      error: errorObject
    });
  }

  return FullNameField;
}();

FullNameField.defaultProps = {
  value: '',
  loading: false,
  onBlur: function () {
    function onBlur(f) {
      return f;
    }

    return onBlur;
  }(),
  onChange: function () {
    function onChange(f) {
      return f;
    }

    return onChange;
  }(),
  errorMessage: '',
  name: 'name',
  label: 'Full name',
  inputRef: function () {
    function inputRef(f) {
      return f;
    }

    return inputRef;
  }()
};

exports['default'] = FullNameField;

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GA_EVENT_CATEGORY = exports.GA_EVENT_CATEGORY = 'Multi Address';
var REQUIRED_SELECTION = exports.REQUIRED_SELECTION = 'Please select an address';

exports['default'] = REQUIRED_SELECTION;

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REDIRECT_PAGE = exports.SET_MANUAL_ADDRESS = exports.CLEAR_FIELD_ERROR = exports.SET_FIELD_ERRORS = exports.SET_RESPONSE_MESSAGE = exports.SUBMIT_LEAD = exports.IS_SUCCESS = exports.IS_LOADING = exports.SET_LEAD_DETAILS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.setLeadDetails = setLeadDetails;
exports.isLoading = isLoading;
exports.setResponseMessage = setResponseMessage;
exports.setFieldErrors = setFieldErrors;
exports.clearFieldError = clearFieldError;
exports.setManualAddress = setManualAddress;
exports.submitLead = submitLead;

var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

var _tracking = __webpack_require__(28);

var _tracking2 = _interopRequireDefault(_tracking);

var _constants = __webpack_require__(67);

var _constants2 = __webpack_require__(95);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var SET_LEAD_DETAILS = exports.SET_LEAD_DETAILS = 'SET_LEAD_DETAILS';
var IS_LOADING = exports.IS_LOADING = 'IS_LOADING';
var IS_SUCCESS = exports.IS_SUCCESS = 'IS_SUCCESS';
var SUBMIT_LEAD = exports.SUBMIT_LEAD = 'SUBMIT_LEAD';
var SET_RESPONSE_MESSAGE = exports.SET_RESPONSE_MESSAGE = 'SET_RESPONSE_MESSAGE';
var SET_FIELD_ERRORS = exports.SET_FIELD_ERRORS = 'SET_FIELD_ERRORS';
var CLEAR_FIELD_ERROR = exports.CLEAR_FIELD_ERROR = 'CLEAR_FIELD_ERROR';
var SET_MANUAL_ADDRESS = exports.SET_MANUAL_ADDRESS = 'SET_MANUAL_ADDRESS';
var REDIRECT_PAGE = exports.REDIRECT_PAGE = 'REDIRECT_PAGE';

function setLeadDetails(fields) {
  return { type: SET_LEAD_DETAILS, payload: fields };
}

function isLoading(status) {
  return { type: IS_LOADING, payload: status };
}

function setResponseMessage(status) {
  return { type: SET_RESPONSE_MESSAGE, payload: status };
}

function setFieldErrors(errors) {
  Object.keys(errors).forEach(function (field) {
    (0, _tracking2['default'])('Failed', {
      event_category: _constants2.GA_EVENT_CATEGORY,
      event_label: 'Invalid',
      field_name: field,
      error_message: errors[field],
      non_interaction: true
    });
  });
  return { type: SET_FIELD_ERRORS, payload: errors };
}

function clearFieldError(fieldName) {
  return { type: CLEAR_FIELD_ERROR, payload: fieldName };
}

function isSuccess(status) {
  return { type: IS_SUCCESS, payload: status };
}

function setManualAddress(state) {
  return { type: SET_MANUAL_ADDRESS, payload: state };
}

function redirectPage(targetUrl) {
  return { type: REDIRECT_PAGE, payload: targetUrl };
}

function postToLeadAPI(leadData, manualAddress, successRedirect) {
  return function (dispatch) {
    var options = { headers: _extends({}, _constants.CSRF_HEADERS) };

    var payload = _extends({}, leadData, {
      is_manual_address: manualAddress,
      proceed_to_checkout: !!successRedirect
    });

    _axios2['default'].post(_constants2.API_POST_URL, payload, options).then(function (response) {
      if (response.data.success) {
        (0, _tracking2['default'])('Success', {
          event_category: _constants2.GA_EVENT_CATEGORY,
          event_label: manualAddress ? 'Address (Manual)' : 'Address (Autocomplete)',
          non_interaction: true
        });
        if (successRedirect) {
          dispatch(redirectPage(successRedirect));
        } else {
          dispatch(isSuccess(true));
          dispatch(isLoading(false));
        }
      } else {
        dispatch(setResponseMessage(_constants2.DEFAULT_RESPONSE_ERROR));
        (0, _tracking2['default'])('Failed', {
          event_category: _constants2.GA_EVENT_CATEGORY,
          event_label: 'Rejected',
          non_interaction: true
        });
      }
    })['catch'](function (error) {
      dispatch(isLoading(false));
      dispatch(setResponseMessage(_constants2.DEFAULT_RESPONSE_ERROR));
      if (!error.response) {
        // network error
        (0, _tracking2['default'])('Failed', {
          event_category: _constants2.GA_EVENT_CATEGORY,
          event_label: 'Network Error',
          non_interaction: true
        });
      } else if (error.response.data && error.response.data.errors) {
        // response data
        var response = error.response.data;
        dispatch(setFieldErrors(response.errors));
      } else {
        // Error HTML page from CDN, Heroku or Django
        (0, _tracking2['default'])('Failed', {
          event_category: _constants2.GA_EVENT_CATEGORY,
          event_label: error.response.statusText,
          non_interaction: true
        });
      }
    });
  };
}

function submitLead(leadData, manualAddress, successRedirect) {
  return function (dispatch) {
    dispatch(isLoading(true));
    dispatch(setLeadDetails(leadData));
    dispatch(postToLeadAPI(leadData, manualAddress, successRedirect));
  };
}

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(23);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _stringUtils = __webpack_require__(689);

var _pricing = __webpack_require__(273);

var _OrderSummaryTotal = __webpack_require__(274);

var _OrderSummaryTotal2 = _interopRequireDefault(_OrderSummaryTotal);

var _OrderSummaryItem = __webpack_require__(275);

var _OrderSummaryItem2 = _interopRequireDefault(_OrderSummaryItem);

var _OrderSummaryItemLarge = __webpack_require__(276);

var _OrderSummaryItemLarge2 = _interopRequireDefault(_OrderSummaryItemLarge);

var _utils = __webpack_require__(168);

var _constants = __webpack_require__(693);

var _styles = __webpack_require__(694);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx('i', {
  className: 'kgnIcon kgn-icon-checkmark'
});

var OrderSummaryPaymentScreen = function (_PureComponent) {
  _inherits(OrderSummaryPaymentScreen, _PureComponent);

  function OrderSummaryPaymentScreen() {
    _classCallCheck(this, OrderSummaryPaymentScreen);

    return _possibleConstructorReturn(this, (OrderSummaryPaymentScreen.__proto__ || Object.getPrototypeOf(OrderSummaryPaymentScreen)).apply(this, arguments));
  }

  _createClass(OrderSummaryPaymentScreen, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            installAddress = _props.installAddress,
            planSelected = _props.planSelected,
            deliveryAddress = _props.deliveryAddress,
            detailsProvided = _props.detailsProvided,
            stageSettings = _props.stageSettings,
            summarySettings = _props.summarySettings,
            ownsService = _props.ownsService,
            modemRequired = _props.modemRequired,
            email = _props.email,
            totalUpfront = _props.totalUpfront;
        var costHeading = summarySettings.costHeading,
            costText = summarySettings.costText,
            planInfoText = summarySettings.planInfoText,
            modemInfoText = summarySettings.modemInfoText;


        var planRate = (0, _pricing.decimalDisplay)(planSelected.rate);
        var totalDisplay = (0, _pricing.decimalDisplay)(totalUpfront);

        var installAddressStreet = installAddress.length >= 1 ? installAddress[0] + ',' : null;
        var installAddressCity = installAddress.length >= 2 ? installAddress[1] : null;

        var firstName = '' + (0, _stringUtils.capitalizeFirstLetter)(this.props.detailsProvided.first_name);
        var middleName = ' ' + (0, _stringUtils.capitalizeFirstLetter)(this.props.detailsProvided.middle_name);
        var lastName = ' ' + (0, _stringUtils.capitalizeFirstLetter)(this.props.detailsProvided.last_name);

        var ownServiceIcon = ownsService ? _ref : null;
        var ownServiceText = ownsService ? _constants.OWNER_OF_SERVICE : _constants.NOT_OWNER_OF_SERVICE;
        var ownServiceClass = ownsService ? _styles2['default'].ownsService : '';
        var deliveryAddressSplit = deliveryAddress.split(',');

        var disclaimers = planSelected.orderSummaryDisclaimer ? _jsx('div', {
          dangerouslySetInnerHTML: { __html: planSelected.orderSummaryDisclaimer }
        }) : null;

        return _jsx('div', {
          className: _styles2['default'].orderSummaryPayment
        }, void 0, _jsx(_OrderSummaryTotal2.default, {
          title: costHeading,
          headingClass: _styles2['default'].heading,
          primaryInfo: costText,
          planRate: planRate,
          planUpfront: totalDisplay,
          planInterval: planSelected.interval,
          extraClass: _styles2['default'].orderTotal
        }, void 0, _jsx(_OrderSummaryItemLarge2.default, {
          icon: 'plan',
          iconColor: planSelected.planColor,
          title: planSelected.title,
          subtitle: planSelected.marketingTagline,
          primaryInfo: '$' + planRate,
          secondaryInfo: planInfoText,
          extraClass: _styles2['default'].summaryItemLarge
        }, void 0, disclaimers), modemRequired ? _jsx(_OrderSummaryItemLarge2.default, {
          secondaryInfo: modemInfoText,
          extraClass: _styles2['default'].summaryItemLarge
        }) : null), _jsx(_OrderSummaryItem2.default, {
          icon: 'house',
          title: stageSettings.landline_check,
          primaryInfo: installAddressStreet,
          secondaryInfo: installAddressCity,
          extraClass: _styles2['default'].summaryItem
        }, void 0, ownsService !== null && _jsx('div', {
          className: _styles2['default'].ownServiceBase + ' ' + ownServiceClass
        }, void 0, ownServiceIcon, ownServiceText)), modemRequired && _jsx(_OrderSummaryItem2.default, {
          icon: 'truck',
          title: stageSettings.modem_delivery,
          primaryInfo: deliveryAddressSplit[0],
          secondaryInfo: deliveryAddressSplit[1],
          extraClass: _styles2['default'].summaryItem
        }), _jsx(_OrderSummaryItem2.default, {
          icon: 'person',
          title: stageSettings.personal,
          primaryInfo: '' + firstName + middleName + lastName,
          extraClass: _styles2['default'].summaryItem
        }, void 0, _jsx('div', {
          className: _styles2['default'].expandedDisplay
        }, void 0, _jsx('div', {
          className: _styles2['default'].extraInfo
        }, void 0, email), _jsx('div', {
          className: _styles2['default'].extraInfo
        }, void 0, detailsProvided.phone))), _jsx(_OrderSummaryItem2.default, {
          icon: 'identification',
          title: 'Identification',
          primaryInfo: 'Identity Verified',
          extraClass: _styles2['default'].summaryItem
        }));
      }

      return render;
    }()
  }]);

  return OrderSummaryPaymentScreen;
}(_react.PureComponent);

OrderSummaryPaymentScreen.defaultProps = {
  installAddress: [],
  planSelected: {},
  deliveryAddress: {},
  detailsProvided: {},
  stageSettings: {},
  summarySettings: {},
  ownsService: false,
  email: '',
  modemRequired: false,
  totalUpfront: null
};


function mapStateToProps(state) {
  // whatever is returned will show up as props
  return {
    installAddress: state.checkoutReducer.installAddress,
    deliveryAddress: state.checkoutReducer.modemDeliveryAddress,
    detailsProvided: state.checkoutReducer.personalFieldValues,
    planSelected: state.checkoutReducer.planSelected,
    email: state.checkoutReducer.email,
    modemRequired: state.checkoutReducer.modemRequired,
    ownsService: state.checkoutReducer.ownsService,
    totalUpfront: (0, _utils.calculateUpfront)(state)
  };
}

exports['default'] = (0, _reactRedux.connect)(mapStateToProps)(OrderSummaryPaymentScreen);

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decimalDisplay = decimalDisplay;
var DECIMAL_DISPLAY = 2;
var BASE = 10;

function decimalDisplay(price) {
  if (price) {
    var floatPrice = parseFloat(price);
    return parseInt(price, BASE) === price ? floatPrice.toString() : floatPrice.toFixed(DECIMAL_DISPLAY);
  }
  return '0.00';
}

exports['default'] = decimalDisplay;

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = __webpack_require__(690);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrderSummaryTotal = function (_PureComponent) {
  _inherits(OrderSummaryTotal, _PureComponent);

  function OrderSummaryTotal() {
    _classCallCheck(this, OrderSummaryTotal);

    return _possibleConstructorReturn(this, (OrderSummaryTotal.__proto__ || Object.getPrototypeOf(OrderSummaryTotal)).apply(this, arguments));
  }

  _createClass(OrderSummaryTotal, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            title = _props.title,
            primaryInfo = _props.primaryInfo,
            headingClass = _props.headingClass,
            extraClass = _props.extraClass,
            planRate = _props.planRate,
            planInterval = _props.planInterval,
            planUpfront = _props.planUpfront;


        var primaryInfoVar = primaryInfo;
        var placeHolders = [{
          tag: '[PLAN_RATE]',
          value: '$' + planRate
        }, {
          tag: '[PLAN_INTERVAL]',
          value: planInterval
        }, {
          tag: '[UPFRONT_COST]',
          value: '$' + planUpfront
        }];
        placeHolders.forEach(function (placeHolder) {
          primaryInfoVar = primaryInfoVar.replace(placeHolder.tag, placeHolder.value);
        });

        if (title === null || primaryInfo === null) {
          return null;
        }
        return _jsx('div', {
          className: extraClass
        }, void 0, _jsx('div', {
          className: _styles2['default'].wrapper
        }, void 0, _jsx('div', {
          className: headingClass
        }, void 0, title), _jsx('div', {
          className: _styles2['default'].primaryInfo,
          dangerouslySetInnerHTML: { __html: primaryInfoVar }
        }), this.props.children));
      }

      return render;
    }()
  }]);

  return OrderSummaryTotal;
}(_react.PureComponent);

OrderSummaryTotal.defaultProps = {
  headingClass: null,
  extraClass: null,
  planRate: '0.00',
  planUpfront: '0.00',
  planInterval: '0.00',
  title: null,
  primaryInfo: '',
  children: null
};
exports['default'] = OrderSummaryTotal;

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = __webpack_require__(691);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrderSummaryItem = function (_PureComponent) {
  _inherits(OrderSummaryItem, _PureComponent);

  function OrderSummaryItem() {
    _classCallCheck(this, OrderSummaryItem);

    return _possibleConstructorReturn(this, (OrderSummaryItem.__proto__ || Object.getPrototypeOf(OrderSummaryItem)).apply(this, arguments));
  }

  _createClass(OrderSummaryItem, [{
    key: 'render',
    value: function () {
      function render() {
        var iconTypes = {
          plan: 'kgn-icon-dashboard',
          truck: 'kgn-icon-truck',
          house: 'kgn-icon-house-wireless',
          person: 'kgn-icon-user',
          identification: 'kgn-icon-drivers-license-o',
          none: ''
        };

        var _props = this.props,
            icon = _props.icon,
            title = _props.title,
            primaryInfo = _props.primaryInfo,
            secondaryInfo = _props.secondaryInfo,
            stageEditable = _props.stageEditable,
            onClick = _props.onClick,
            children = _props.children,
            extraClass = _props.extraClass;


        if (title === null || !primaryInfo) {
          // secondary info is allowed to be null
          return null;
        }
        var iconClass = iconTypes[icon];

        return _jsx('div', {
          className: extraClass + ' ' + _styles2['default'].wrapper
        }, void 0, _jsx('i', {
          className: iconClass + ' ' + _styles2['default'].icon
        }), _jsx('div', {
          className: _styles2['default'].itemContainer
        }, void 0, _jsx('h2', {
          className: _styles2['default'].heading
        }, void 0, title), primaryInfo && _jsx('div', {
          className: _styles2['default'].itemInfoMain
        }, void 0, primaryInfo), _jsx('div', {
          className: 'secondaryInfo ' + _styles2['default'].itemInfoSecondary,
          dangerouslySetInnerHTML: { __html: secondaryInfo }
        }), children, onClick && stageEditable && _jsx('button', {
          className: _styles2['default'].editButton,
          onClick: onClick
        }, void 0, 'Edit')));
      }

      return render;
    }()
  }]);

  return OrderSummaryItem;
}(_react.PureComponent);

OrderSummaryItem.defaultProps = {
  icon: '',
  title: null,
  primaryInfo: null,
  secondaryInfo: null,
  stageEditable: false,
  onClick: null,
  children: null,
  extraClass: ''
};
exports['default'] = OrderSummaryItem;

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = __webpack_require__(692);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TEMP_IMAGE = 'https://kwalify-media.s3.amazonaws.com/media/uploads/modem/KMVR500vAU-F_nmqvrp';

var OrderSummaryItemLarge = function (_PureComponent) {
  _inherits(OrderSummaryItemLarge, _PureComponent);

  function OrderSummaryItemLarge() {
    _classCallCheck(this, OrderSummaryItemLarge);

    return _possibleConstructorReturn(this, (OrderSummaryItemLarge.__proto__ || Object.getPrototypeOf(OrderSummaryItemLarge)).apply(this, arguments));
  }

  _createClass(OrderSummaryItemLarge, [{
    key: 'render',
    value: function () {
      function render() {
        var iconTypes = {
          plan: 'kgn-icon-dashboard',
          truck: 'kgn-icon-truck',
          house: 'kgn-icon-house-wireless',
          person: 'kgn-icon-user',
          identification: 'kgn-icon-drivers-license-o',
          none: ''
        };

        var _props = this.props,
            icon = _props.icon,
            iconColor = _props.iconColor,
            image = _props.image,
            title = _props.title,
            subtitle = _props.subtitle,
            primaryInfo = _props.primaryInfo,
            secondaryInfo = _props.secondaryInfo,
            children = _props.children,
            extraClass = _props.extraClass;


        if (title === null || !primaryInfo) {
          // secondary info is allowed to be null
          return null;
        }
        var iconClass = iconTypes[icon];
        var iconColorStyle = {
          color: iconColor
        };

        return _jsx('div', {
          className: extraClass
        }, void 0, icon ? _jsx('i', {
          className: iconClass + ' ' + _styles2['default'].icon,
          style: iconColorStyle
        }) : _jsx('img', {
          className: _styles2['default'].image,
          src: image,
          alt: title
        }), _jsx('div', {
          className: _styles2['default'].itemContainer
        }, void 0, _jsx('div', {
          className: _styles2['default'].heading
        }, void 0, _jsx('h2', {}, void 0, title), subtitle && _jsx('div', {
          className: _styles2['default'].itemInfoSecondary,
          dangerouslySetInnerHTML: { __html: subtitle }
        })), primaryInfo && _jsx('div', {
          className: _styles2['default'].itemInfoMain
        }, void 0, primaryInfo), _jsx('div', {
          className: 'secondaryInfo ' + _styles2['default'].itemInfoSecondary
        }, void 0, secondaryInfo), _jsx('div', {
          className: _styles2['default'].children
        }, void 0, children)));
      }

      return render;
    }()
  }]);

  return OrderSummaryItemLarge;
}(_react.PureComponent);

OrderSummaryItemLarge.defaultProps = {
  icon: '',
  iconColor: '$primary_color',
  image: TEMP_IMAGE,
  title: null,
  subtitle: null,
  primaryInfo: null,
  secondaryInfo: null,
  children: null,
  extraClass: ''
};
exports['default'] = OrderSummaryItemLarge;

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint max-len: ["error", { "ignoreStrings": true }] */

var API_IDENTIFICATION_URL = exports.API_IDENTIFICATION_URL = '/api/signup/identification/';
var DEFAULT_RESPONSE_ERROR = exports.DEFAULT_RESPONSE_ERROR = 'Sorry, there was an error processing your request. Please try again';

var GA_EVENT_CATEGORY = exports.GA_EVENT_CATEGORY = 'Identification';
var TEXT_INTERNATIONAL_VISA = exports.TEXT_INTERNATIONAL_VISA = 'International passport';

var TEXT_INTERNATIONAL_VISA_VERIFIED = exports.TEXT_INTERNATIONAL_VISA_VERIFIED = 'Your passport details were <strong>verified</strong>.';
var TEXT_INTERNATIONAL_VISA_PENDING = exports.TEXT_INTERNATIONAL_VISA_PENDING = 'Your passport details were verified, <strong>pending the review of an administrator</strong>.';
var TEXT_INTERNATIONAL_VISA_NO_MATCH = exports.TEXT_INTERNATIONAL_VISA_NO_MATCH = '<p>Your passport details <strong>did not match</strong>. Please check that the details you\'ve entered below match those found on your non-Australian passport and ensure you have an active Australian visa.</p><p>If your name on your passport is different to your name on your visa grant notice or visa label, you must use the name shown on your visa grant notice or visa label.</p>';
var TEXT_INTERNATIONAL_VISA_LOCKED = exports.TEXT_INTERNATIONAL_VISA_LOCKED = 'You\'ve been <strong>locked out</strong> of the passport source because you\'ve tried it too many times without success.';
var TEXT_INTERNATIONAL_VISA_FAILED = exports.TEXT_INTERNATIONAL_VISA_FAILED = 'Unfortunately your passport details <strong>cannot contribute towards your verification</strong> because they differ too much from those details you initially provided us.';
var TEXT_INTERNATIONAL_VISA_CONTRIB = exports.TEXT_INTERNATIONAL_VISA_CONTRIB = 'Unfortunately your passport details <strong>cannot contribute towards your verification</strong> because they differ too much from those details you initially provided us.';
var TEXT_INTERNATIONAL_VISA_NO_EFFECT = exports.TEXT_INTERNATIONAL_VISA_NO_EFFECT = 'Your passport details <strong>can\'t contribute to your verification</strong>. The visa may no longer be in effect.';

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _FormFieldLayout = __webpack_require__(43);

var _FormFieldLayout2 = _interopRequireDefault(_FormFieldLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PhoneNumberField = function () {
  function PhoneNumberField(_ref) {
    var onBlur = _ref.onBlur,
        onFocus = _ref.onFocus,
        onChange = _ref.onChange,
        value = _ref.value,
        loading = _ref.loading,
        errorMessage = _ref.errorMessage,
        fieldName = _ref.fieldName,
        labelText = _ref.labelText,
        isRequired = _ref.isRequired;

    var hasError = !!errorMessage;
    var errorObject = {
      status: hasError,
      message: errorMessage
    };
    var fieldElement = _jsx('input', {
      type: 'tel',
      name: fieldName,
      className: 'form-input',
      id: fieldName,
      maxLength: '140',
      value: value,
      onChange: onChange,
      onBlur: onBlur,
      onFocus: onFocus,
      disabled: loading,
      required: isRequired
    });
    return _jsx(_FormFieldLayout2.default, {
      fieldName: fieldName,
      labelText: labelText,
      fieldElement: fieldElement,
      error: errorObject
    });
  }

  return PhoneNumberField;
}();

PhoneNumberField.defaultProps = {
  value: '',
  fieldName: 'phoneNumberField',
  labelText: 'Phone Number Field',
  loading: false,
  onFocus: undefined,
  onBlur: function () {
    function onBlur(f) {
      return f;
    }

    return onBlur;
  }(),
  onChange: function () {
    function onChange(f) {
      return f;
    }

    return onChange;
  }(),
  errorMessage: '',
  isRequired: false
};

exports['default'] = PhoneNumberField;

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }(); /* eslint-disable react/no-danger */


var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(37);

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = __webpack_require__(707);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ChoiceField = function () {
  function ChoiceField(_ref) {
    var onChange = _ref.onChange,
        options = _ref.options,
        value = _ref.value,
        loading = _ref.loading,
        errorMessage = _ref.errorMessage,
        name = _ref.name,
        required = _ref.required;

    var hasError = !!errorMessage;

    return _jsx('div', {
      className: (0, _classnames2['default'])(_styles2['default'].wrapper, _defineProperty({}, _styles2['default'].error, hasError))
    }, void 0, options.map(function (option) {
      return _jsx('div', {
        className: _styles2['default'].option
      }, option.value, _jsx('input', {
        id: name + '-' + option.value,
        value: option.value,
        name: name,
        onChange: onChange,
        type: 'radio',
        checked: option.value === value,
        required: required,
        disabled: loading
      }, option.value), _jsx('label', {
        htmlFor: name + '-' + option.value
      }, void 0, _jsx('span', {
        className: _styles2['default'].icon
      }), _jsx('div', {
        className: _styles2['default'].labelText
      }, void 0, option.label), option.extra));
    }), hasError && _jsx('span', {
      className: _styles2['default'].errorText
    }, void 0, errorMessage));
  }

  return ChoiceField;
}();

ChoiceField.defaultProps = {
  value: '',
  loading: false,
  onChange: function () {
    function onChange(f) {
      return f;
    }

    return onChange;
  }(),
  errorMessage: '',
  required: false,
  options: []
};

exports['default'] = ChoiceField;

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = gaEvent;
exports.gaPageView = gaPageView;
// https://developers.google.com/analytics/devguides/collection/gtagjs/events
function gaEvent(eventName, parameters) {
  if (window.gtag) {
    window.gtag('event', eventName, parameters);
  } else {
    // eslint-disable-next-line no-console
    console.log('GA Event', 'category:', parameters.event_category, 'event:', eventName, 'label:', parameters.event_label || parameters.name, 'value:', parameters.value, parameters);
  }
}

function gaPageView(title, path) {
  if (window.gtag && window.ga_id) {
    window.gtag('config', window.ga_id, {
      page_title: title || document.title,
      page_path: path || window.location.pathname
    });
  } else {
    // eslint-disable-next-line no-console
    console.log('GA PageView', 'title:', title || document.title, 'path:', path || window.location.pathname);
  }
}

var submitEventWhitelist = ['checkout_progress', 'begin_checkout', 'Submit Manual Address', 'Submit Autocomplete Address'];

var checkSubmitted = function () {
  function checkSubmitted() {
    if (!window.dataLayer) return false;

    var i = window.dataLayer.length - 1;
    while (i > -1) {
      if (window.dataLayer[i][0] === 'event' && submitEventWhitelist.indexOf(window.dataLayer[i][0]) > -1) {
        return true;
      }
      i -= 1;
    }
    return false;
  }

  return checkSubmitted;
}();

var fieldTouchHistory = exports.fieldTouchHistory = [];
var trackingInitialised = false;
var trackAbandonments = exports.trackAbandonments = function () {
  function trackAbandonments() {
    // Abort if we have already initialised
    if (trackingInitialised) return;

    trackingInitialised = true;
    window.addEventListener('beforeunload', function () {
      var hasInteractedWithFields = fieldTouchHistory.length > 0;
      if (hasInteractedWithFields && !checkSubmitted()) {
        gaEvent(fieldTouchHistory.join(' > '), {
          event_category: 'Form Abandonment',
          value: fieldTouchHistory.length,
          non_interaction: true
        });
      }
    });
  }

  return trackAbandonments;
}();

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MODEM_DISCLAIMER = exports.MODEM_DISCLAIMER = 'You’ll need to make sure your modem works with the nbn service, and you’ll need to know the basics on troubleshooting the device. For anything else, you’d need to check with the manufacturer directly.';
var SAME_AS_INSTALL_ADDRESS = exports.SAME_AS_INSTALL_ADDRESS = 'same_as_install_address';
var REQUIRES_MODEM = exports.REQUIRES_MODEM = 'requires_modem';
var ATTENTION_TO_KEY = exports.ATTENTION_TO_KEY = 'name';
var DEFAULT_RESPONSE_ERROR = exports.DEFAULT_RESPONSE_ERROR = 'We encountered an issue while trying to save your details, please try again';
var GA_CATEGORY = exports.GA_CATEGORY = 'Modem';

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _previouslySetDetails;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(23);

var _redux = __webpack_require__(27);

var _QantasFrequentFlyerDetailed = __webpack_require__(710);

var _QantasFrequentFlyerDetailed2 = _interopRequireDefault(_QantasFrequentFlyerDetailed);

var _QantasFrequentFlyerSimple = __webpack_require__(713);

var _QantasFrequentFlyerSimple2 = _interopRequireDefault(_QantasFrequentFlyerSimple);

var _formValidator = __webpack_require__(61);

var _actions = __webpack_require__(282);

var _constants = __webpack_require__(97);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QantasFrequentFlyerContainer = function (_Component) {
  _inherits(QantasFrequentFlyerContainer, _Component);

  function QantasFrequentFlyerContainer(props) {
    var _fieldValues;

    _classCallCheck(this, QantasFrequentFlyerContainer);

    // We handle state here locally as storing these in Redux for onChange events is very expensive!
    var _this = _possibleConstructorReturn(this, (QantasFrequentFlyerContainer.__proto__ || Object.getPrototypeOf(QantasFrequentFlyerContainer)).call(this, props));

    _this.onFieldChange = function (value, fieldname) {
      _this.setState({
        fieldValues: _extends({}, _this.state.fieldValues, _defineProperty({}, fieldname, value))
      });
    };

    _this.onFieldChangeHandler = function (event) {
      return _this.onFieldChange(event.target.value, event.target.name);
    };

    _this.onSelectChangeHandler = function (event) {
      _this.onFieldChange(event.target.value, event.target.name);
      _this.props.setQffDetails(_defineProperty({}, event.target.name, event.target.value));
    };

    _this.onFieldBlur = function (event) {
      if (_this.props.fieldValues[event.target.name] !== _this.state.fieldValues[event.target.name]) {
        _this.props.setQffDetails(_defineProperty({}, event.target.name, event.target.value));
      }
    };

    _this.onQffSubmit = function (event) {
      event.preventDefault();
      _this.props.setResponseMessage('');

      var valid = (0, _formValidator.validateQffForm)(_this.state.fieldValues);

      if (valid === true) {
        /* Clear any form errors */
        _this.props.setFieldErrors({});
        _this.props.submitQff(_this.state.fieldValues, _this.props.nextPage);
      } else {
        _this.props.setFieldErrors(valid);
      }
    };

    _this.state = {
      fieldValues: (_fieldValues = {}, _defineProperty(_fieldValues, _constants.QFF_FIRST_NAME_KEY, props.previouslySetDetails[_constants.QFF_FIRST_NAME_KEY] || ''), _defineProperty(_fieldValues, _constants.QFF_LAST_NAME_KEY, props.previouslySetDetails[_constants.QFF_LAST_NAME_KEY] || ''), _defineProperty(_fieldValues, _constants.QFF_EMAIL_KEY, props.previouslySetDetails[_constants.QFF_EMAIL_KEY] || ''), _defineProperty(_fieldValues, _constants.QFF_REFERENCE_KEY, props.previouslySetDetails[_constants.QFF_REFERENCE_KEY] || ''), _defineProperty(_fieldValues, _constants.QFF_NUMBER_KEY, ''), _fieldValues)
    };
    return _this;
  }

  /* Full Name Handlers */


  /* Handle Submission */


  _createClass(QantasFrequentFlyerContainer, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            qffReducer = _props.qffReducer,
            qffText = _props.qffText,
            fieldError = _props.fieldError,
            firstNameLabel = _props.firstNameLabel,
            lastNameLabel = _props.lastNameLabel,
            emailLabel = _props.emailLabel,
            referenceLabel = _props.referenceLabel,
            qffLabel = _props.qffLabel,
            submitLabel = _props.submitLabel,
            termsText = _props.termsText,
            successText = _props.successText,
            isSimplePage = _props.isSimplePage;
        var isLoading = qffReducer.isLoading,
            success = qffReducer.success,
            message = qffReducer.message;


        if (isSimplePage) {
          return _jsx(_QantasFrequentFlyerSimple2.default, {
            qffReducer: qffReducer,
            fieldError: fieldError,
            onSubmit: this.onQffSubmit,
            onFieldChangeHandler: this.onFieldChangeHandler,
            onFieldBlur: this.onFieldBlur,
            clearEmailErrors: this.clearEmailErrors,
            fieldValues: this.state.fieldValues,
            isLoading: isLoading,
            isFormComplete: success,
            successText: successText,
            message: message,
            qffText: qffText
          });
        }
        return _jsx(_QantasFrequentFlyerDetailed2.default, {
          qffReducer: qffReducer,
          fieldError: fieldError,
          onSubmit: this.onQffSubmit,
          onFieldChangeHandler: this.onFieldChangeHandler,
          onFieldBlur: this.onFieldBlur,
          clearEmailErrors: this.clearEmailErrors,
          fieldValues: this.state.fieldValues,
          firstNameLabel: firstNameLabel,
          lastNameLabel: lastNameLabel,
          emailLabel: emailLabel,
          referenceLabel: referenceLabel,
          qffLabel: qffLabel,
          submitLabel: submitLabel,
          isLoading: isLoading,
          isFormComplete: success,
          termsText: termsText,
          successText: successText,
          message: message
        });
      }

      return render;
    }()
  }]);

  return QantasFrequentFlyerContainer;
}(_react.Component);

QantasFrequentFlyerContainer.defaultProps = {
  qffReducer: {
    isLoading: false,
    success: false,
    message: ''
  },
  fieldValues: {},
  fieldError: {},
  firstNameLabel: 'Your First Name',
  lastNameLabel: 'Your Last Name',
  emailLabel: 'Your Email',
  referenceLabel: 'Your Kogan Internet Customer Reference',
  qffLabel: 'Your Qantas Frequent Flyer Number (only the digits)',
  previouslySetDetails: (_previouslySetDetails = {}, _defineProperty(_previouslySetDetails, _constants.QFF_FIRST_NAME_KEY, ''), _defineProperty(_previouslySetDetails, _constants.QFF_LAST_NAME_KEY, ''), _defineProperty(_previouslySetDetails, _constants.QFF_EMAIL_KEY, ''), _defineProperty(_previouslySetDetails, _constants.QFF_REFERENCE_KEY, ''), _previouslySetDetails),
  submitLabel: 'Register Details',
  termsText: null,
  successText: null,
  nextPage: null,
  isSimplePage: false,
  qffText: '',

  setResponseMessage: function () {
    function setResponseMessage(f) {
      return f;
    }

    return setResponseMessage;
  }(),
  submitQff: function () {
    function submitQff(f) {
      return f;
    }

    return submitQff;
  }(),
  setFieldErrors: function () {
    function setFieldErrors(f) {
      return f;
    }

    return setFieldErrors;
  }(),
  setQffDetails: function () {
    function setQffDetails(f) {
      return f;
    }

    return setQffDetails;
  }()
};

function mapStateToProps(state) {
  var _previouslySetDetails2;

  // whatever is returned will show up as props
  return {
    qffReducer: state.qffReducer,
    fieldValues: state.qffReducer.fieldValues,
    fieldError: state.qffReducer.fieldError,
    previouslySetDetails: (_previouslySetDetails2 = {}, _defineProperty(_previouslySetDetails2, _constants.QFF_FIRST_NAME_KEY, state.checkoutReducer.personalFieldValues.first_name), _defineProperty(_previouslySetDetails2, _constants.QFF_LAST_NAME_KEY, state.checkoutReducer.personalFieldValues.last_name), _defineProperty(_previouslySetDetails2, _constants.QFF_EMAIL_KEY, state.checkoutReducer.email), _defineProperty(_previouslySetDetails2, _constants.QFF_REFERENCE_KEY, state.checkoutReducer.reference), _previouslySetDetails2)
  };
}

// Anything returned from this function will end up as props
function mapDispatchToProps(dispatch) {
  // Whenever dispatch is called the result should be passed
  // to all of the reducers
  return (0, _redux.bindActionCreators)({
    setQffDetails: _actions.setQffDetails,
    setResponseMessage: _actions.setResponseMessage,
    submitQff: _actions.submitQff,
    setFieldErrors: _actions.setFieldErrors
  }, dispatch);
}

exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(QantasFrequentFlyerContainer);

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GA_CATEGORY_NAME = exports.REDIRECT_PAGE = exports.CLEAR_FIELD_ERROR = exports.SET_FIELD_ERRORS = exports.SET_RESPONSE_MESSAGE = exports.SUBMIT_QFF = exports.IS_SUCCESS = exports.IS_LOADING = exports.SET_QFF_DETAILS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.setQffDetails = setQffDetails;
exports.isLoading = isLoading;
exports.setResponseMessage = setResponseMessage;
exports.setFieldErrors = setFieldErrors;
exports.clearFieldError = clearFieldError;
exports.isSuccess = isSuccess;
exports.redirectPage = redirectPage;
exports.submitQff = submitQff;

var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

var _tracking = __webpack_require__(28);

var _tracking2 = _interopRequireDefault(_tracking);

var _constants = __webpack_require__(67);

var _constants2 = __webpack_require__(97);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var createAction = function () {
  function createAction(action) {
    return 'qff/' + action;
  }

  return createAction;
}();

var SET_QFF_DETAILS = exports.SET_QFF_DETAILS = createAction('SET_QFF_DETAILS');
var IS_LOADING = exports.IS_LOADING = createAction('IS_LOADING');
var IS_SUCCESS = exports.IS_SUCCESS = createAction('IS_SUCCESS');
var SUBMIT_QFF = exports.SUBMIT_QFF = createAction('SUBMIT_QFF');
var SET_RESPONSE_MESSAGE = exports.SET_RESPONSE_MESSAGE = createAction('SET_RESPONSE_MESSAGE');
var SET_FIELD_ERRORS = exports.SET_FIELD_ERRORS = createAction('SET_FIELD_ERRORS');
var CLEAR_FIELD_ERROR = exports.CLEAR_FIELD_ERROR = createAction('CLEAR_FIELD_ERROR');
var REDIRECT_PAGE = exports.REDIRECT_PAGE = createAction('REDIRECT_PAGE');
var GA_CATEGORY_NAME = exports.GA_CATEGORY_NAME = createAction('QFF Form Submit');

function setQffDetails(fields) {
  return {
    type: SET_QFF_DETAILS,
    payload: fields
  };
}

function isLoading(status) {
  return {
    type: IS_LOADING,
    payload: status
  };
}

function setResponseMessage(status) {
  return {
    type: SET_RESPONSE_MESSAGE,
    payload: status
  };
}

function setFieldErrors(errors) {
  Object.keys(errors).forEach(function (field) {
    (0, _tracking2['default'])('Failed', {
      event_category: GA_CATEGORY_NAME,
      event_label: 'Invalid',
      field_name: field,
      error_message: errors[field],
      non_interaction: true
    });
  });
  return {
    type: SET_FIELD_ERRORS,
    payload: errors
  };
}

function clearFieldError(fieldName) {
  return {
    type: CLEAR_FIELD_ERROR,
    payload: fieldName
  };
}

function isSuccess(status) {
  return {
    type: IS_SUCCESS,
    payload: status
  };
}

function redirectPage(targetUrl) {
  return {
    type: REDIRECT_PAGE,
    payload: targetUrl
  };
}

function postToQffAPI(qffData, successRedirect) {
  return function (dispatch) {
    var options = {
      headers: _extends({}, _constants.CSRF_HEADERS)
    };

    var payload = _extends({}, qffData, {
      proceed_to_next: !!successRedirect
    });

    return _axios2['default'].post(_constants2.API_POST_URL, payload, options).then(function (response) {
      if (response.data.success) {
        (0, _tracking2['default'])('Success', {
          event_category: GA_CATEGORY_NAME,
          non_interaction: true
        });
        if (successRedirect) {
          dispatch(redirectPage(successRedirect));
        } else {
          dispatch(isSuccess(true));
          dispatch(isLoading(false));
        }
      } else {
        dispatch(setResponseMessage(_constants2.DEFAULT_RESPONSE_ERROR));
        (0, _tracking2['default'])('Failed', {
          event_category: GA_CATEGORY_NAME,
          event_label: 'Rejected',
          non_interaction: true
        });
      }
    })['catch'](function (error) {
      dispatch(isLoading(false));
      dispatch(setResponseMessage(_constants2.DEFAULT_RESPONSE_ERROR));
      if (!error.response) {
        // network error
        (0, _tracking2['default'])('Failed', {
          event_category: GA_CATEGORY_NAME,
          event_label: 'Network Error',
          non_interaction: true
        });
      } else if (error.response.data && error.response.data.errors) {
        // response data
        var response = error.response.data;
        dispatch(setFieldErrors(response.errors));
      } else {
        // Error HTML page from CDN, Heroku or Django
        (0, _tracking2['default'])('Failed', {
          event_category: GA_CATEGORY_NAME,
          event_label: error.response.statusText,
          non_interaction: true
        });
      }
    });
  };
}

function submitQff(qffData, successRedirect) {
  return function (dispatch) {
    dispatch(isLoading(true));
    dispatch(setQffDetails(qffData));
    return dispatch(postToQffAPI(qffData, successRedirect));
  };
}

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADDRESS_CHECK_TASK_QUEUED = exports.ADDRESS_CHECK_MULTIPLE = exports.ADDRESS_CHECK_SUCCESS = exports.ADDRESS_CHECK_FAILED = exports.ADDRESS_CHECK_ERROR = exports.ADDRESS_CHECK_INIT = undefined;
exports.checkAddressPoll = checkAddressPoll;
exports.checkAddress = checkAddress;

var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

var _tracking = __webpack_require__(28);

var _tracking2 = _interopRequireDefault(_tracking);

var _constants = __webpack_require__(29);

var _constants2 = __webpack_require__(284);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ADDRESS_CHECK_INIT = exports.ADDRESS_CHECK_INIT = 'ADDRESS_CHECK_INIT';
var ADDRESS_CHECK_ERROR = exports.ADDRESS_CHECK_ERROR = 'ADDRESS_CHECK_ERROR';
var ADDRESS_CHECK_FAILED = exports.ADDRESS_CHECK_FAILED = 'ADDRESS_CHECK_FAILED';
var ADDRESS_CHECK_SUCCESS = exports.ADDRESS_CHECK_SUCCESS = 'ADDRESS_CHECK_SUCCESS';
var ADDRESS_CHECK_MULTIPLE = exports.ADDRESS_CHECK_MULTIPLE = 'ADDRESS_CHECK_MULTIPLE';
var ADDRESS_CHECK_TASK_QUEUED = exports.ADDRESS_CHECK_TASK_QUEUED = 'ADDRESS_CHECK_TASK_QUEUED';

function addressCheckInit() {
  return { type: ADDRESS_CHECK_INIT };
}

function addressCheckSuccess(nextStage, askLandline, appointmentRequired, installAddress, serviceClass, productFeatureAvailability) {
  return {
    type: ADDRESS_CHECK_SUCCESS,
    payload: {
      nextStage: nextStage,
      askLandline: askLandline,
      appointmentRequired: appointmentRequired,
      installAddress: installAddress,
      serviceClass: serviceClass,
      productFeatureAvailability: productFeatureAvailability
    }
  };
}

function addressCheckFailed(reason, date) {
  return { type: ADDRESS_CHECK_FAILED, payload: { reason: reason, date: date } };
}

function addressCheckError() {
  return { type: ADDRESS_CHECK_ERROR };
}

function taskInQueue() {
  return { type: ADDRESS_CHECK_TASK_QUEUED };
}

function addressCheckMultiple(addresses, nextStage) {
  return {
    type: ADDRESS_CHECK_MULTIPLE,
    payload: { addresses: addresses, nextStage: nextStage }
  };
}

var trackEvent = function () {
  function trackEvent(action, label) {
    return (0, _tracking2['default'])(action, {
      event_category: _constants2.GA_EVENT_CATEGORY,
      event_label: label
    });
  }

  return trackEvent;
}();

function parseAddressCheckResult(data) {
  if (data.next === _constants.ADDRESS_CLARIFICATION) {
    return addressCheckMultiple(data.addresses, data.next);
  }
  if (data.reason === _constants2.API_RESPONSE_AVAILABLE) {
    return addressCheckSuccess(data.next, data.ask_landline, data.appointment_required, data.install_address, data.service_class, data.product_feature_availability);
  }

  // Kogan internet not available
  trackEvent('Failed', data.reason || 'unknown');
  return addressCheckFailed(data.reason, data.date);
}

function checkAddressPoll() {
  return function (dispatch) {
    _axios2['default'].get(_constants.API_ADDRESS_CHECK_URL).then(function (response) {
      if (response.data.success) {
        if (response.data.pending) {
          // Still pending, try again later
          setTimeout(function () {
            return dispatch(checkAddressPoll());
          }, _constants2.POLL_INTERVAL);
          if (!response.data.started) {
            // Check if its even started, if not, show the additional message
            dispatch(taskInQueue());
          }
        } else {
          // Done! now parse the result
          dispatch(parseAddressCheckResult(response.data));
          var label = response.data.next === _constants.ADDRESS_CLARIFICATION ? _constants.ADDRESS_CLARIFICATION : _constants2.API_RESPONSE_AVAILABLE;
          trackEvent('Success', label);
        }
      } else {
        dispatch(addressCheckError());
      }
    })['catch'](function (error) {
      dispatch(addressCheckError());
      trackEvent('Error', error.response && error.response.statusText || 'client_network');
    });
  };
}

function checkAddress() {
  return function (dispatch) {
    dispatch(addressCheckInit());
    _axios2['default'].post(_constants.API_ADDRESS_CHECK_URL).then(function (response) {
      if (response.data.success === false) {
        dispatch(addressCheckError());
      } else if (response.data.pending) {
        // In queue, show loading message
        setTimeout(function () {
          return dispatch(checkAddressPoll());
        }, _constants2.POLL_INTERVAL);
      } else {
        // Wow, that was quick, it was already finished
        dispatch(parseAddressCheckResult(response.data));
        var label = response.data.next === _constants.ADDRESS_CLARIFICATION ? _constants.ADDRESS_CLARIFICATION : _constants2.API_RESPONSE_AVAILABLE;
        trackEvent('Success', label);
      }
    })['catch'](function (error) {
      dispatch(addressCheckError());
      trackEvent('Error', error.response && error.response.statusText || 'client_network');
    });
  };
}

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var API_RESPONSE_CONTACT_US = exports.API_RESPONSE_CONTACT_US = 'contact_us';
var API_RESPONSE_NOT_FOUND = exports.API_RESPONSE_NOT_FOUND = 'address_not_found';
var API_RESPONSE_NOT_AVAILABLE = exports.API_RESPONSE_NOT_AVAILABLE = 'not_available';
var API_RESPONSE_AVAILABLE = exports.API_RESPONSE_AVAILABLE = 'available';

var GA_EVENT_CATEGORY = exports.GA_EVENT_CATEGORY = 'Address Check';

var POLL_INTERVAL = exports.POLL_INTERVAL = 3000; // in milliseconds

/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMedia = __webpack_require__(721);

var _reactMedia2 = _interopRequireDefault(_reactMedia);

var _nukaCarousel = __webpack_require__(724);

var _nukaCarousel2 = _interopRequireDefault(_nukaCarousel);

var _PlanItem = __webpack_require__(730);

var _PlanItem2 = _interopRequireDefault(_PlanItem);

var _PlanSummary = __webpack_require__(735);

var _PlanSummary2 = _interopRequireDefault(_PlanSummary);

var _styles = __webpack_require__(736);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// 3 plans with a set width of 380 + padding on desktop = 1180 so we change the layout slightly
// below this width so users can still see all the plans clearly on medium sized devices
var desktopBreakpoint = 1180;

var PlanDisplay = function (_PureComponent) {
  _inherits(PlanDisplay, _PureComponent);

  function PlanDisplay(props) {
    _classCallCheck(this, PlanDisplay);

    var _this = _possibleConstructorReturn(this, (PlanDisplay.__proto__ || Object.getPrototypeOf(PlanDisplay)).call(this, props));

    _initialiseProps.call(_this);

    var plans = props.plans;

    var defaultPlanIndex = plans.map(function (p, i) {
      return p.carouselDefault ? i : null;
    }).filter(function (i) {
      return i != null;
    })[0] || 0;
    _this.state = {
      slideIndex: defaultPlanIndex,
      isDesktop: window.innerWidth >= desktopBreakpoint
    };
    return _this;
  }

  _createClass(PlanDisplay, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
      }

      return componentWillUnmount;
    }()

    // Displays the left slider control button if it's rendered on a desktop screen width, the number of plans
    // are more than 3 and if the centered plan is not the far left slide. On mobile it displays the left control
    // always unless the center slide is the far left slide.


    // Displays the right slider control button if it's rendered on a desktop screen width, the number of plans
    // are more than 3 and if the centered plan is not the far right slide. On mobile it displays the right control
    // always unless the center slide is the far right slide.


    // Desktop slider displays the center 3 slides with opacity 1 and any slides left and right of
    // the center 3 slides with opacity 0.4. Each slide has a set width of 380px.


    // Mobile slider displays the center slide with opacity 1 and any slides left and right of
    // the center slide with opacity 0.4.

  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props = this.props,
            summary = _props.summary,
            plans = _props.plans;

        return _jsx('div', {
          className: _styles2['default'].planWrapper
        }, void 0, plans.length < 2 ? _jsx('ul', {
          className: _styles2['default'].planList
        }, void 0, this.getPlans()) : _jsx(_reactMedia2.default, {
          query: '(max-width: 480px)'
        }, void 0, function (matches) {
          return matches && !summary ? _this2.renderPlanItemsMobile() : _this2.renderPlanItemsDesktop();
        }));
      }

      return render;
    }()
  }]);

  return PlanDisplay;
}(_react.PureComponent);

var _initialiseProps = function () {
  function _initialiseProps() {
    var _this3 = this;

    this.getPlans = function () {
      var _props2 = _this3.props,
          plans = _props2.plans,
          summary = _props2.summary,
          buttonTexts = _props2.buttonTexts,
          onButtonClicks = _props2.onButtonClicks,
          showEligibility = _props2.showEligibility;
      var _state = _this3.state,
          isDesktop = _state.isDesktop,
          slideIndex = _state.slideIndex;

      var PlanComponent = summary ? _PlanSummary2['default'] : _PlanItem2['default'];
      var activatePlans = [];

      if (isDesktop) {
        activatePlans = [slideIndex - 1, slideIndex, slideIndex + 1];
      }
      return plans.map(function (planData, i) {
        return _react2['default'].createElement(PlanComponent, _extends({
          key: planData.id
        }, planData, {
          active: isDesktop ? activatePlans.includes(i) : i === slideIndex,
          buttonText: buttonTexts[i],
          onButtonClick: onButtonClicks[i],
          showEligibility: showEligibility
        }));
      });
    };

    this.updateDimensions = function () {
      _this3.setState({ isDesktop: window.innerWidth >= desktopBreakpoint });
    };

    this.changeSlideIndex = function (slideIndex) {
      return _this3.setState({ slideIndex: slideIndex });
    };

    this.showLeftControl = function () {
      var plans = _this3.props.plans;
      var _state2 = _this3.state,
          isDesktop = _state2.isDesktop,
          slideIndex = _state2.slideIndex;


      if (isDesktop) {
        return plans.length > 3 ? slideIndex > 1 : false;
      }
      return slideIndex > 0;
    };

    this.showRightControl = function () {
      var plans = _this3.props.plans;
      var _state3 = _this3.state,
          isDesktop = _state3.isDesktop,
          slideIndex = _state3.slideIndex;


      if (isDesktop) {
        return plans.length > 3 ? slideIndex < plans.length - 2 : false;
      }
      return slideIndex < plans.length - 1;
    };

    this.leftControls = function (previousSlide) {
      return _this3.showLeftControl() ? _jsx('button', {
        className: _styles2['default'].carouselButton,
        onClick: previousSlide
      }, void 0, _jsx('i', {
        className: 'kgn-icon-arrow-left2',
        style: { lineHeight: 'normal', color: '#fff' }
      })) : function () {
        return null;
      };
    };

    this.rightControls = function (nextSlide) {
      return _this3.showRightControl() ? _jsx('button', {
        className: _styles2['default'].carouselButton,
        onClick: nextSlide
      }, void 0, _jsx('i', {
        className: 'kgn-icon-arrow-right2',
        style: { lineHeight: 'normal', color: '#fff' }
      })) : function () {
        return null;
      };
    };

    this.renderPlanItemsDesktop = function () {
      var plans = _this3.props.plans;
      var _state4 = _this3.state,
          isDesktop = _state4.isDesktop,
          slideIndex = _state4.slideIndex;


      return _jsx('div', {
        className: _styles2['default'].planList
      }, void 0, _jsx(_nukaCarousel2.default, {
        slideIndex: slideIndex,
        afterSlide: _this3.changeSlideIndex,
        speed: 100,
        renderBottomCenterControls: null,
        cellAlign: 'center',
        cellSpacing: 15,
        heightMode: 'max',
        slidesToShow: isDesktop ? plans.length - 1 : 1.2,
        frameOverflow: 'visible',
        slideWidth: '380px',
        width: '100%',
        dragging: false,
        renderCenterLeftControls: function () {
          function renderCenterLeftControls(_ref) {
            var previousSlide = _ref.previousSlide;
            return _this3.leftControls(previousSlide);
          }

          return renderCenterLeftControls;
        }(),
        renderCenterRightControls: function () {
          function renderCenterRightControls(_ref2) {
            var nextSlide = _ref2.nextSlide;
            return _this3.rightControls(nextSlide);
          }

          return renderCenterRightControls;
        }()
      }, void 0, _this3.getPlans()));
    };

    this.renderPlanItemsMobile = function () {
      var slideIndex = _this3.state.slideIndex;


      return _jsx('div', {
        className: _styles2['default'].planList
      }, void 0, _jsx(_nukaCarousel2.default, {
        slideIndex: slideIndex,
        afterSlide: _this3.changeSlideIndex,
        speed: 100,
        renderBottomCenterControls: null,
        cellAlign: 'center',
        heightMode: 'max',
        slidesToShow: 1.2,
        renderCenterLeftControls: function () {
          function renderCenterLeftControls(_ref3) {
            var previousSlide = _ref3.previousSlide;
            return _this3.leftControls(previousSlide);
          }

          return renderCenterLeftControls;
        }(),
        renderCenterRightControls: function () {
          function renderCenterRightControls(_ref4) {
            var nextSlide = _ref4.nextSlide;
            return _this3.rightControls(nextSlide);
          }

          return renderCenterRightControls;
        }()
      }, void 0, _this3.getPlans()));
    };
  }

  return _initialiseProps;
}();

PlanDisplay.defaultProps = {
  plans: [],
  buttonTexts: [''],
  summary: false,
  onButtonClicks: [function (f) {
    return f;
  }],
  showEligibility: true
};

exports['default'] = PlanDisplay;

/***/ }),

/***/ 289:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"planItem":"_3TOte","inactive":"_3uhUX","headerPill":"_1TdYZ","headerPillIcon":"_3CZAI","planTitle":"_3xhK5","planHeader":"_3cPIO","content":"_3r4CW","features":"_2FFjg","rate":"_3CAA4","wasPrice":"_3A3Q_","strikethrough":"_1y2Tt","pricing":"rRNco","price":"_3DwQq","interval":"_3TDYg","limit":"H5xru","highlightedFeature":"gIRwB","disclaimer":"_2x6hy","genericButton":"HIDJI","terms":"_187x7"};

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable object-curly-newline */

// Address
var OWNER_OF_SERVICE = exports.OWNER_OF_SERVICE = 'Owner of this service';
var NOT_OWNER_OF_SERVICE = exports.NOT_OWNER_OF_SERVICE = 'Does not own this service';

// Stages
var STAGE_CHECK_ADDRESS = exports.STAGE_CHECK_ADDRESS = 'check_address';
var STAGE_CLARIFY_ADDRESS = exports.STAGE_CLARIFY_ADDRESS = 'clarify_address';
var STAGE_WAITLIST = exports.STAGE_WAITLIST = 'waitlist';
var STAGE_OWNER_CHECK = exports.STAGE_OWNER_CHECK = 'owner_check';
var STAGE_PLAN_SELECT = exports.STAGE_PLAN_SELECT = 'plan_select';
var STAGE_MODEM_SELECT = exports.STAGE_MODEM_SELECT = 'modem_delivery';
var STAGE_PERSONAL = exports.STAGE_PERSONAL = 'personal';
var STAGE_IDENTIFICATION = exports.STAGE_IDENTIFICATION = 'identification';
var STAGE_PAYMENT = exports.STAGE_PAYMENT = 'payment';
var STAGE_SUBMIT = exports.STAGE_SUBMIT = 'submit';
var STAGE_SUCCESS = exports.STAGE_SUCCESS = 'success';

var STAGES = exports.STAGES = [{ id: STAGE_CHECK_ADDRESS, visible: false }, { id: STAGE_OWNER_CHECK, visible: false }, { id: STAGE_PLAN_SELECT, visible: false }, { id: STAGE_MODEM_SELECT, gaId: 1 }, { id: STAGE_PERSONAL, gaId: 2 }, { id: STAGE_IDENTIFICATION, gaId: 3 }, { id: STAGE_PAYMENT, gaId: 4 }, { id: STAGE_SUBMIT, visible: false, gaId: 5 }, { id: STAGE_SUCCESS, visible: false }];

// APIS
var API_PAYMENT_URL = exports.API_PAYMENT_URL = '/api/signup/pay/';
var API_MODEM_URL = exports.API_MODEM_URL = '/api/signup/modem_select/';
var API_PERSONAL_URL = exports.API_PERSONAL_URL = '/api/signup/personal/';
var API_ADDRESS_CHECK_URL = exports.API_ADDRESS_CHECK_URL = '/api/signup/address_check/';
var API_ADDRESS_UPDATE_URL = exports.API_ADDRESS_UPDATE_URL = '/api/signup/address_multiple_addresses/';
var API_LANDLINE_URL = exports.API_LANDLINE_URL = '/api/signup/owner/';
var API_SUBMIT_URL = exports.API_SUBMIT_URL = '/api/signup/submit/';
var API_TRANSITION_URL = exports.API_TRANSITION_URL = '/api/signup/transition/';
var API_ORDER_SUMMARY_URL = exports.API_ORDER_SUMMARY_URL = '/api/order/summary/';

// Payment
var DEFAULT_RESPONSE_ERROR = exports.DEFAULT_RESPONSE_ERROR = 'Sorry, there was an error processing your payment. Please try again';
var DEFAULT_RESPONSE_DECLINED = exports.DEFAULT_RESPONSE_DECLINED = 'Sorry, your payment was not successful. Please try again with a different card';

// Personal
var DEFAULT_DETAILS_PROVIDED = exports.DEFAULT_DETAILS_PROVIDED = {
  first_name: '',
  middle_name: '',
  last_name: '',
  email: '',
  date_of_birth: ''

  // Multi address stage
};var DEFAULT_MULTI_ADDRESS_STAGE_NUMBER_OF_ADDRESSES_TO_SHOW = exports.DEFAULT_MULTI_ADDRESS_STAGE_NUMBER_OF_ADDRESSES_TO_SHOW = 5;
var ADDRESS_CLARIFICATION = exports.ADDRESS_CLARIFICATION = 'clarify_address'; // const on backend

var PLAN_4G_FEATURE = exports.PLAN_4G_FEATURE = 'FHW-4G';

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OWNER_CLEAR_FIELD_ERROR = exports.OWNER_SUBMIT_SUCCESS = exports.OWNER_FIELD_ERRORS = undefined;
exports.setFieldErrors = setFieldErrors;
exports.clearFieldError = clearFieldError;
exports.submitForm = submitForm;

var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

var _tracking = __webpack_require__(28);

var _tracking2 = _interopRequireDefault(_tracking);

var _constants = __webpack_require__(29);

var _actions = __webpack_require__(31);

var _formValidator = __webpack_require__(61);

var _constants2 = __webpack_require__(164);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var OWNER_FIELD_ERRORS = exports.OWNER_FIELD_ERRORS = 'OWNER_FIELD_ERRORS';
var OWNER_SUBMIT_SUCCESS = exports.OWNER_SUBMIT_SUCCESS = 'OWNER_SUBMIT_SUCCESS';
var OWNER_CLEAR_FIELD_ERROR = exports.OWNER_CLEAR_FIELD_ERROR = 'OWNER_CLEAR_FIELD_ERROR';

function submitSuccess(nextStage, isOwner) {
  return {
    type: OWNER_SUBMIT_SUCCESS,
    payload: {
      nextStage: nextStage,
      isOwner: isOwner
    }
  };
}

function setFieldErrors(errors) {
  Object.keys(errors).forEach(function (field) {
    (0, _tracking2['default'])('Invalid', {
      event_category: _constants2.GA_EVENT_CATEGORY,
      event_label: field,
      field_name: field,
      error_message: errors[field],
      non_interaction: true
    });
  });
  return {
    type: OWNER_FIELD_ERRORS,
    payload: errors
  };
}

function clearFieldError(fieldName) {
  return {
    type: OWNER_CLEAR_FIELD_ERROR,
    payload: fieldName
  };
}

function submitForm(data) {
  return function (dispatch) {
    dispatch((0, _actions.isLoading)(true));
    _axios2['default'].post(_constants.API_LANDLINE_URL, data).then(function (response) {
      if (response.data.success) {
        dispatch(submitSuccess(response.data.next, data[_constants2.OWNS_SERVICE_KEY]));
        (0, _tracking2['default'])('Success', {
          event_category: _constants2.GA_EVENT_CATEGORY,
          event_label: 'Owner Details Submitted'
        });
      } else {
        dispatch((0, _actions.setError)(true));
      }
    })['catch'](function (error) {
      if (error.response.data && error.response.data.errors) {
        dispatch(setFieldErrors((0, _formValidator.flattenErrors)(error.response.data.errors)));
      } else {
        dispatch((0, _actions.setError)(true));
        (0, _tracking2['default'])('Error', {
          event_category: _constants2.GA_EVENT_CATEGORY,
          event_label: 'Network Error'
        });
      }
    });
  };
}

/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(295);
__webpack_require__(543);
__webpack_require__(773);
module.exports = __webpack_require__(774);


/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(296);

__webpack_require__(297);

__webpack_require__(326);

__webpack_require__(359);

__webpack_require__(387);

__webpack_require__(421);

__webpack_require__(492);

__webpack_require__(537);

__webpack_require__(539);

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STAGE_TRANSITION_SUCCESS = exports.ORDER_SUMMARY_FETCH_FAILURE = exports.ORDER_SUMMARY_FETCH_SUCCESS = exports.PAYMENT_SUCCESS = exports.PAYMENT_DECLINED = exports.PAYMENT_ERROR = exports.PAYMENT_PROCESSING = exports.SET_ERROR = exports.IS_LOADING = undefined;
exports.isLoading = isLoading;
exports.setError = setError;
exports.paymentSetError = paymentSetError;
exports.paymentSetDeclined = paymentSetDeclined;
exports.paymentSuccess = paymentSuccess;
exports.paymentSetProcessing = paymentSetProcessing;
exports.paymentSubmit = paymentSubmit;
exports.fetchOrderSummary = fetchOrderSummary;
exports.transitionToStage = transitionToStage;

var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

var _tracking = __webpack_require__(28);

var _tracking2 = _interopRequireDefault(_tracking);

var _constants = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var IS_LOADING = exports.IS_LOADING = 'IS_LOADING';
var SET_ERROR = exports.SET_ERROR = 'SET_ERROR';
var PAYMENT_PROCESSING = exports.PAYMENT_PROCESSING = 'PAYMENT_PROCESSING';
var PAYMENT_ERROR = exports.PAYMENT_ERROR = 'PAYMENT_ERROR';
var PAYMENT_DECLINED = exports.PAYMENT_DECLINED = 'PAYMENT_DECLINED';
var PAYMENT_SUCCESS = exports.PAYMENT_SUCCESS = 'PAYMENT_SUCCESS';
var ORDER_SUMMARY_FETCH_SUCCESS = exports.ORDER_SUMMARY_FETCH_SUCCESS = 'ORDER_SUMMARY_FETCH_SUCCESS';
var ORDER_SUMMARY_FETCH_FAILURE = exports.ORDER_SUMMARY_FETCH_FAILURE = 'ORDER_SUMMARY_FETCH_FAILURE';
var STAGE_TRANSITION_SUCCESS = exports.STAGE_TRANSITION_SUCCESS = 'STAGE_TRANSITION_SUCCESS';

function isLoading(state) {
  return { type: IS_LOADING, payload: state };
}

function setError(on) {
  return { type: SET_ERROR, payload: on };
}

function paymentSetError(error) {
  return { type: PAYMENT_ERROR, payload: { error: error } };
}

function paymentSetDeclined(declined) {
  return { type: PAYMENT_DECLINED, payload: { declined: declined } };
}

function paymentSuccess(nextStage) {
  return { type: PAYMENT_SUCCESS, payload: nextStage };
}

function paymentSetProcessing() {
  return { type: PAYMENT_PROCESSING };
}

function paymentSubmit(requestId, nonce) {
  return function (dispatch) {
    dispatch(paymentSetProcessing(true));
    var data = { reqid: requestId, nonce: nonce };
    _axios2['default'].post(_constants.API_PAYMENT_URL, data).then(function (response) {
      if (response.data.success) {
        dispatch(paymentSuccess(response.data.next));
      } else if (response.data.response !== undefined) {
        dispatch(paymentSetDeclined(true));
        (0, _tracking2['default'])('Declined', {
          event_category: 'Payment',
          event_label: 'Pay Details Declined'
        });
      } else {
        dispatch(paymentSetError(true));
        (0, _tracking2['default'])('Error', {
          event_category: 'Payment',
          event_label: 'Pay Network Error'
        });
      }
    })['catch'](function () {
      dispatch(paymentSetError(true));
      (0, _tracking2['default'])('Error', {
        event_category: 'Payment',
        event_label: 'Pay Network Error'
      });
    });
  };
}

function orderSummarySuccess(payload) {
  return { type: ORDER_SUMMARY_FETCH_SUCCESS, payload: payload };
}

function orderSummaryFailure(payload) {
  return { type: ORDER_SUMMARY_FETCH_FAILURE, payload: payload };
}

function fetchOrderSummary() {
  return function (dispatch) {
    dispatch(isLoading(true));
    _axios2['default'].get(_constants.API_ORDER_SUMMARY_URL).then(function (response) {
      dispatch(orderSummarySuccess(response.data));
    })['catch'](function (error) {
      if (error.response && error.response.status === 400) {
        window.location.href = '/';
      } else {
        dispatch(orderSummaryFailure());
        (0, _tracking2['default'])('Error', {
          event_category: 'Fetch Order Summary',
          event_label: 'Network Error',
          non_interaction: true
        });
      }
    });
  };
}

function stageTransitionSuccess(payload) {
  return { type: STAGE_TRANSITION_SUCCESS, payload: payload };
}

function transitionToStage(stage) {
  return function (dispatch) {
    dispatch(isLoading(true));
    _axios2['default'].post(_constants.API_TRANSITION_URL, { target_state: stage }).then(function (response) {
      dispatch(stageTransitionSuccess(response.data));
      (0, _tracking.gaPageView)(stage);
    })['catch'](function (error) {
      dispatch(setError(true));
      dispatch(isLoading(false));
      (0, _tracking2['default'])('Error', {
        event_category: 'Transition',
        event_label: error.response && error.response.statusText || 'Network Error',
        non_interaction: true
      });
    });
  };
}

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }(); /* eslint jsx-a11y/label-has-for: 0 */


var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(37);

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = __webpack_require__(587);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormFieldLayout = function () {
  function FormFieldLayout(_ref) {
    var fieldName = _ref.fieldName,
        labelText = _ref.labelText,
        fieldElement = _ref.fieldElement,
        description = _ref.description,
        error = _ref.error,
        extraClasses = _ref.extraClasses;

    var errorElement = error.status ? _jsx('p', {
      className: _styles2['default'].error
    }, void 0, error.message) : null;

    return _jsx('div', {
      className: (0, _classnames2['default'])(_styles2['default'].element_group, extraClasses, _defineProperty({}, _styles2['default'].hasError, error.status))
    }, void 0, _jsx('label', {
      className: _styles2['default'].label,
      htmlFor: fieldName
    }, void 0, labelText), fieldElement, errorElement, description && _jsx('p', {
      className: _styles2['default'].description
    }, void 0, description));
  }

  return FormFieldLayout;
}();

var defaultInput = _jsx('input', {
  type: 'text',
  className: 'form-input',
  id: 'genericInput',
  placeholder: 'Just a label',
  maxLength: '50'
});

FormFieldLayout.defaultProps = {
  fieldName: 'genericInput',
  labelText: 'Input label',
  fieldElement: defaultInput,
  description: '',
  error: { status: false, message: '' },
  extraClasses: ''
};

exports['default'] = FormFieldLayout;

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactBrowserDetection = __webpack_require__(607);

var _reactBrowserDetection2 = _interopRequireDefault(_reactBrowserDetection);

var _GenericStatusLoading = __webpack_require__(79);

var _GenericStatusLoading2 = _interopRequireDefault(_GenericStatusLoading);

var _constants = __webpack_require__(67);

var _styles = __webpack_require__(609);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _ref2 = _jsx(_GenericStatusLoading2.default, {});

var _ref3 = _jsx('rect', {
  className: 'svgClipped',
  width: '100%',
  height: '80'
});

var _ref4 = _jsx('defs', {}, void 0, _jsx('clipPath', {
  id: 'anglePath',
  clipPathUnits: 'objectBoundingBox'
}, void 0, _jsx('polygon', {
  points: '0 1, 0 0, 1 0, 0.8 1'
})));

var BrandedButton = function () {
  function BrandedButton(_ref) {
    var className = _ref.className,
        iconName = _ref.iconName,
        labelText = _ref.labelText,
        onSubmit = _ref.onSubmit,
        onClick = _ref.onClick,
        loading = _ref.loading,
        disabled = _ref.disabled,
        fitContent = _ref.fitContent;

    // Explicitly add icons classNames from scss/icons.scss
    var iconTypes = {
      arrowUp: 'kgn-icon-pencil',
      arrowDown: 'kgn-icon-pencil',
      creditCard: 'kgn-icon-credit-card',
      retry: 'kgn-icon-spinner',
      kgnArrowRight: 'kgn-icon-arrow-right',
      arrowRight: 'kgn-icon-keyboard_arrow_right'
    };

    var iconElement = iconName ? _jsx('i', {
      className: _styles2['default'].kgnIcon + ' ' + iconTypes[iconName]
    }) : '';
    var activeIcon = loading ? _jsx('div', {
      className: _styles2['default'].loadingIcon
    }, void 0, _ref2) : iconElement;

    /* This stuff is only used in IE and EDGE as clip path doesnt work,
     * Didn't want to render this for other browsers so just remove this when/if it is finally suported
     */
    var ieEdgeClass = _constants.isEdge ? _styles2['default'].edgeFix : '';
    var ieFixClass = _constants.isIE || _constants.isEdge ? ieEdgeClass + ' ' + _styles2['default'].ieFix : '';

    var isLoadingClass = loading ? _styles2['default'].isLoading : '';

    var svgAngleElement = _jsx('svg', {
      className: _styles2['default'].svgStyleBlock
    }, void 0, _ref3, _ref4);

    var ieEdgeClipPathPolyfill = {
      ie: function () {
        function ie() {
          return svgAngleElement;
        }

        return ie;
      }(),
      edge: function () {
        function edge() {
          return svgAngleElement;
        }

        return edge;
      }(),
      'default': function () {
        function _default() {
          return null;
        }

        return _default;
      }()

      // Approx. width required for each character + width for arrow element
    };var charWidth = 13;
    var arrowWidth = 32;
    var styleOverrides = fitContent ? {
      width: charWidth * labelText.length + arrowWidth + 'px'
    } : {};

    return _jsx('button', {
      className: _styles2['default'].button + ' ' + ieFixClass + ' ' + isLoadingClass + ' ' + className,
      style: styleOverrides,
      'data-text-before': labelText,
      onSubmit: onSubmit,
      onClick: onClick,
      disabled: disabled || loading
    }, void 0, labelText, activeIcon, _jsx(_reactBrowserDetection2.default, {}, void 0, ieEdgeClipPathPolyfill));
  }

  return BrandedButton;
}();

BrandedButton.defaultProps = {
  className: '',
  iconName: 'kgnArrowRight',
  labelText: 'Branded Button',
  onSubmit: function () {
    function onSubmit(f) {
      return f;
    }

    return onSubmit;
  }(),
  onClick: undefined,
  loading: false,
  disabled: false,
  fitContent: false
};

exports['default'] = BrandedButton;

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }(); /* eslint no-console: ["error", { allow: ["log"] }] */
// middleware
// used to fire other actions sequentially
// Axios config


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(156);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(23);

var _redux = __webpack_require__(27);

var _reduxPromise = __webpack_require__(553);

var _reduxPromise2 = _interopRequireDefault(_reduxPromise);

var _reduxThunk = __webpack_require__(559);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

__webpack_require__(560);

var _LeadGen = __webpack_require__(578);

var _LeadGen2 = _interopRequireDefault(_LeadGen);

var _Checkout = __webpack_require__(613);

var _Checkout2 = _interopRequireDefault(_Checkout);

var _QantasFrequentFlyer = __webpack_require__(281);

var _QantasFrequentFlyer2 = _interopRequireDefault(_QantasFrequentFlyer);

var _BGAnimation = __webpack_require__(766);

var _BGAnimation2 = _interopRequireDefault(_BGAnimation);

var _middleware = __webpack_require__(768);

var _middleware2 = _interopRequireDefault(_middleware);

var _PlanDisplay = __webpack_require__(285);

var _PlanDisplay2 = _interopRequireDefault(_PlanDisplay);

var _BrandedButton = __webpack_require__(47);

var _BrandedButton2 = _interopRequireDefault(_BrandedButton);

var _constants = __webpack_require__(67);

var _reducers = __webpack_require__(769);

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var middleware = [_reduxThunk2['default'], _reduxPromise2['default'], _middleware2['default']];
var consoleStyle = 'background: #555; color: #bada55;';

var devToolsExtension = function () {
  function devToolsExtension(f) {
    return f;
  }

  return devToolsExtension;
}(); // Initialise as an empty function

if (_constants.ENABLE_DEV_TOOLS === true) {
  console.log('%c_____ PROJECT HAS REDUX TOOLS ENABLED _____', consoleStyle);
  // eslint-disable-next-line no-underscore-dangle
  devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : function (f) {
    return f;
  };
}

var contactFormElement = document.querySelector('.app__container--lead_gen');
var bgAnimationElement = document.querySelector('.app__container--bg_animation');
var checkoutElement = document.getElementById('app__container--checkout');
var planElements = document.querySelectorAll('.app__container--plan');
var qffElement = document.querySelector('.app__container--qff');
var brandedButtonElements = document.querySelectorAll('.app__element--branded_button');
var homepagePlanDisplay = document.querySelector('#homepage-plan-display');

var middlewareComposed = (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middleware), devToolsExtension);
var store = (0, _redux.createStore)(_reducers2['default'], middlewareComposed);
var bootstrapProps = window.bootstrapData || {};
if (contactFormElement) {
  // Contact form embedded in marketing pages (eg. homepage)
  _reactDom2['default'].render(_jsx(_reactRedux.Provider, {
    store: store
  }, void 0, _react2['default'].createElement(_LeadGen2['default'], _extends({ store: store }, bootstrapProps))), contactFormElement);
}

if (checkoutElement) {
  // Checkout Application
  _reactDom2['default'].render(_jsx(_reactRedux.Provider, {
    store: store
  }, void 0, _react2['default'].createElement(_Checkout2['default'], _extends({ store: store }, bootstrapProps))), checkoutElement);
}

if (qffElement) {
  // QFF Application
  _reactDom2['default'].render(_jsx(_reactRedux.Provider, {
    store: store
  }, void 0, _react2['default'].createElement(_QantasFrequentFlyer2['default'], _extends({ store: store }, bootstrapProps))), qffElement);
}

if (bgAnimationElement) {
  // React Background Animation
  _reactDom2['default'].render(_jsx(_BGAnimation2.default, {}), bgAnimationElement);
}

if (brandedButtonElements) {
  // Kogan Branded Button
  var _onClick = function () {
    function _onClick(target) {
      if (target) {
        window.location.href = target;
      }
    }

    return _onClick;
  }();
  brandedButtonElements.forEach(function (button) {
    var text = button.getAttribute('data-label');
    var targetUrl = button.getAttribute('data-target');
    _reactDom2['default'].render(_jsx(_BrandedButton2.default, {
      fitContent: true,
      labelText: text,
      onClick: function () {
        function onClick() {
          return _onClick(targetUrl);
        }

        return onClick;
      }()
    }), button);
  });
}

if (homepagePlanDisplay && window.bootstrapPlans) {
  var plans = Object.values(window.bootstrapPlans);
  var buttonTexts = Array.apply(undefined, _toConsumableArray(planElements)).map(function (element) {
    return element.getAttribute('data-button-text');
  });
  var onButtonClicks = Array.apply(undefined, _toConsumableArray(planElements)).map(function (element) {
    return function () {
      function redirect() {
        document.location.href = element.getAttribute('data-redirect-target');
      }

      return redirect;
    }();
  });
  _reactDom2['default'].render(_jsx(_PlanDisplay2.default, {
    plans: plans,
    buttonTexts: buttonTexts,
    onButtonClicks: onButtonClicks
  }), homepagePlanDisplay);
}

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_axios2['default'].defaults.xsrfCookieName = 'csrftoken';
_axios2['default'].defaults.xsrfHeaderName = 'X-CSRFToken';

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(23);

var _redux = __webpack_require__(27);

var _scrollToElement = __webpack_require__(255);

var _scrollToElement2 = _interopRequireDefault(_scrollToElement);

var _AddressForm = __webpack_require__(256);

var _AddressForm2 = _interopRequireDefault(_AddressForm);

var _FullNameField = __webpack_require__(259);

var _FullNameField2 = _interopRequireDefault(_FullNameField);

var _EmailField = __webpack_require__(162);

var _EmailField2 = _interopRequireDefault(_EmailField);

var _BrandedButton = __webpack_require__(47);

var _BrandedButton2 = _interopRequireDefault(_BrandedButton);

var _formValidator = __webpack_require__(61);

var _urlParams = __webpack_require__(610);

var _urlParams2 = _interopRequireDefault(_urlParams);

var _constants = __webpack_require__(96);

var _constants2 = __webpack_require__(124);

var _cookie = __webpack_require__(611);

var _cookie2 = _interopRequireDefault(_cookie);

var _tracking = __webpack_require__(28);

var _utils = __webpack_require__(125);

var _WithInputAnalytics = __webpack_require__(126);

var _WithInputAnalytics2 = _interopRequireDefault(_WithInputAnalytics);

var _constants3 = __webpack_require__(161);

var _styles = __webpack_require__(612);

var _styles2 = _interopRequireDefault(_styles);

var _actions = __webpack_require__(261);

var _constants4 = __webpack_require__(95);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TrackedFullNameField = (0, _WithInputAnalytics2['default'])(_constants4.GA_EVENT_CATEGORY)(_FullNameField2['default']);
var TrackedEmailField = (0, _WithInputAnalytics2['default'])(_constants4.GA_EVENT_CATEGORY)(_EmailField2['default']);

var _ref = _jsx('legend', {}, void 0, 'Signup for Kogan Internet:');

var _ref2 = _jsx('h2', {}, void 0, 'Thanks for joining the Kogan Internet waitlist.');

var _ref3 = _jsx('p', {}, void 0, _jsx('a', {
  href: 'https://www.kogan.com/'
}, void 0, 'Click here'), ' to shop the latest deals from Kogan.com');

var LeadGen = function (_Component) {
  _inherits(LeadGen, _Component);

  function LeadGen(props) {
    var _fieldValues;

    _classCallCheck(this, LeadGen);

    // We handle state here locally as storing these in Redux for onChange events is very expensive!
    var _this = _possibleConstructorReturn(this, (LeadGen.__proto__ || Object.getPrototypeOf(LeadGen)).call(this, props));

    _this.onFieldChange = function (value, fieldname) {
      _this.setState({
        fieldValues: _extends({}, _this.state.fieldValues, _defineProperty({}, fieldname, value))
      });
    };

    _this.onFieldChangeHandler = function (event) {
      return _this.onFieldChange(event.target.value, event.target.name);
    };

    _this.onFieldBlur = function (event) {
      if (_this.props.fieldValues[event.target.name] !== _this.state.fieldValues[event.target.name]) {
        _this.props.setLeadDetails(_defineProperty({}, event.target.name, event.target.value));
      }
    };

    _this.onAddressSelect = function (selected) {
      _this.props.setLeadDetails(_extends({}, selected));
    };

    _this.onAddressUpdated = function (data) {
      _this.props.setLeadDetails(_extends({}, data.fieldValues));
    };

    _this.onLeadSubmit = function (event) {
      event.preventDefault();
      _this.props.setResponseMessage('');

      var valid = (0, _formValidator.validateForm)(_this.props.fieldValues, _this.props.manualAddress);

      if (valid === true) {
        /* Clear any form errors */
        _this.props.setFieldErrors({});
        // Track completion of field
        var eventLabel = 'Address ' + (_this.props.manualAddress ? '(Manual)' : '(Autocomplete)');
        (0, _utils.sendEvent)(eventLabel, _constants3.GA_ACTION_COMPLETED, _constants4.GA_EVENT_CATEGORY);
        _this.props.submitLead(_this.props.fieldValues, _this.props.manualAddress, _this.props.checkoutPage);
      } else {
        _this.props.setFieldErrors(valid);
      }
    };

    _this.clearEmailErrors = function () {
      return _this.props.clearFieldError(_constants4.LEAD_EMAIL_KEY);
    };

    _this.populateDataFromQueryStrings = function () {
      var _basicFieldsPayload;

      var qsName = (0, _cookie2['default'])(_constants4.COOKIE_KEY_NAME);
      var qsEmail = (0, _cookie2['default'])(_constants4.COOKIE_KEY_EMAIL);
      var qsAddress = (0, _cookie2['default'])(_constants4.COOKIE_KEY_ADDRESS);

      var basicFieldsPayload = (_basicFieldsPayload = {}, _defineProperty(_basicFieldsPayload, _constants4.LEAD_NAME_KEY, qsName), _defineProperty(_basicFieldsPayload, _constants4.LEAD_EMAIL_KEY, qsEmail), _defineProperty(_basicFieldsPayload, _constants.ADDRESS_TEXT_KEY, qsAddress), _basicFieldsPayload);

      // TODO: Disable in production
      var manual = !!(0, _urlParams2['default'])('manual');
      if (manual) {
        var typeMapping = {
          AV: 'Avenue', DR: 'Drive', ST: 'Street', RD: 'Road'
        };
        basicFieldsPayload[_constants2.STREET_NUMBER_KEY] = (0, _urlParams2['default'])(_constants2.STREET_NUMBER_KEY);
        basicFieldsPayload[_constants2.STREET_NAME_KEY] = (0, _urlParams2['default'])(_constants2.STREET_NAME_KEY);
        basicFieldsPayload[_constants2.STREET_TYPE_KEY] = typeMapping[(0, _urlParams2['default'])(_constants2.STREET_TYPE_KEY)];
        basicFieldsPayload[_constants2.SUBURB_KEY] = (0, _urlParams2['default'])(_constants2.SUBURB_KEY);
        basicFieldsPayload[_constants2.STATE_KEY] = (0, _urlParams2['default'])(_constants2.STATE_KEY);
        basicFieldsPayload[_constants2.POSTCODE_KEY] = (0, _urlParams2['default'])(_constants2.POSTCODE_KEY);
        _this.props.setManualAddress(true);
      }

      // Local state is set here
      _this.setState({
        fieldValues: _extends({}, _this.state.fieldValues, basicFieldsPayload)
      });

      // Set redux props (whats sent to server)
      _this.props.setLeadDetails(basicFieldsPayload);

      if (qsEmail || qsName) {
        if (qsAddress.length !== 0) {
          _this.addressFocusRef.current.search(qsAddress);
        }
        setTimeout(function () {
          return _this.addressFocusRef.current.focus();
        }, 100);
      } else if (window.location.hash) {
        // Only focus if an anchor exists
        if (_this.leadNameRef) _this.leadNameRef.focus();
      }
    };

    _this.state = {
      fieldValues: (_fieldValues = {}, _defineProperty(_fieldValues, _constants4.LEAD_NAME_KEY, ''), _defineProperty(_fieldValues, _constants4.LEAD_EMAIL_KEY, ''), _fieldValues)
    };
    _this.leadNameRef = null;
    _this.addressFocusRef = _react2['default'].createRef();
    return _this;
  }

  // Grab some query string values


  _createClass(LeadGen, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        this.populateDataFromQueryStrings();
        (0, _tracking.trackAbandonments)();
      }

      return componentDidMount;
    }()

    /* Full Name Handlers */


    /* Handle Submission */

  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props = this.props,
            leadGenReducer = _props.leadGenReducer,
            fieldError = _props.fieldError,
            manualAddress = _props.manualAddress,
            submitLabel = _props.submitLabel,
            termsText = _props.termsText;
        var isLoading = leadGenReducer.isLoading,
            success = leadGenReducer.success,
            message = leadGenReducer.message;


        var isFormCompleteClass = success ? _styles2['default'].form_complete : '';
        var responseMessageElement = message && !success ? _jsx('p', {
          className: _styles2['default'].form_error
        }, void 0, message) : null;
        var isManualAddressClass = manualAddress ? _styles2['default'].manual_address : '';
        var termsConditionsElement = !termsText ? null :
        // eslint-disable-next-line react/no-danger
        _jsx('div', {
          className: _styles2['default'].terms,
          dangerouslySetInnerHTML: { __html: termsText }
        });

        if (success) {
          (0, _scrollToElement2['default'])(document.getElementById(_constants4.LEAD_SUCCESS_CONTAINER_ID), {
            offset: -100,
            ease: 'linear',
            duration: 250
          });
        }

        return _jsx('form', {
          className: _styles2['default'].container + ' ' + isFormCompleteClass + ' ' + isManualAddressClass,
          onSubmit: this.onLeadSubmit,
          method: 'POST'
        }, void 0, _jsx('fieldset', {
          className: _styles2['default'].form_container
        }, void 0, _ref, _jsx('div', {
          className: _styles2['default'].field_name
        }, void 0, _jsx(TrackedFullNameField, {
          fieldName: _constants4.LEAD_NAME_KEY,
          inputRef: function () {
            function inputRef(r) {
              _this2.leadNameRef = r;
            }

            return inputRef;
          }(),
          name: _constants4.LEAD_NAME_KEY,
          onChange: this.onFieldChangeHandler,
          onBlur: this.onFieldBlur,
          value: this.state.fieldValues[_constants4.LEAD_NAME_KEY],
          errorMessage: fieldError[_constants4.LEAD_NAME_KEY],
          loading: isLoading
        })), _jsx('div', {
          className: _styles2['default'].field_email
        }, void 0, _jsx(TrackedEmailField, {
          fieldName: _constants4.LEAD_EMAIL_KEY,
          onChange: this.onFieldChangeHandler,
          onBlur: this.onFieldBlur,
          onFocus: this.clearEmailErrors,
          value: this.state.fieldValues[_constants4.LEAD_EMAIL_KEY],
          errorMessage: fieldError[_constants4.LEAD_EMAIL_KEY],
          loading: isLoading
        })), _jsx('div', {
          className: _styles2['default'].field_break
        }), _jsx('div', {
          className: manualAddress ? 'c-form-field--lesspadding' : _styles2['default'].field_address
        }, void 0, _react2['default'].createElement(_AddressForm2['default'], {
          ref: this.addressFocusRef,
          loading: isLoading,
          manual: manualAddress,
          fieldErrors: fieldError,
          fieldValues: this.props.fieldValues,
          onAddressSelected: this.onAddressSelect,
          onFieldUpdated: this.props.setLeadDetails,
          onManualEntry: this.props.setManualAddress,
          gaCategory: _constants4.GA_EVENT_CATEGORY
        })), _jsx('div', {
          className: _styles2['default'].field_submit
        }, void 0, _jsx(_BrandedButton2.default, {
          labelText: submitLabel,
          loading: isLoading,
          fitContent: true
        })), termsConditionsElement, responseMessageElement), _jsx('div', {
          className: _styles2['default'].success_container,
          id: _constants4.LEAD_SUCCESS_CONTAINER_ID
        }, void 0, _ref2, _jsx('p', {}, void 0, 'We will send updates to ', _jsx('strong', {}, void 0, this.props.fieldValues.email)), _ref3));
      }

      return render;
    }()
  }]);

  return LeadGen;
}(_react.Component);

LeadGen.defaultProps = {
  leadGenReducer: {
    isLoading: false,
    success: false,
    message: 'Just a message'
  },
  fieldValues: {},
  fieldError: {},
  manualAddress: false,
  submitLabel: 'Join Waitlist',
  termsText: null,
  checkoutPage: null,

  setResponseMessage: function () {
    function setResponseMessage(f) {
      return f;
    }

    return setResponseMessage;
  }(),
  submitLead: function () {
    function submitLead(f) {
      return f;
    }

    return submitLead;
  }(),
  setFieldErrors: function () {
    function setFieldErrors(f) {
      return f;
    }

    return setFieldErrors;
  }(),
  setLeadDetails: function () {
    function setLeadDetails(f) {
      return f;
    }

    return setLeadDetails;
  }(),
  setManualAddress: function () {
    function setManualAddress(f) {
      return f;
    }

    return setManualAddress;
  }(),
  clearFieldError: function () {
    function clearFieldError(f) {
      return f;
    }

    return clearFieldError;
  }()
};

function mapStateToProps(state) {
  // whatever is returned will show up as props
  return {
    leadGenReducer: state.leadGenReducer,
    fieldValues: state.leadGenReducer.fieldValues,
    fieldError: state.leadGenReducer.fieldError,
    manualAddress: state.leadGenReducer.manualAddress
  };
}

// Anything returned from this function will end up as props
function mapDispatchToProps(dispatch) {
  // Whenever dispatch is called the result should be passed to all of the reducers
  return (0, _redux.bindActionCreators)({
    setLeadDetails: _actions.setLeadDetails,
    setResponseMessage: _actions.setResponseMessage,
    submitLead: _actions.submitLead,
    setFieldErrors: _actions.setFieldErrors,
    setManualAddress: _actions.setManualAddress
  }, dispatch);
}

// To promote a component to a container (smart component) - it needs
// to know about this new dispatch method. Make it available as a prop.
exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LeadGen);

/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(37);

var _classnames2 = _interopRequireDefault(_classnames);

var _GenericAddressField = __webpack_require__(586);

var _GenericAddressField2 = _interopRequireDefault(_GenericAddressField);

var _SelectField = __webpack_require__(588);

var _SelectField2 = _interopRequireDefault(_SelectField);

var _styles = __webpack_require__(590);

var _styles2 = _interopRequireDefault(_styles);

var _constants = __webpack_require__(124);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Address = function (_Component) {
  _inherits(Address, _Component);

  function Address(props) {
    var _extends3;

    _classCallCheck(this, Address);

    var _this = _possibleConstructorReturn(this, (Address.__proto__ || Object.getPrototypeOf(Address)).call(this, props));

    _this.onFieldChange = function (value, fieldname) {
      _this.setState({
        fieldValues: _extends({}, _this.state.fieldValues, _defineProperty({}, fieldname, value))
      });
    };

    _this.onFieldBlur = function (value, fieldname) {
      if (_this.props.fieldValues[fieldname] !== _this.state.fieldValues[fieldname]) {
        _this.props.onFieldUpdated(_defineProperty({}, fieldname, value));
      }
    };

    _this.onSelectChangeHandler = function (event) {
      _this.onFieldChange(event.target.value, event.target.name);
      _this.onFieldBlur(event.target.value, event.target.name);
    };

    _this.onFieldChangeHandler = function (event) {
      return _this.onFieldChange(event.target.value, event.target.name);
    };

    _this.onFieldBlurHandler = function (event) {
      return _this.onFieldBlur(event.target.value, event.target.name);
    };

    _this.onKeyPressHandler = function (event) {
      if (event.key === 'Enter') {
        _this.onFieldBlur(event.target.value, event.target.name);
      }
    };

    _this.focus = function () {
      return _this.focusRef.current.focus();
    };

    _this.focusRef = _react2['default'].createRef();
    _this.state = {
      fieldValues: _extends((_extends3 = {}, _defineProperty(_extends3, _constants.UNIT_NUMBER_KEY, ''), _defineProperty(_extends3, _constants.UNIT_TYPE_KEY, ''), _defineProperty(_extends3, _constants.STREET_NUMBER_KEY, ''), _defineProperty(_extends3, _constants.STREET_NAME_KEY, ''), _defineProperty(_extends3, _constants.STREET_TYPE_KEY, ''), _defineProperty(_extends3, _constants.SUBURB_KEY, ''), _defineProperty(_extends3, _constants.STATE_KEY, ''), _defineProperty(_extends3, _constants.POSTCODE_KEY, ''), _extends3), props.fieldValues)
    };
    return _this;
  }

  _createClass(Address, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            loading = _props.loading,
            fieldErrors = _props.fieldErrors;
        var fieldValues = this.state.fieldValues;


        return _jsx(_react.Fragment, {}, void 0, _react2['default'].createElement(
          'div',
          { className: _styles2['default'].field_unit_number, ref: this.focusRef },
          _jsx(_GenericAddressField2.default, {
            label: 'Unit Number',
            name: _constants.UNIT_NUMBER_KEY,
            value: fieldValues[_constants.UNIT_NUMBER_KEY],
            errorMessage: fieldErrors[_constants.UNIT_NUMBER_KEY],
            onChange: this.onFieldChangeHandler,
            onBlur: this.onFieldBlurHandler,
            onKeyPress: this.onKeyPressHandler,
            loading: loading
          })
        ), _jsx('div', {
          className: (0, _classnames2['default'])(_styles2['default'].field_select, _styles2['default'].field_unit_type)
        }, void 0, _jsx(_SelectField2.default, {
          label: 'Unit Type',
          options: _constants.UNIT_TYPE_SELECTION,
          name: _constants.UNIT_TYPE_KEY,
          value: fieldValues[_constants.UNIT_TYPE_KEY],
          errorMessage: fieldErrors[_constants.UNIT_TYPE_KEY],
          onChange: this.onSelectChangeHandler,
          onBlur: this.onFieldBlurHandler,
          onKeyPress: this.onKeyPressHandler,
          loading: loading
        })), _jsx('div', {
          className: _styles2['default'].field_break
        }), _jsx('div', {
          className: _styles2['default'].field_street_number
        }, void 0, _jsx(_GenericAddressField2.default, {
          label: 'Street Number',
          name: _constants.STREET_NUMBER_KEY,
          value: fieldValues[_constants.STREET_NUMBER_KEY],
          errorMessage: fieldErrors[_constants.STREET_NUMBER_KEY],
          onChange: this.onFieldChangeHandler,
          onBlur: this.onFieldBlurHandler,
          onKeyPress: this.onKeyPressHandler,
          loading: loading,
          required: true
        })), _jsx('div', {
          className: _styles2['default'].field_street_name
        }, void 0, _jsx(_GenericAddressField2.default, {
          label: 'Street Name',
          name: _constants.STREET_NAME_KEY,
          value: fieldValues[_constants.STREET_NAME_KEY],
          errorMessage: fieldErrors[_constants.STREET_NAME_KEY],
          onChange: this.onFieldChangeHandler,
          onBlur: this.onFieldBlurHandler,
          onKeyPress: this.onKeyPressHandler,
          loading: loading,
          required: true
        })), _jsx('div', {
          className: (0, _classnames2['default'])(_styles2['default'].field_select, _styles2['default'].field_street_type)
        }, void 0, _jsx(_SelectField2.default, {
          label: 'Street Type',
          options: _constants.STREET_TYPE_SELECTION,
          name: _constants.STREET_TYPE_KEY,
          value: fieldValues[_constants.STREET_TYPE_KEY],
          errorMessage: fieldErrors[_constants.STREET_TYPE_KEY],
          onChange: this.onSelectChangeHandler,
          onBlur: this.onFieldBlurHandler,
          onKeyPress: this.onKeyPressHandler,
          loading: loading,
          required: true
        })), _jsx('div', {
          className: _styles2['default'].field_break
        }), _jsx('div', {
          className: _styles2['default'].field_suburb
        }, void 0, _jsx(_GenericAddressField2.default, {
          label: 'Suburb',
          name: _constants.SUBURB_KEY,
          value: fieldValues[_constants.SUBURB_KEY],
          errorMessage: fieldErrors[_constants.SUBURB_KEY],
          onChange: this.onFieldChangeHandler,
          onBlur: this.onFieldBlurHandler,
          onKeyPress: this.onKeyPressHandler,
          loading: loading,
          required: true
        })), _jsx('div', {
          className: (0, _classnames2['default'])(_styles2['default'].field_select, _styles2['default'].field_state)
        }, void 0, _jsx(_SelectField2.default, {
          label: 'State',
          options: _constants.STATE_SELECTION,
          name: _constants.STATE_KEY,
          value: fieldValues[_constants.STATE_KEY],
          errorMessage: fieldErrors[_constants.STATE_KEY],
          onChange: this.onSelectChangeHandler,
          onBlur: this.onFieldBlurHandler,
          onKeyPress: this.onKeyPressHandler,
          loading: loading,
          required: true
        })), _jsx('div', {
          className: _styles2['default'].field_postcode
        }, void 0, _jsx(_GenericAddressField2.default, {
          label: 'Postcode',
          name: _constants.POSTCODE_KEY,
          value: fieldValues[_constants.POSTCODE_KEY],
          errorMessage: fieldErrors[_constants.POSTCODE_KEY],
          onChange: this.onFieldChangeHandler,
          onBlur: this.onFieldBlurHandler,
          onKeyPress: this.onKeyPressHandler,
          loading: loading,
          required: true
        })), _jsx('div', {
          className: _styles2['default'].field_break
        }));
      }

      return render;
    }()
  }]);

  return Address;
}(_react.Component);

Address.defaultProps = {
  onFieldUpdated: function () {
    function onFieldUpdated(f) {
      return f;
    }

    return onFieldUpdated;
  }(),
  loading: false,
  fieldValues: {},
  fieldErrors: {}
};
exports['default'] = Address;

/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _FormFieldLayout = __webpack_require__(43);

var _FormFieldLayout2 = _interopRequireDefault(_FormFieldLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var GenericAddressField = function () {
  function GenericAddressField(_ref) {
    var onBlur = _ref.onBlur,
        onFocus = _ref.onFocus,
        onChange = _ref.onChange,
        onKeyPress = _ref.onKeyPress,
        value = _ref.value,
        loading = _ref.loading,
        errorMessage = _ref.errorMessage,
        name = _ref.name,
        label = _ref.label,
        required = _ref.required;

    var hasValueClass = value ? 'has-value' : '';
    var hasError = !!errorMessage;

    var errorObject = {
      status: hasError,
      message: errorMessage
    };
    var fieldElement = _jsx('input', {
      type: 'text',
      name: name,
      className: 'form-input ' + hasValueClass,
      id: name,
      maxLength: '140',
      value: value,
      onChange: onChange,
      onBlur: onBlur,
      onFocus: onFocus,
      onKeyPress: onKeyPress,
      disabled: loading,
      required: required
    });
    return _jsx(_FormFieldLayout2.default, {
      fieldName: name,
      labelText: label,
      fieldElement: fieldElement,
      error: errorObject
    });
  }

  return GenericAddressField;
}();

GenericAddressField.defaultProps = {
  value: '',
  loading: false,
  onBlur: function () {
    function onBlur(f) {
      return f;
    }

    return onBlur;
  }(),
  onChange: function () {
    function onChange(f) {
      return f;
    }

    return onChange;
  }(),
  onFocus: function () {
    function onFocus(f) {
      return f;
    }

    return onFocus;
  }(),
  onKeyPress: function () {
    function onKeyPress(f) {
      return f;
    }

    return onKeyPress;
  }(),
  errorMessage: '',
  required: false
};

exports['default'] = GenericAddressField;

/***/ }),

/***/ 587:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"element_group":"_2XxAt","hasError":"_2Jnrb","label":"_347c8","error":"_2MDi9","description":"_2j74y"};

/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _FormFieldLayout = __webpack_require__(43);

var _FormFieldLayout2 = _interopRequireDefault(_FormFieldLayout);

var _constants = __webpack_require__(95);

var _styles = __webpack_require__(589);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _ref2 = _jsx('option', {
  disabled: true,
  value: ''
});

var SelectField = function () {
  function SelectField(_ref) {
    var onChange = _ref.onChange,
        onFocus = _ref.onFocus,
        onKeyPress = _ref.onKeyPress,
        options = _ref.options,
        value = _ref.value,
        loading = _ref.loading,
        errorMessage = _ref.errorMessage,
        name = _ref.name,
        label = _ref.label,
        required = _ref.required;

    var hasValueClass = value ? 'has-value' : '';
    var hasError = !!errorMessage;

    var errorObject = {
      status: hasError,
      message: errorMessage
    };

    var listOfOptions = options.map(function (valueName) {
      return _jsx('option', {
        value: valueName
      }, valueName, valueName);
    });
    var extraClasses = loading ? _styles2['default'].isLoading : '';

    var fieldElement = _jsx('select', {
      name: name,
      className: hasValueClass,
      id: name,
      value: value,
      onChange: onChange,
      onFocus: onFocus,
      onKeyPress: onKeyPress,
      disabled: loading,
      required: required
    }, void 0, _ref2, listOfOptions);

    return _jsx(_FormFieldLayout2.default, {
      fieldName: name,
      labelText: label,
      fieldElement: fieldElement,
      error: errorObject,
      extraClasses: extraClasses
    });
  }

  return SelectField;
}();

SelectField.defaultProps = {
  value: '',
  loading: false,
  onChange: function () {
    function onChange(f) {
      return f;
    }

    return onChange;
  }(),
  onFocus: function () {
    function onFocus(f) {
      return f;
    }

    return onFocus;
  }(),
  onKeyPress: function () {
    function onKeyPress(f) {
      return f;
    }

    return onKeyPress;
  }(),
  errorMessage: '',
  required: false,
  options: _constants.UNIT_TYPE_SELECTION
};

exports['default'] = SelectField;

/***/ }),

/***/ 589:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"isLoading":"_1Qme8"};

/***/ }),

/***/ 590:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"field_unit_number":"_17akK","field_unit_type":"UgXPB","field_street_number":"_2xuz6","field_street_name":"_2adoM","field_street_type":"_1idU5","field_suburb":"knR38","field_state":"_2H6nb","field_postcode":"_2oNfO","field":"_66Dgm","form_error":"_2JwGd","field_break":"_2IU9f","field_select":"_2rxV0"};

/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(159);

var _lodash2 = _interopRequireDefault(_lodash);

var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactAutocomplete = __webpack_require__(592);

var _reactAutocomplete2 = _interopRequireDefault(_reactAutocomplete);

var _FormFieldLayout = __webpack_require__(43);

var _FormFieldLayout2 = _interopRequireDefault(_FormFieldLayout);

var _AutocompleteResult = __webpack_require__(596);

var _AutocompleteResult2 = _interopRequireDefault(_AutocompleteResult);

var _AutocompleteList = __webpack_require__(601);

var _AutocompleteList2 = _interopRequireDefault(_AutocompleteList);

var _utils = __webpack_require__(125);

var _actions = __webpack_require__(258);

var _constants = __webpack_require__(96);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AutocompleteAddress = function (_Component) {
  _inherits(AutocompleteAddress, _Component);

  function AutocompleteAddress(props) {
    _classCallCheck(this, AutocompleteAddress);

    var _this = _possibleConstructorReturn(this, (AutocompleteAddress.__proto__ || Object.getPrototypeOf(AutocompleteAddress)).call(this, props));

    _this.onInputUpdated = function (event) {
      var val = event.target.value;
      if (val && val.length > _constants.AUTOCOMPLETE_MIN_CHARS) {
        _this.handleSearchDebounced(val);
      }
      _this.setState({ value: val });
    };

    _this.onItemSelected = function (text, item) {
      var _this$props$onSelect;

      switch (item.Moniker) {
        case _constants.SWITCH_MANUAL_ADDRESS:
          _this.trackEvent('Enter Manual Address', 'Cant find', text.length);
          _this.props.onManualEntry(true);
          break;

        case _constants.ITEM_MONIKER_TOO_MANY:
          _this.trackEvent('Enter Manual Address', 'Too many matches', text.length);
          _this.props.onManualEntry(true);
          break;

        default:
          _this.trackEvent('Select address', undefined, text.length);
          _this.setState({ value: text });
          _this.props.onSelect((_this$props$onSelect = {}, _defineProperty(_this$props$onSelect, _constants.ADDRESS_ID_KEY, item.Moniker), _defineProperty(_this$props$onSelect, _constants.ADDRESS_TEXT_KEY, text), _this$props$onSelect));
      }
    };

    _this.trackSearchResults = function () {
      var _this$state = _this.state,
          searchState = _this$state.searchState,
          value = _this$state.value;


      if (searchState === _constants.TOO_MANY_ERROR_STATUS) {
        _this.trackEvent('Search Completed', 'Too many matches', value.length);
      } else if (searchState === _constants.HAS_RESULTS_STATUS) {
        _this.trackEvent('Search Completed', 'Has Results', value.length);
      } else if (searchState === _constants.NO_MATCHES_STATUS) {
        _this.trackEvent('Search Completed', 'No Results');
      }
    };

    _this.trackEvent = function (action, label, value) {
      return (0, _utils.sendEvent)(label, action, _this.props.gaCategory, value);
    };

    _this.focus = function () {
      return _this.focusRef.current.focus();
    };

    _this.handleFocus = function (e) {
      return _this.trackEvent('Focussed', e.currentTarget.name);
    };

    _this.focusRef = _react2['default'].createRef();
    _this.state = {
      isSearching: false,
      searchResults: [],
      searchError: undefined,
      searchState: null,
      value: props.value
    };
    _this.searchCanceller = _axios2['default'].CancelToken.source();
    return _this;
  }

  _createClass(AutocompleteAddress, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        var _this2 = this;

        this.handleSearchDebounced = _lodash2['default'].debounce(function (addressValue) {
          _this2.setState({
            isSearching: true,
            value: addressValue
          });
          _this2.searchCanceller = _axios2['default'].CancelToken.source();
          _this2.props.searchForAddress(addressValue, _this2.searchCanceller.token).then(function (data) {
            _this2.setState({
              searchResults: data.results,
              searchState: data.state,
              searchError: ''
            }, function () {
              _this2.trackSearchResults();
            });
            // If there is no other requests in-flight, not searching any more
            if (_this2.state.value === addressValue) {
              _this2.setState({
                isSearching: false
              });
            }
          })['catch'](function (error) {
            _this2.setState({
              searchResults: [],
              searchState: null,
              searchError: error
            });
            // If there is no other requests in-flight, not searching any more
            if (_this2.state.value === addressValue) {
              _this2.setState({
                isSearching: false
              });
            }
          });
        }, 400);
        this.handleSearchDebounced.bind(this);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        this.handleSearchDebounced.cancel();
        this.searchCanceller.cancel();
      }

      return componentWillUnmount;
    }()

    /* Track when a particular error is displayed */

  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this3 = this;

        var _props = this.props,
            loading = _props.loading,
            errorMessage = _props.errorMessage,
            label = _props.label;
        var _state = this.state,
            isSearching = _state.isSearching,
            searchResults = _state.searchResults,
            searchError = _state.searchError,
            searchState = _state.searchState,
            value = _state.value;


        var hasValueClass = value.length === 0 || 'has-value';
        var hasError = errorMessage.length > 0 || false;
        var errorObject = { status: hasError, message: errorMessage };

        var results = [].concat(_toConsumableArray(searchResults));
        if (value.length <= _constants.AUTOCOMPLETE_MIN_CHARS) {
          results.push({
            Moniker: _constants.ITEM_MONIKER_TOO_SHORT,
            Picklist: ''
          });
        } else if (searchState === _constants.TOO_MANY_ERROR_STATUS) {
          results.push({
            Moniker: _constants.ITEM_MONIKER_TOO_MANY,
            Picklist: ''
          });
        } else {
          results.push({
            Moniker: _constants.SWITCH_MANUAL_ADDRESS,
            Picklist: ''
          });
        }

        results.forEach(function (ignored, i) {
          results[i].Picklist = (0, _actions.parseAddress)(results[i].Picklist);
        });

        var fieldElement = function () {
          function fieldElement(props) {
            return _jsx(_FormFieldLayout2.default, {
              fieldName: _constants.ADDRESS_TEXT_KEY,
              labelText: label,
              fieldElement: _react2['default'].createElement('input', _extends({}, props, {
                type: 'text',
                name: 'street-address',
                className: 'form-input ' + hasValueClass,
                id: _constants.ADDRESS_TEXT_KEY,
                maxLength: '600',
                disabled: loading,
                required: true,
                autoComplete: 'googleignoreautofill' // Google deliberately ignores off and false values
                , ref: function () {
                  function ref(r) {
                    props.ref(r);
                    _this3.focusRef.current = r;
                  }

                  return ref;
                }(),
                onFocus: _this3.handleFocus,
                placeholder: label
              })),
              error: errorObject
            });
          }

          return fieldElement;
        }();

        return _jsx(_reactAutocomplete2.default, {
          getItemValue: function () {
            function getItemValue(item) {
              return item.Picklist;
            }

            return getItemValue;
          }(),
          items: results,
          renderItem: function () {
            function renderItem(item, isHighlighted) {
              return _jsx(_AutocompleteResult2.default, {
                item: item,
                search: value,
                isHighlighted: isHighlighted
              }, item.Moniker);
            }

            return renderItem;
          }(),
          renderMenu: function () {
            function renderMenu(items) {
              return _jsx(_AutocompleteList2.default, {
                searching: isSearching,
                searchError: searchError,
                searchState: searchState
              }, void 0, items);
            }

            return renderMenu;
          }(),
          renderInput: fieldElement,
          value: value,
          onChange: this.onInputUpdated,
          onSelect: this.onItemSelected,
          selectOnBlur: false,
          wrapperStyle: { width: '100%' }
        });
      }

      return render;
    }()
  }]);

  return AutocompleteAddress;
}(_react.Component);

AutocompleteAddress.defaultProps = {
  onManualEntry: function () {
    function onManualEntry(f) {
      return f;
    }

    return onManualEntry;
  }(),
  gaCategory: 'Address Autocomplete',
  value: '',
  loading: false,
  onSelect: function () {
    function onSelect(f) {
      return f;
    }

    return onSelect;
  }(),
  errorMessage: '',
  label: 'Address',
  searchForAddress: function () {
    function searchForAddress(f) {
      return f;
    }

    return searchForAddress;
  }()
};
exports['default'] = AutocompleteAddress;

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactHighlightWords = __webpack_require__(597);

var _reactHighlightWords2 = _interopRequireDefault(_reactHighlightWords);

var _AutocompleteItem = __webpack_require__(257);

var _AutocompleteItem2 = _interopRequireDefault(_AutocompleteItem);

var _styles = __webpack_require__(599);

var _styles2 = _interopRequireDefault(_styles);

var _constants = __webpack_require__(600);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx('span', {}, void 0, _constants.TOO_SHORT_WARNING);

var AutocompleteResult = function (_PureComponent) {
  _inherits(AutocompleteResult, _PureComponent);

  function AutocompleteResult() {
    _classCallCheck(this, AutocompleteResult);

    return _possibleConstructorReturn(this, (AutocompleteResult.__proto__ || Object.getPrototypeOf(AutocompleteResult)).apply(this, arguments));
  }

  _createClass(AutocompleteResult, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            item = _props.item,
            search = _props.search,
            isHighlighted = _props.isHighlighted,
            onMouseEnter = _props.onMouseEnter,
            onClick = _props.onClick;


        var children = void 0;
        var extraProps = {
          isHighlighted: isHighlighted,
          onMouseEnter: onMouseEnter,
          onClick: onClick,
          className: _styles2['default'].result
        };

        if (item.Moniker === _constants.ITEM_MONIKER_NOT_FOUND) {
          children = _jsx('span', {}, void 0, 'Address not found? ', _jsx('span', {
            className: _styles2['default'].link
          }, void 0, 'Click here'));
        } else if (item.Moniker === _constants.ITEM_MONIKER_TOO_SHORT) {
          children = _ref;
          extraProps = {
            className: _styles2['default'].noSearch
          };
        } else if (item.Moniker === _constants.ITEM_MONIKER_TOO_MANY) {
          children = _jsx('span', {
            className: _styles2['default'].warning
          }, void 0, _jsx('div', {}, void 0, _constants.TOO_MANY_WARNING, '\xA0', _jsx('span', {
            className: _styles2['default'].link
          }, void 0, 'Manually enter your address')));
        } else {
          var address = ((item || {}).Picklist || '').match(/[^,]+,?/g);
          var postcode = (item || {}).Postcode || '';

          children = address.map(function (part) {
            return _jsx(_reactHighlightWords2.default, {
              autoEscape: true,
              highlightClassName: _styles2['default'].highlight,
              searchWords: search.split(' '),
              textToHighlight: part
            }, part);
          });
          children.push(_jsx('span', {}, _constants.ITEM_MONIKER_NOT_FOUND, ' ', postcode));
        }

        return _react2['default'].createElement(
          _AutocompleteItem2['default'],
          extraProps,
          children
        );
      }

      return render;
    }()
  }]);

  return AutocompleteResult;
}(_react.PureComponent);

AutocompleteResult.defaultProps = {
  item: {
    Picklist: '',
    Moniker: '',
    Postcode: ''
  },
  search: '',
  isHighlighted: false,
  onMouseEnter: function () {
    function onMouseEnter(f) {
      return f;
    }

    return onMouseEnter;
  }(),
  onClick: function () {
    function onClick(f) {
      return f;
    }

    return onClick;
  }()
};

exports['default'] = AutocompleteResult;

/***/ }),

/***/ 598:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"autocomplete_item":"_1JP3A","noSearch":"_3s5PR","highlighted":"_1IjxU"};

/***/ }),

/***/ 599:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"noSearch":"_3ew5M","highlight":"_3bQtz","result":"JucO0","link":"_35sU5","warning":"_3sT3j"};

/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ITEM_MONIKER_NOT_FOUND = exports.ITEM_MONIKER_NOT_FOUND = 'cantfind';
var ITEM_MONIKER_TOO_MANY = exports.ITEM_MONIKER_TOO_MANY = 'toomany';
var ITEM_MONIKER_TOO_SHORT = exports.ITEM_MONIKER_TOO_SHORT = 'tooshort';

var TOO_MANY_WARNING = exports.TOO_MANY_WARNING = 'Too many results, please be more specific. e.g. Unit 5/10 Seal St.';
var TOO_SHORT_WARNING = exports.TOO_SHORT_WARNING = 'Keep typing...';

/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LoadingBar = __webpack_require__(602);

var _LoadingBar2 = _interopRequireDefault(_LoadingBar);

var _AutocompleteError = __webpack_require__(604);

var _AutocompleteError2 = _interopRequireDefault(_AutocompleteError);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _styles = __webpack_require__(606);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AutocompleteList = function (_PureComponent) {
  _inherits(AutocompleteList, _PureComponent);

  function AutocompleteList() {
    _classCallCheck(this, AutocompleteList);

    return _possibleConstructorReturn(this, (AutocompleteList.__proto__ || Object.getPrototypeOf(AutocompleteList)).apply(this, arguments));
  }

  _createClass(AutocompleteList, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            children = _props.children,
            searching = _props.searching,
            searchError = _props.searchError,
            searchState = _props.searchState,
            onMouseEnter = _props.onMouseEnter,
            onMouseLeave = _props.onMouseLeave;


        var errorElement = searchError && _jsx(_AutocompleteError2.default, {
          message: searchError
        });

        if ((!children || children.length === 0) && !searching && !searchError && !searchState) {
          return null;
        }

        return _jsx('div', {
          className: _styles2['default'].wrapper,
          onMouseEnter: onMouseEnter,
          onMouseLeave: onMouseLeave
        }, void 0, _jsx(_LoadingBar2.default, {
          show: searching
        }), _jsx('ol', {
          className: _styles2['default'].list
        }, void 0, errorElement, children));
      }

      return render;
    }()
  }]);

  return AutocompleteList;
}(_react.PureComponent);

AutocompleteList.defaultProps = {
  children: null,
  searching: false,
  searchError: '',
  searchState: '',
  onMouseEnter: function () {
    function onMouseEnter(f) {
      return f;
    }

    return onMouseEnter;
  }(),
  onMouseLeave: function () {
    function onMouseLeave(f) {
      return f;
    }

    return onMouseLeave;
  }()
};

exports['default'] = AutocompleteList;

/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _styles = __webpack_require__(603);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var LoadingBar = function () {
  function LoadingBar(_ref) {
    var show = _ref.show;
    return _jsx('div', {
      className: _styles2['default'].bar + ' ' + (show ? '' : _styles2['default'].off)
    });
  }

  return LoadingBar;
}();

LoadingBar.defaultProps = {
  show: false
};

exports['default'] = LoadingBar;

/***/ }),

/***/ 603:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bar":"_17d5T","move-bar":"_40gDK","off":"_2Bpko"};

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _AutocompleteItem = __webpack_require__(257);

var _AutocompleteItem2 = _interopRequireDefault(_AutocompleteItem);

var _styles = __webpack_require__(605);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var AutocompleteError = function () {
  function AutocompleteError(_ref) {
    var message = _ref.message;
    return _jsx(_AutocompleteItem2.default, {
      className: _styles2['default'].error
    }, void 0, _jsx('span', {}, void 0, message));
  }

  return AutocompleteError;
}();

AutocompleteError.defaultProps = {
  message: ''
};

exports['default'] = AutocompleteError;

/***/ }),

/***/ 605:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"error":"_1a3LG"};

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"g22Yb","list":"_2DUZ1"};

/***/ }),

/***/ 608:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loader__wrapper":"pcd5l","loader":"dMe7E","loadingAnimation":"_2y3Bt"};

/***/ }),

/***/ 609:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"isLoading":"_iowG","svgStyleBlock":"_2HIgb","button":"EjSwA","loadingIcon":"POkAn","ieFix":"_1rvcR","edgeFix":"_1ivzn","kgnIcon":"_2kNMl"};

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateName = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.validateEmail = validateEmail;
exports.validateNotBlank = validateNotBlank;
exports.validatePhone = validatePhone;
exports.validateDate = validateDate;
exports.validateAccountPin = validateAccountPin;
exports.validateAddress = validateAddress;
exports.validateStreetNumber = validateStreetNumber;
exports.validateStreetName = validateStreetName;
exports.validatePostcode = validatePostcode;
exports.validateState = validateState;
exports.validateStreetType = validateStreetType;
exports.validateUnitType = validateUnitType;
exports.validateQantasFrequentFlyer = validateQantasFrequentFlyer;
exports.validateReference = validateReference;
exports.validateAddressForm = validateAddressForm;
exports.validateForm = validateForm;
exports.validatePersonalInfoForm = validatePersonalInfoForm;
exports.validateMultiAddressForm = validateMultiAddressForm;
exports.validateOwnerForm = validateOwnerForm;
exports.validateQffForm = validateQffForm;
exports.flattenErrors = flattenErrors;

var _constants = __webpack_require__(95);

var _constants2 = __webpack_require__(163);

var _constants3 = __webpack_require__(164);

var _constants4 = __webpack_require__(97);

var _constants5 = __webpack_require__(260);

var _constants6 = __webpack_require__(124);

var _constants7 = __webpack_require__(96);

function errorsOrTrue(errors) {
  if (Object.keys(errors).length === 0) {
    return true;
  }
  return errors;
}

function validateEmail(email) {
  var expression = /^(.+)@(.+){2,}\.(.+){2,}$/;
  return expression.test(email);
}

function validateNotBlank(name) {
  return name && name.length > 0;
}

var validateName = exports.validateName = function () {
  function validateName(name) {
    return validateNotBlank(name);
  }

  return validateName;
}();

function validatePhone(number) {
  var required = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!required && !number) return true;
  // Validates land line and mobile numbers.
  // Starting numbers must be between 01 and 08 or optionally +61
  var expression = /^(0|\+?61)[1-8]\d{8}$/g;
  return expression.test(number.replace(/\s/g, ''));
}

function validateDate(date) {
  // validates dd/mm/yyyy
  var expression = /^(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/;
  return expression.test(date);
}

function validateAccountPin(number) {
  var expression = /^[0-9]{4}$/;
  return expression.test(number);
}

function validateAddress(addressId) {
  return !!addressId;
}

function validateStreetNumber(input, required) {
  if (!required && !input) return true;
  var expression = /^\d+(-\d+|[a-zA-Z])?$/;
  return expression.test(input || '');
}

function validateStreetName(input, required) {
  if (!required && !input) return true;
  return !!input;
}

function validatePostcode(input) {
  var expression = /^\d{4}$/;
  return expression.test(input || '');
}

function validateState(input) {
  return _constants6.STATE_SELECTION.indexOf(input) !== -1;
}

function validateStreetType(input) {
  return _constants6.STREET_TYPE_SELECTION.indexOf(input) !== -1;
}

function validateUnitType(input, required) {
  if (!required && !input) return true;
  return _constants6.UNIT_TYPE_SELECTION.indexOf(input) !== -1;
}

function validateOwner(input) {
  return input === true || input === false;
}

function validateQantasFrequentFlyer(number) {
  var required = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!required && !number) return true;
  var expression = /^\d{7,16}$/g;
  return expression.test(number.replace(/\s/g, ''));
}

function validateReference(number) {
  var required = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!required && !number) return true;
  var expression = /^[0-9A-Za-z]{8,}$/g;
  return expression.test(number.replace(/\s/g, ''));
}

function validateAddressForm(data, manualAddress) {
  var errors = {};
  if (!manualAddress) {
    if (!data[_constants7.ADDRESS_ID_KEY]) {
      errors[_constants7.ADDRESS_TEXT_KEY] = _constants7.ADDRESS_ERROR_MESSAGE;
    }
  } else {
    if (!validateStreetNumber(data[_constants6.UNIT_NUMBER_KEY], false)) {
      errors[_constants6.UNIT_NUMBER_KEY] = _constants6.NUMBER_ERROR_MESSAGE;
    }
    if (!validateUnitType(data[_constants6.UNIT_TYPE_KEY], !!data[_constants6.UNIT_NUMBER_KEY])) {
      errors[_constants6.UNIT_TYPE_KEY] = _constants.REQUIRED_ERROR_MESSAGE;
    }
    if (!validateStreetNumber(data[_constants6.STREET_NUMBER_KEY], true)) {
      errors[_constants6.STREET_NUMBER_KEY] = _constants6.NUMBER_ERROR_MESSAGE;
    }
    if (!validateStreetName(data[_constants6.STREET_NAME_KEY], true)) {
      errors[_constants6.STREET_NAME_KEY] = _constants.REQUIRED_ERROR_MESSAGE;
    }
    if (!validateStreetType(data[_constants6.STREET_TYPE_KEY])) {
      errors[_constants6.STREET_TYPE_KEY] = _constants.REQUIRED_ERROR_MESSAGE;
    }
    if (!validateNotBlank(data[_constants6.SUBURB_KEY])) {
      errors[_constants6.SUBURB_KEY] = _constants.REQUIRED_ERROR_MESSAGE;
    }
    if (!validateState(data[_constants6.STATE_KEY])) {
      errors[_constants6.STATE_KEY] = _constants.REQUIRED_ERROR_MESSAGE;
    }
    if (!validatePostcode(data[_constants6.POSTCODE_KEY])) {
      errors[_constants6.POSTCODE_KEY] = _constants6.POSTCODE_ERROR_MESSAGE;
    }
  }

  return errorsOrTrue(errors);
}

function validateForm(formData, manualAddress) {
  var errors = {};
  if (!validateEmail(formData[_constants.LEAD_EMAIL_KEY])) errors[_constants.LEAD_EMAIL_KEY] = _constants.EMAIL_ERROR_MESSAGE;
  if (!validateName(formData[_constants.LEAD_NAME_KEY])) errors[_constants.LEAD_NAME_KEY] = _constants.REQUIRED_ERROR_MESSAGE;

  var addressErrors = validateAddressForm(formData, manualAddress);
  if (addressErrors !== true) {
    Object.assign(errors, addressErrors);
  }

  if (Object.keys(errors).length === 0) {
    return true;
  }
  return errors;
}

function validatePersonalInfoForm(formData) {
  var errors = {};
  if (!validateName(formData[_constants2.FIRST_NAME_KEY])) errors[_constants2.FIRST_NAME_KEY] = _constants.REQUIRED_ERROR_MESSAGE;
  // TODO: middle name is optional
  // if (!validateName(formData[MIDDLE_NAME_KEY])) errors[MIDDLE_NAME_KEY] = REQUIRED_ERROR_MESSAGE
  if (!validateName(formData[_constants2.LAST_NAME_KEY])) errors[_constants2.LAST_NAME_KEY] = _constants.REQUIRED_ERROR_MESSAGE;

  /* Add new validation for these its just checking as name */
  if (!validatePhone(formData[_constants2.PHONE_KEY])) errors[_constants2.PHONE_KEY] = _constants2.PHONE_ERROR_MESSAGE;
  if (!validateDate(formData[_constants2.DATE_BIRTH_KEY])) errors[_constants2.DATE_BIRTH_KEY] = _constants2.DATE_ERROR_MESSAGE;
  if (!validateAccountPin(formData[_constants2.ACCOUNT_PIN_KEY])) errors[_constants2.ACCOUNT_PIN_KEY] = _constants2.ACCOUNT_PIN_ERROR_MESSAGE;

  if (Object.keys(errors).length === 0) {
    return true;
  }
  return errors;
}

function validateMultiAddressForm(selectedAddress) {
  return validateAddress(selectedAddress) ? true : _constants5.REQUIRED_SELECTION;
}

function validateOwnerForm(formData) {
  var errors = {};
  if (!validateOwner(formData[_constants3.OWNS_SERVICE_KEY])) errors[_constants3.OWNS_SERVICE_KEY] = _constants.REQUIRED_ERROR_MESSAGE;

  if (Object.keys(errors).length === 0) {
    return true;
  }
  return errors;
}

function validateQffForm(formData) {
  var errors = {};
  if (!validateEmail(formData[_constants4.QFF_EMAIL_KEY], false)) errors[_constants4.QFF_EMAIL_KEY] = _constants.EMAIL_ERROR_MESSAGE;
  if (!validateNotBlank(formData[_constants4.QFF_FIRST_NAME_KEY])) errors[_constants4.QFF_FIRST_NAME_KEY] = _constants.REQUIRED_ERROR_MESSAGE;
  if (!validateNotBlank(formData[_constants4.QFF_LAST_NAME_KEY])) errors[_constants4.QFF_LAST_NAME_KEY] = _constants.REQUIRED_ERROR_MESSAGE;
  if (!validateReference(formData[_constants4.QFF_REFERENCE_KEY])) errors[_constants4.QFF_REFERENCE_KEY] = _constants4.QFF_REFERENCE_ERROR_MESSAGE;
  if (!validateQantasFrequentFlyer(formData[_constants4.QFF_NUMBER_KEY])) errors[_constants4.QFF_NUMBER_KEY] = _constants4.QFF_NUMBER_ERROR_MESSAGE;
  if (Object.keys(errors).length === 0) {
    return true;
  }
  return errors;
}

function flattenErrors(errors) {
  // Flatten error objects coming back from the server
  // Django MAY return errors like this:
  // {'field1': ['An error']}
  var newErrors = {};
  Object.keys(errors).forEach(function (key) {
    if (typeof errors[key] === 'string') {
      newErrors[key] = errors[key];
    } else {
      var _errors$key = _slicedToArray(errors[key], 1),
          err = _errors$key[0];

      newErrors[key] = err;
    }
  });
  return newErrors;
}

/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = getUrlParameter;
/* Gets a url paramater from query string */
function getUrlParameter(name) {
  var cleanName = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + cleanName + '=([^&#]*)');
  var results = regex.exec(window.location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = getCookie;
function getCookie(cname) {
  // Get a cookie value
  // Taken from https://www.w3schools.com/js/js_cookies.asp
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  // eslint-disable-next-line
  for (var i in ca) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      var start = name.length;
      var end = c.length;
      if (c.charAt(end - 1) === '"') {
        end -= 1;
      }
      if (c.charAt(start) === '"') {
        start += 1;
      }
      return c.substring(start, end);
    }
  }
  return '';
}

/***/ }),

/***/ 612:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"form_complete":"_16gRo","form_container":"lUBl1","success_container":"_1cIMi","container":"_3ExaJ","field_submit":"_3erio","field_name":"_3pDNH","field_email":"_3x-JN","field_address":"_2zD_s","field":"_1bYxh","terms":"_1FMwi","manual_address":"_8Y9yV","field_break":"_29uLf","form_error":"qYdpu","field_select":"_1MzeA"};

/***/ }),

/***/ 613:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(23);

var _redux = __webpack_require__(27);

var _isEqual = __webpack_require__(614);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _GenericStatusLoading = __webpack_require__(79);

var _GenericStatusLoading2 = _interopRequireDefault(_GenericStatusLoading);

var _PaymentStage = __webpack_require__(682);

var _PaymentStage2 = _interopRequireDefault(_PaymentStage);

var _IdentificationStage = __webpack_require__(698);

var _IdentificationStage2 = _interopRequireDefault(_IdentificationStage);

var _PersonalInfoStage = __webpack_require__(700);

var _PersonalInfoStage2 = _interopRequireDefault(_PersonalInfoStage);

var _ModemStage = __webpack_require__(706);

var _ModemStage2 = _interopRequireDefault(_ModemStage);

var _SuccessStage = __webpack_require__(709);

var _SuccessStage2 = _interopRequireDefault(_SuccessStage);

var _AddressCheckStage = __webpack_require__(718);

var _AddressCheckStage2 = _interopRequireDefault(_AddressCheckStage);

var _PlanSelectionStage = __webpack_require__(720);

var _PlanSelectionStage2 = _interopRequireDefault(_PlanSelectionStage);

var _OwnerCheckStage = __webpack_require__(739);

var _OwnerCheckStage2 = _interopRequireDefault(_OwnerCheckStage);

var _SubmitStage = __webpack_require__(741);

var _SubmitStage2 = _interopRequireDefault(_SubmitStage);

var _StageIndicator = __webpack_require__(743);

var _StageIndicator2 = _interopRequireDefault(_StageIndicator);

var _OrderSummary = __webpack_require__(745);

var _OrderSummary2 = _interopRequireDefault(_OrderSummary);

var _DialogPlan = __webpack_require__(747);

var _DialogPlan2 = _interopRequireDefault(_DialogPlan);

var _ErrorScreen = __webpack_require__(133);

var _ErrorScreen2 = _interopRequireDefault(_ErrorScreen);

var _MultipleAddressStage = __webpack_require__(761);

var _MultipleAddressStage2 = _interopRequireDefault(_MultipleAddressStage);

var _tracking = __webpack_require__(28);

var _constants = __webpack_require__(29);

var _actions = __webpack_require__(31);

var _styles = __webpack_require__(765);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx(_GenericStatusLoading2.default, {});

var CheckoutContainer = function (_Component) {
  _inherits(CheckoutContainer, _Component);

  function CheckoutContainer(props) {
    _classCallCheck(this, CheckoutContainer);

    var _this = _possibleConstructorReturn(this, (CheckoutContainer.__proto__ || Object.getPrototypeOf(CheckoutContainer)).call(this, props));

    _this.onCloseDialogPlan = function () {
      _this.setState({ isDialogPlanOpen: false });
    };

    _this.getCards = function () {
      return _this.props.modalSettings.cards.filter(function (card) {
        if (card.availableProductFeatures.length <= 0) {
          return true;
        }
        if (_this.props.productFeatureAvailability) {
          return card.availableProductFeatures.some(function (apf) {
            return _this.props.productFeatureAvailability.includes(apf);
          });
        }
        return false;
      });
    };

    _this.state = { isDialogPlanOpen: false };
    return _this;
  }

  _createClass(CheckoutContainer, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        this.props.fetchOrderSummary();
        (0, _tracking.trackAbandonments)();
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps) {
        if (!(0, _isEqual2['default'])(this.props.productFeatureAvailability, prevProps.productFeatureAvailability)) {
          var cards = this.getCards();
          var isDialogPlanOpen = this.props.modalSettings.showPlanModal && cards.length > 0;

          // eslint-disable-next-line react/no-did-update-set-state
          this.setState({ isDialogPlanOpen: isDialogPlanOpen });
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            loading = _props.loading,
            error = _props.error,
            currentStage = _props.currentStage;
        var _props2 = this.props,
            addressSettings = _props2.addressSettings,
            multipleAddressSettings = _props2.multipleAddressSettings,
            modemDeliveryName = _props2.modemDeliveryName,
            identificationSettings = _props2.identificationSettings,
            ownerSettings = _props2.ownerSettings,
            paymentSettings = _props2.paymentSettings,
            personalSettings = _props2.personalSettings,
            modemDeliverySettings = _props2.modemDeliverySettings,
            modalSettings = _props2.modalSettings,
            planSettings = _props2.planSettings,
            stageSettings = _props2.stageSettings,
            submitSettings = _props2.submitSettings,
            successSettings = _props2.successSettings,
            summarySettings = _props2.summarySettings,
            genericError = _props2.genericError,
            phoneNumber = _props2.phoneNumber;

        var cards = this.getCards();

        if (error) {
          return _jsx('div', {
            className: _styles2['default'].wrapper
          }, void 0, _jsx(_ErrorScreen2.default, {
            text: genericError,
            phoneNumber: phoneNumber
          }));
        }

        var stage = void 0;
        switch (currentStage) {
          case _constants.STAGE_CHECK_ADDRESS:
          case _constants.STAGE_WAITLIST:
            stage = _react2['default'].createElement(_AddressCheckStage2['default'], _extends({ isLoading: loading, phoneNumber: phoneNumber }, addressSettings));
            break;
          case _constants.STAGE_CLARIFY_ADDRESS:
            stage = _react2['default'].createElement(_MultipleAddressStage2['default'], multipleAddressSettings);
            break;
          case _constants.STAGE_PLAN_SELECT:
          case _constants.STAGE_OWNER_CHECK:
            if (this.state.isDialogPlanOpen) {
              stage = _react2['default'].createElement(_DialogPlan2['default'], _extends({
                isOpen: true,
                onClose: this.onCloseDialogPlan
              }, modalSettings, {
                cards: cards
              }));
            } else {
              stage = currentStage === _constants.STAGE_PLAN_SELECT ? _react2['default'].createElement(_PlanSelectionStage2['default'], planSettings) : _react2['default'].createElement(_OwnerCheckStage2['default'], ownerSettings);
            }
            break;
          case _constants.STAGE_MODEM_SELECT:
            stage = _jsx(_ModemStage2.default, {
              modemSettings: modemDeliverySettings
            });
            break;
          case _constants.STAGE_PERSONAL:
            stage = _react2['default'].createElement(_PersonalInfoStage2['default'], _extends({}, personalSettings, {
              modemDeliveryName: modemDeliveryName
            }));
            break;
          case _constants.STAGE_IDENTIFICATION:
            stage = _react2['default'].createElement(_IdentificationStage2['default'], identificationSettings);
            break;
          case _constants.STAGE_PAYMENT:
            stage = _react2['default'].createElement(_PaymentStage2['default'], _extends({}, paymentSettings, {
              stageSettings: stageSettings,
              summarySettings: summarySettings
            }));
            break;
          case _constants.STAGE_SUBMIT:
            stage = _react2['default'].createElement(_SubmitStage2['default'], submitSettings);
            break;
          case _constants.STAGE_SUCCESS:
            return _jsx('div', {
              'data-stage': _constants.STAGE_SUCCESS
            }, void 0, _react2['default'].createElement(_SuccessStage2['default'], _extends({}, successSettings, {
              stageSettings: stageSettings,
              summarySettings: summarySettings
            })));
          case null:
            stage = _ref;
            break;
          default:
            stage = 'Invalid stage ' + currentStage;
        }
        return _jsx('div', {
          className: _styles2['default'].wrapper,
          'data-stage': currentStage
        }, void 0, currentStage && _jsx(_OrderSummary2.default, {
          currentStage: currentStage,
          stageSettings: stageSettings,
          summarySettings: summarySettings
        }), _jsx(_StageIndicator2.default, {
          stages: _constants.STAGES,
          currentStage: currentStage,
          settings: stageSettings
        }), stage);
      }

      return render;
    }()
  }]);

  return CheckoutContainer;
}(_react.Component);

CheckoutContainer.defaultProps = {
  loading: true,
  error: false,
  currentStage: null,
  addressSettings: {},
  modemDeliveryName: '',
  modalSettings: {},
  multipleAddressSettings: {},
  ownerSettings: {},
  paymentSettings: {},
  personalSettings: {},
  planSettings: {},
  stageSettings: {},
  submitSettings: {},
  modemDeliverySettings: {},
  summarySettings: {},
  successSettings: {},
  genericError: _constants.DEFAULT_RESPONSE_ERROR,
  phoneNumber: undefined,
  identificationSettings: {},

  fetchOrderSummary: function () {
    function fetchOrderSummary(f) {
      return f;
    }

    return fetchOrderSummary;
  }(),
  productFeatureAvailability: []
};

function mapStateToProps(state) {
  // whatever is returned will show up as props
  return {
    loading: state.checkoutReducer.isLoading,
    error: state.checkoutReducer.error,
    currentStage: state.checkoutReducer.currentStage,
    addressResult: state.checkoutReducer.addressResult,
    productFeatureAvailability: state.checkoutReducer.productFeatureAvailability
  };
}

// Anything returned from this function will end up as props
function mapDispatchToProps(dispatch) {
  // Whenever dispatch is called the result should be passed
  // to all of the reducers
  return (0, _redux.bindActionCreators)({ fetchOrderSummary: _actions.fetchOrderSummary }, dispatch);
}

// To promote a component to a container (smart component) - it needs
// to know about this new dispatch method. Make it available as a prop.
exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CheckoutContainer);

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ENABLE_DEV_TOOLS = exports.ENABLE_DEV_TOOLS = "production" === 'development';

/* Internet Explorer 6-11 */
var isIE = exports.isIE = false || !!document.documentMode;
/* Edge 20+ */
var isEdge = exports.isEdge = !isIE && !!window.StyleMedia;

var TABLET_BREAKPOINT = exports.TABLET_BREAKPOINT = 640;

/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

var _braintreeWeb = __webpack_require__(683);

var _braintreeWeb2 = _interopRequireDefault(_braintreeWeb);

var _reactRedux = __webpack_require__(23);

var _redux = __webpack_require__(27);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(37);

var _classnames2 = _interopRequireDefault(_classnames);

var _tracking = __webpack_require__(28);

var _tracking2 = _interopRequireDefault(_tracking);

var _ErrorScreen = __webpack_require__(133);

var _ErrorScreen2 = _interopRequireDefault(_ErrorScreen);

var _OrderSummaryPaymentScreen = __webpack_require__(272);

var _OrderSummaryPaymentScreen2 = _interopRequireDefault(_OrderSummaryPaymentScreen);

var _actions = __webpack_require__(31);

var checkoutActions = _interopRequireWildcard(_actions);

var _BrandedButton = __webpack_require__(47);

var _BrandedButton2 = _interopRequireDefault(_BrandedButton);

var _BackButton = __webpack_require__(134);

var _BackButton2 = _interopRequireDefault(_BackButton);

var _cvc3Icon = __webpack_require__(696);

var _cvc3Icon2 = _interopRequireDefault(_cvc3Icon);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(168);

var _styles = __webpack_require__(697);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _ref2 = _jsx('input', {
  type: 'hidden',
  name: 'payment_method_nonce'
});

var _ref3 = _jsx('div', {
  className: 'hostedField',
  id: 'cc-name'
});

var _ref4 = _jsx('span', {
  className: 'hide-feedback'
}, void 0, 'Please enter a valid card holder name');

var _ref5 = _jsx('div', {
  className: 'hostedField',
  id: 'cc-number'
});

var _ref6 = _jsx('span', {
  className: 'hide-feedback'
}, void 0, 'Please enter a valid credit card number');

var _ref7 = _jsx('div', {
  className: 'hostedField',
  id: 'cc-expiration'
});

var _ref8 = _jsx('span', {
  className: 'hide-feedback'
}, void 0, 'Please enter a valid expiry date');

var _ref9 = _jsx('div', {
  className: 'hostedField',
  id: 'cc-cvc'
}, void 0, _jsx('img', {
  className: 'cardIcon',
  src: _cvc3Icon2['default'],
  alt: 'cvn3'
}));

var _ref10 = _jsx('span', {
  className: 'hide-feedback'
}, void 0, 'Please enter a valid CVV');

var _ref11 = _jsx('div', {
  className: 'clearfix'
});

var _ref12 = _jsx(_ErrorScreen2.default, {});

var PaymentStage = function () {
  function PaymentStage(_ref) {
    var title = _ref.title,
        text = _ref.text,
        textNocharge = _ref.textNocharge,
        buttonText = _ref.buttonText,
        termsText = _ref.termsText,
        nbnTermsText = _ref.nbnTermsText,
        paymentProcessing = _ref.paymentProcessing,
        paymentError = _ref.paymentError,
        paymentErrorMessage = _ref.paymentErrorMessage,
        paymentDeclined = _ref.paymentDeclined,
        paymentDeclinedMessage = _ref.paymentDeclinedMessage,
        totalUpfront = _ref.totalUpfront,
        stageSettings = _ref.stageSettings,
        summarySettings = _ref.summarySettings,
        paymentSubmit = _ref.paymentSubmit,
        transitionToStage = _ref.transitionToStage;

    var _useState = (0, _react.useState)(true),
        _useState2 = _slicedToArray(_useState, 2),
        isLoading = _useState2[0],
        setIsLoading = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        _useState4 = _slicedToArray(_useState3, 2),
        brainTreeError = _useState4[0],
        setBrainTreeError = _useState4[1];

    var _useState5 = (0, _react.useState)(),
        _useState6 = _slicedToArray(_useState5, 2),
        clientToken = _useState6[0],
        setClientToken = _useState6[1];

    var _useState7 = (0, _react.useState)(),
        _useState8 = _slicedToArray(_useState7, 2),
        reqId = _useState8[0],
        setReqId = _useState8[1];

    var _useState9 = (0, _react.useState)(),
        _useState10 = _slicedToArray(_useState9, 2),
        hostedFields = _useState10[0],
        setHostedFields = _useState10[1];

    var _useState11 = (0, _react.useState)(false),
        _useState12 = _slicedToArray(_useState11, 2),
        termsChecked = _useState12[0],
        setTermsChecked = _useState12[1];

    var showFeedbackClass = function () {
      function showFeedbackClass(element, show) {
        // Adding css to hosted fields to show or hide invalid feedback
        if (show) {
          element.classList.add('show-feedback');
          element.classList.remove('hide-feedback');
        } else {
          element.classList.remove('show-feedback');
          element.classList.add('hide-feedback');
        }
      }

      return showFeedbackClass;
    }();

    var setValidityClasses = function () {
      function setValidityClasses(element, validity) {
        // Adding css to hosted fields to show or remove custom validity
        if (!validity) {
          element.classList.add('custom-invalid');
        } else {
          element.classList.remove('custom-invalid');
        }
      }

      return setValidityClasses;
    }();

    // generate braintree clientToken on initial load
    (0, _react.useEffect)(function () {
      _axios2['default'].get(_constants.API_PAYMENT_URL).then(function (response) {
        if (response.data && response.data.success) {
          setClientToken(response.data.token);
          setReqId(response.data.reqId);
        } else {
          setIsLoading(false);
          setBrainTreeError(true);
          (0, _tracking2['default'])('Error', {
            event_category: 'Payment',
            event_label: 'Error Loading Client Token',
            non_interaction: true
          });
        }
      })['catch'](function () {
        setIsLoading(false);
        setBrainTreeError(true);
        (0, _tracking2['default'])('Error', {
          event_category: 'Payment',
          event_label: 'Init Network Error',
          non_interaction: true
        });
      });
    }, []);

    // once braintree clientToken is available then generate braintree hostedFields
    (0, _react.useEffect)(function () {
      if (clientToken) {
        // 1. Create braintree client
        _braintreeWeb2['default'].client.create({ authorization: clientToken })['catch'](function () {
          setIsLoading(false);
          setBrainTreeError(true);
        }).then(function (clientInstance) {
          // 2. Create braintree hosted fields
          var options = {
            client: clientInstance,
            styles: {
              input: {
                'font-size': '1rem',
                'font-family': 'Boing", Helvetica, Arial, sans-serif',
                color: '#888888'
              }
            },
            fields: {
              cardholderName: {
                selector: '#cc-name'
              },
              number: {
                selector: '#cc-number',
                supportedCardBrands: {
                  'diners-club': false
                }
              },
              cvv: {
                selector: '#cc-cvc'
              },
              expirationDate: {
                selector: '#cc-expiration',
                placeholder: 'MM / YY'
              }
            }
          };
          return _braintreeWeb2['default'].hostedFields.create(options);
        }).then(function (instance) {
          // 3. Add event listeners to braintree hosted fields
          setIsLoading(false);
          setHostedFields(instance);
          // treat empty hosted fields as invalid
          instance.on('empty', function (e) {
            var element = e.fields[e.emittedBy].container;
            setValidityClasses(element, false);
            showFeedbackClass(element.nextSibling, true);
          });
          // when hosted fields toggle between invalid and valid
          instance.on('validityChange', function (e) {
            var field = e.fields[e.emittedBy];
            var element = field.container;
            if (field.isValid) {
              setValidityClasses(element, true);
              showFeedbackClass(element.nextSibling, false);
            } else {
              setValidityClasses(element, false);
              showFeedbackClass(element.nextSibling, true);
            }
          });
        })['catch'](function () {
          setBrainTreeError(true);
          setIsLoading(false);
          (0, _tracking2['default'])('Error', {
            event_category: 'Payment',
            event_label: 'Error Loading Hosted Fields',
            non_interaction: true
          });
        });
      }
    }, [clientToken]);

    var onBack = function () {
      function onBack() {
        transitionToStage(_constants.STAGE_PERSONAL);
      }

      return onBack;
    }();

    var isFormValid = function () {
      function isFormValid() {
        var currState = hostedFields.getState();
        return Object.keys(currState.fields).reduce(function (result, key) {
          if (!currState.fields[key].isValid) {
            var element = currState.fields[key].container;
            setValidityClasses(element, false);
            showFeedbackClass(element.nextSibling, true);
            var formElement = element.parentElement;
            formElement.scrollIntoView();
            return result && false;
          }

          return result && true;
        }, true);
      }

      return isFormValid;
    }();

    var onSubmit = function () {
      function onSubmit(e) {
        e.preventDefault();

        if (isFormValid()) {
          var options = { vault: true };
          hostedFields.tokenize(options)
          // 1. tokenize hosted fields
          ['catch'](function () {
            setBrainTreeError(true);
            (0, _tracking2['default'])('Error', {
              event_category: 'Payment',
              event_label: 'Error Tokenize Hosted Fields',
              non_interaction: true
            });
          })
          // 2. Valuting the card and submit payment
          .then(function (tokenizePayload) {
            paymentSubmit(reqId, tokenizePayload.nonce);
          });
        }
      }

      return onSubmit;
    }();

    var onTermsSelect = function () {
      function onTermsSelect() {
        setTermsChecked(function (prevState) {
          return !prevState;
        });
      }

      return onTermsSelect;
    }();

    var toRender = _jsx('div', {
      className: _styles2['default'].stageWrapper
    }, void 0, _jsx('div', {
      className: _styles2['default'].summaryWrapper
    }, void 0, _jsx(_OrderSummaryPaymentScreen2.default, {
      stageSettings: stageSettings,
      summarySettings: summarySettings
    })), _jsx('div', {
      className: _styles2['default'].paymentWrapper
    }, void 0, _jsx('h2', {}, void 0, title), _jsx('div', {
      dangerouslySetInnerHTML: { __html: text }
    }), !totalUpfront && _jsx('div', {
      dangerouslySetInnerHTML: { __html: textNocharge }
    }), _jsx('form', {
      className: _styles2['default'].creditCardForm,
      method: 'POST',
      action: '/',
      onSubmit: onSubmit
    }, void 0, _ref2, _jsx('label', {
      htmlFor: 'cc-name',
      className: _styles2['default'].label,
      id: 'cc-name-label'
    }, void 0, _jsx('span', {
      className: _styles2['default'].labelText
    }, void 0, 'Cardholder Name'), _ref3, _ref4), _jsx('label', {
      htmlFor: 'cc-number',
      className: _styles2['default'].label,
      id: 'cc-number-label'
    }, void 0, _jsx('span', {
      className: _styles2['default'].labelText
    }, void 0, 'Credit Card Number'), _ref5, _ref6), _jsx('label', {
      htmlFor: 'cc-expiration',
      className: _styles2['default'].label,
      id: 'cc-expiration-label'
    }, void 0, _jsx('span', {
      className: _styles2['default'].labelText
    }, void 0, 'Expiration'), _ref7, _ref8), _jsx('label', {
      htmlFor: 'cc-cvc',
      className: _styles2['default'].label,
      id: 'cc-cvc-label'
    }, void 0, _jsx('span', {
      className: _styles2['default'].labelText
    }, void 0, 'CVN'), _ref9, _ref10), _jsx('div', {
      className: (0, _classnames2['default'])(_styles2['default'].termsConditions, _defineProperty({}, _styles2['default'].complete, termsChecked))
    }, void 0, _jsx('label', {
      className: _styles2['default'].termsTextAsLabel,
      htmlFor: 'checkTerms',
      id: 'checkTerms-label'
    }, void 0, _jsx('button', {
      className: _styles2['default'].checkIcon,
      type: 'button',
      onClick: onTermsSelect,
      id: 'checkTerms',
      disabled: isLoading
    }), _jsx('div', {
      className: _styles2['default'].termsText,
      dangerouslySetInnerHTML: { __html: termsText }
    }), !termsChecked && _jsx('span', {
      className: _styles2['default'].required
    }, void 0, 'This field is required'))), _jsx('div', {
      className: _styles2['default'].buttonWrapper
    }, void 0, _jsx(_BackButton2.default, {
      className: _styles2['default'].backButton,
      onClick: onBack
    }), _jsx(_BrandedButton2.default, {
      className: _styles2['default'].submitButton,
      type: 'submit',
      labelText: buttonText,
      iconName: 'creditCard',
      loading: paymentProcessing || isLoading,
      disabled: !termsChecked || brainTreeError
    }))), _jsx('div', {
      className: _styles2['default'].nbnDisclaimer
    }, void 0, _jsx('div', {
      className: _styles2['default'].nbnDisclaimerText,
      dangerouslySetInnerHTML: { __html: nbnTermsText }
    })), paymentError && _jsx('div', {
      className: _styles2['default'].error
    }, void 0, _jsx('i', {
      className: _styles2['default'].errorIcon
    }), _jsx('div', {
      className: _styles2['default'].errorText,
      dangerouslySetInnerHTML: { __html: paymentErrorMessage }
    })), paymentDeclined && _jsx('div', {
      className: _styles2['default'].error
    }, void 0, _jsx('i', {
      className: _styles2['default'].errorIcon
    }), _jsx('div', {
      className: _styles2['default'].errorText,
      dangerouslySetInnerHTML: { __html: paymentDeclinedMessage }
    }))), _ref11);

    if (brainTreeError) {
      return _ref12;
    }

    return toRender;
  }

  return PaymentStage;
}();

PaymentStage.defaultProps = {
  paymentError: false,
  paymentDeclined: false,
  paymentProcessing: false,
  totalUpfront: 0,
  title: 'Payment',
  text: null,
  textNocharge: null,
  buttonText: 'CONFIRM & PAY',
  termsText: 'Terms and conditions text',
  nbnTermsText: 'Speeds may vary',
  paymentErrorMessage: _constants.DEFAULT_RESPONSE_ERROR,
  paymentDeclinedMessage: _constants.DEFAULT_RESPONSE_DECLINED,
  stageSettings: {},
  summarySettings: {},
  paymentSubmit: function () {
    function paymentSubmit(f) {
      return f;
    }

    return paymentSubmit;
  }(),
  transitionToStage: function () {
    function transitionToStage(f) {
      return f;
    }

    return transitionToStage;
  }()
};

var mapStateToProps = function () {
  function mapStateToProps(state) {
    return {
      paymentError: state.checkoutReducer.paymentError,
      paymentDeclined: state.checkoutReducer.paymentDeclined,
      paymentProcessing: state.checkoutReducer.paymentProcessing,
      totalUpfront: (0, _utils.calculateUpfront)(state)
    };
  }

  return mapStateToProps;
}();

var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
      paymentSubmit: checkoutActions.paymentSubmit,
      transitionToStage: checkoutActions.transitionToStage
    }, dispatch);
  }

  return mapDispatchToProps;
}();

exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PaymentStage);

/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = __webpack_require__(687);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx('span', {}, void 0, 'Customer Service');

var ContactPhone = function (_PureComponent) {
  _inherits(ContactPhone, _PureComponent);

  function ContactPhone() {
    _classCallCheck(this, ContactPhone);

    return _possibleConstructorReturn(this, (ContactPhone.__proto__ || Object.getPrototypeOf(ContactPhone)).apply(this, arguments));
  }

  _createClass(ContactPhone, [{
    key: 'render',
    value: function () {
      function render() {
        var phoneNumber = this.props.phoneNumber;


        return _jsx('div', {
          className: _styles2['default'].contact
        }, void 0, _ref, _jsx('h2', {
          className: _styles2['default'].contactHeading
        }, void 0, _jsx('a', {
          href: 'tel:' + phoneNumber
        }, void 0, phoneNumber)));
      }

      return render;
    }()
  }]);

  return ContactPhone;
}(_react.PureComponent);

ContactPhone.defaultProps = {
  phoneNumber: '1300 123 455'
};
exports['default'] = ContactPhone;

/***/ }),

/***/ 687:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contact":"_1U-e3","contactHeading":"_1Nams"};

/***/ }),

/***/ 688:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2PM8v","content":"WmIrw","actionLink":"_3_qQH"};

/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalizeFirstLetter = capitalizeFirstLetter;
function capitalizeFirstLetter(string) {
  return "" + string.charAt(0).toUpperCase() + string.slice(1);
}

exports["default"] = capitalizeFirstLetter;

/***/ }),

/***/ 690:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"orderSummaryPayment":"pERk9","separator":"_3avDW","wrapper":"oHcwB","primaryInfo":"_1wgRm","heading":"_3ua75","itemInfoSecondary":"_3wXTy"};

/***/ }),

/***/ 691:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"icon":"QUlHw","heading":"_2kEOh","itemContainer":"TFqZO","wrapper":"_1w6pS","ownsService":"_34ovy","itemInfoMain":"_3Fx9V","itemInfoSecondary":"ZS2UQ","editButton":"_1keuu"};

/***/ }),

/***/ 692:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"icon":"_3NVqT","image":"_288IN","heading":"_1xVHU","itemContainer":"_2sbcS","itemInfoMain":"_1UlHz","itemInfoSecondary":"_3Yazz","children":"_1x4sv"};

/***/ }),

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Address
var OWNER_OF_SERVICE = exports.OWNER_OF_SERVICE = 'Owner of this service';
var NOT_OWNER_OF_SERVICE = exports.NOT_OWNER_OF_SERVICE = 'Does not own this service';

/***/ }),

/***/ 694:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"orderSummaryPayment":"_3EFs8","orderTotal":"_2YQhL","heading":"_3FngK","expandedDisplay":"_2SjEi","extraInfo":"_2I6qI","summaryItem":"_3BpkI","summaryItemLarge":"_15AR4","ownServiceBase":"_1DJme","ownsService":"_1PTKz"};

/***/ }),

/***/ 695:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"back":"B6yr0"};

/***/ }),

/***/ 696:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAAAwCAYAAAC/gkysAAAAAXNSR0IArs4c6QAABD9JREFUaAXtm11IY0cUx/83BlGiFRWFCoLok7hPIoIPIi55EhTBB6WEosT60UpBfCmi+IUoyIIUt4hUwSIF9UHBR0sx+CCCH4grKAr6ZEHxA3GN+JWec0kvTnI107BkN3dnYDJnzpyZZH6cO/dm7hwN/uTz+bSNjY16Kt2apr2h0vFf29dcEouPxOIDleP5+fm/U+ljHhp/rK2tfUuKKTJ4Gxsb+xgXFxdDiZu++vT4+Ijb29vHu7u7GGL0NzFyFRQU/GMngT1tigiVpKenIyEhQRELdpeY6+trnJ6elvgdzKmtr6//QPDG/NCCuyiNQYDhnZycgOA12Aiamy9P8jTDQAnmBJgRs2JmNqL3htc0c1OlDSTArJgZr3GOq6srcFZJmoDDJm2qDAUCCpyAQ76iwMmzEiwVOAGHfEWBk2clWCpwAg75igInz0qwVOAEHPIVBU6elWCpwAk45CsKnDwrwdLOteTkZD0LLapiSuDi4gKcdXCmFl+y8rc/I/frfvzO9LuiEpzvfeTAabLgaL8J8fHxppQ/h9Lr9fKef9BX23/+Ht/80hik/1QK77sJeN+Nvzicujm8iOb1BkuBa2xsxNbWljDjiYkJlJeXo7q6GvPz87i/v9fbj4+PwfZOpxOdnZ3Y3d0V+oWqWALcwsICGhoaMDY2hsvLS2PO09PT6OnpQVVVFVpaWtDV1QUGyYlh0u43BgcHYbfb4XK5jH4yQlTeHAIntr29DYfDgcTERKFpcXERra2tqK2t1fX19fWYmZlBTU2N/qpgdHQUNpsNWVlZ6Ovrw/n5OVJSUoQxXqpYAlx7e7s+v7m5OWGevb29SEpKMnTLy8soLi7Wdfv7+3h4eAC9U8bIyIiul4XGA1riUjXIBAgZGRm6J97c3KCpqQmrq6twu92GFb+gYu+bnJxEYWEhnp6ejLZQgqXB8eR3dnaQl5eHs7MzbG5uIjMz02DCHnZwcKDn4eFhLC0tGW2hBEuDYygVFRUYGhrC7OyssX7R6QXU1dUZbHJyclBUVITDw0NDF0qwNLj+/n79MaSsrAx8uXLmh2n2QH408Xg8Oh9e73itq6ysDMXLaLfEzcGYTYCwsrKCvb09DAwMGC10VAvscW1tbSgtLUV2drb+WNLd3Y3U1FTDLpRgKXBHR0fCfF97qO3o6EBzc7N+iCY3N1foJ1MJAseubPbfUGawaLNhD/s/XvZ8fpZe455P9FPLClyYRIMu1TDHiXi3h1//wDnlz5WiEpz2k/mubCQhRiU4vLArG0lwao0Lk7YCp8CFSSDMbnx4+iMHQagkR4BZMTM+rv+B/ikocnLc9CgbZsYeN87hNhz8oNLrBJiRPzRpXCN6HJL0F3UpSUtLi1GBIubw/CFJfGV6aIfFaSeP81EQnIvKKQq3eUtviVQQ3DN2AUFwHnI0ZuXTowfZzu95KuzyGTQWCZJp2OW/PqaZCDhzxHcAAAAASUVORK5CYII="

/***/ }),

/***/ 697:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"stageWrapper":"_3Ney-","paymentWrapper":"_1qfU1","creditCardForm":"_1cUjw","label":"_1sp20","labelText":"_1pziw","buttonWrapper":"_2rAvR","backButton":"_3SZco","submitButton":"_1iDi-","summaryWrapper":"_3glJx","frame":"_38h4X","error":"_3nAhd","errorText":"_2mv9q","errorIcon":"_23kgX","paymentSummary":"JRzH_","termsConditions":"_1KM2A","checkIcon":"CutLl","complete":"YFEpC","current":"_3ypuI","termsText":"_31Wkj","termsTextAsLabel":"_3-eaP","required":"N88sG","nbnDisclaimer":"_3JUxR","nbnDisclaimerText":"_10bWy"};

/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(23);

var _redux = __webpack_require__(27);

var _GenericStatusLoading = __webpack_require__(79);

var _GenericStatusLoading2 = _interopRequireDefault(_GenericStatusLoading);

var _ErrorScreen = __webpack_require__(133);

var _ErrorScreen2 = _interopRequireDefault(_ErrorScreen);

var _BackButton = __webpack_require__(134);

var _BackButton2 = _interopRequireDefault(_BackButton);

var _constants = __webpack_require__(29);

var _actions = __webpack_require__(31);

var _utils = __webpack_require__(125);

var _constants2 = __webpack_require__(277);

var _actions2 = __webpack_require__(169);

var _styles = __webpack_require__(699);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref2 = _jsx(_GenericStatusLoading2.default, {});

var IdentificationStage = function (_PureComponent) {
  _inherits(IdentificationStage, _PureComponent);

  function IdentificationStage(props) {
    _classCallCheck(this, IdentificationStage);

    var _this = _possibleConstructorReturn(this, (IdentificationStage.__proto__ || Object.getPrototypeOf(IdentificationStage)).call(this, props));

    _this.onBack = function () {
      _this.props.transitionToStage(_constants.STAGE_PERSONAL);
    };

    _this.handleTrackingOnFocus = function (e) {
      var name = e.target.name || e.target.id;
      var time = _this.fieldFocusTimes[name];
      if (time) return time;

      time = new Date().getTime();
      _this.fieldFocusTimes[name] = time;
      return time;
    };

    _this.attachFormAnalytics = function () {
      // Timeout required for GreenID to init
      var loading = !_this.holder || !_this.holder.querySelector('#greenid-source-body') || !_this.holder.querySelector('#greenid-source-body').children.length;
      if (loading) {
        _this.analyticsTimeout = setTimeout(function () {
          _this.attachFormAnalytics();
        }, 300);
        return;
      }
      _this.holder.addEventListener('focus', function (event) {
        if (event.target.matches('input[type="text"]')) {
          _this.handleTrackingOnFocus(event);
        }
      }, true);
      _this.holder.addEventListener('blur', function (event) {
        if (event.target.matches('input[type="text"]')) {
          (0, _utils.handleTrackingOnBlur)(event, _constants2.GA_EVENT_CATEGORY, _this.fieldFocusTimes[event.target.name || event.target.id]);
        }
      }, true);
      _this.holder.addEventListener('change', function (event) {
        if (event.target.matches('input[type="checkbox"]')) {
          (0, _utils.handleTrackingOnChange)(event, _constants2.GA_EVENT_CATEGORY, _this.fieldFocusTimes[event.target.name || event.target.id]);
        }
      }, true);
    };

    _this.errorCallback = _this.errorCallback.bind(_this);
    _this.sessionCompleteCallback = _this.sessionCompleteCallback.bind(_this);
    _this.holder = null;
    _this.state = {
      simpleUILoaded: false,
      formComplete: false,
      hasFatalError: false // needs page reload
    };
    _this.fieldFocusTimes = {};
    _this.analyticsTimeout = null;
    return _this;
  }

  _createClass(IdentificationStage, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        this.checkGreenIdLoaded();
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(newProps) {
        var _this2 = this;

        var greenidAccountID = newProps.greenidAccountID,
            greenidAPICode = newProps.greenidAPICode,
            identificationVerificationToken = newProps.identificationVerificationToken;

        if (newProps.identificationVerificationToken && !this.state.simpleUILoaded) {
          window.greenidUI.setup({
            environment: this.props.greenidProduction ? 'prod' : 'test',
            frameId: 'greenid-holder',
            country: 'AU',
            sessionCompleteCallback: this.sessionCompleteCallback,
            errorCallback: this.errorCallback
          });

          window.greenidUI.show(greenidAccountID, greenidAPICode, identificationVerificationToken);
          this.setState({ simpleUILoaded: true }, function () {
            _this2.attachFormAnalytics();
          });
        }
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        if (this.holder) {
          this.holder.removeEventListener('blur', _utils.handleTrackingOnBlur);
          this.holder.removeEventListener('change', _utils.handleTrackingOnBlur);
        }
        if (this.analyticsTimeout) {
          clearTimeout(this.analyticsTimeout);
        }
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'checkGreenIdLoaded',
    value: function () {
      function checkGreenIdLoaded() {
        var _this3 = this;

        if (!window.greenidUI) {
          setTimeout(function () {
            return _this3.checkGreenIdLoaded();
          }, 300);
        } else {
          // Overriding greenID Defaults
          window.greenidConfig.setOverrides({
            enable_save_and_complete_later: false,
            intro_title: '<h2>' + this.props.title + '</h2>',
            onesourceleft_alert_text: '',
            intro_introText0: this.props.text,
            submit_button_text: 'Continue',
            modal_error_cancel_button: 'Back ',

            // Australian Visa overrides
            visadvs_short_title: _constants2.TEXT_INTERNATIONAL_VISA,
            visadvs_title: _constants2.TEXT_INTERNATIONAL_VISA,
            visadvs_verifiedStr: _constants2.TEXT_INTERNATIONAL_VISA_VERIFIED,
            visadvs_pendingStr: _constants2.TEXT_INTERNATIONAL_VISA_PENDING,
            visadvs_inProgressStr: _constants2.TEXT_INTERNATIONAL_VISA_NO_MATCH,
            visadvs_lockedoutStr: _constants2.TEXT_INTERNATIONAL_VISA_LOCKED,
            visadvs_failedStr: _constants2.TEXT_INTERNATIONAL_VISA_FAILED,
            visadvs_notContributingStr: _constants2.TEXT_INTERNATIONAL_VISA_CONTRIB,
            visadvs_notContributingStr_NC_DVS_D: _constants2.TEXT_INTERNATIONAL_VISA_NO_EFFECT,

            // terms and conditions
            visadvs_tandc_label: this.props.termsText,
            citizenshipcertificatedvs_tandc_label: this.props.termsText,
            passportdvs_tandc_label: this.props.termsText,
            medicaredvs_tandc_label: this.props.termsText,

            /* All The Drivers Regos */
            actregodvs_tandc_label: this.props.termsText,
            nswregodvs_tandc_label: this.props.termsText,
            qldregodvs_tandc_label: this.props.termsText,
            vicregodvs_tandc_label: this.props.termsText,
            saregodvs_tandc_label: this.props.termsText,
            waregodvs_tandc_label: this.props.termsText,
            ntregodvs_tandc_label: this.props.termsText
          });

          this.props.identificationInit();
        }
      }

      return checkGreenIdLoaded;
    }()
  }, {
    key: 'errorCallback',
    value: function () {
      function errorCallback(verificationToken, errorName) {
        if (errorName === 'InvalidTokenFault' || errorName === 'TokenTimeoutFault') {
          this.setState({ hasFatalError: true });
        }
        // sometimes user could have verified before or token already expires,
        // so we ping backend and check whether we should proceed
        this.props.identificationComplete(verificationToken);
      }

      return errorCallback;
    }()
  }, {
    key: 'sessionCompleteCallback',
    value: function () {
      function sessionCompleteCallback(verificationToken) {
        this.setState({ formComplete: true });
        this.props.identificationComplete(verificationToken);
      }

      return sessionCompleteCallback;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this4 = this;

        var greenidContainer = _jsx('div', {}, void 0, _react2['default'].createElement('div', { id: 'greenid-holder', className: 'greenid-holder', ref: function () {
            function ref(_ref) {
              _this4.holder = _ref;
            }

            return ref;
          }() }), _jsx(_BackButton2.default, {
          onClick: this.onBack,
          className: _styles2['default'].backButton
        }));

        if (this.state.hasFatalError) {
          var errorText = '<h2>Something went wrong...</h2>' + '<p>Unfortunately, the verification token is invalid or already expired.</p>';
          return _jsx(_ErrorScreen2.default, {
            text: errorText
          });
        }

        return this.state.simpleUILoaded && !this.state.formComplete ? greenidContainer : _ref2;
      }

      return render;
    }()
  }]);

  return IdentificationStage;
}(_react.PureComponent);

IdentificationStage.defaultProps = {
  greenidProduction: false,
  greenidAccountID: '',
  greenidAPICode: '',
  identificationVerificationToken: '',
  title: 'Verify Your Identity',
  text: '',
  termsText: 'I agree that my above information is checked with the Issuer or Official Record Holder',
  identificationInit: function () {
    function identificationInit(f) {
      return f;
    }

    return identificationInit;
  }(),
  identificationComplete: function () {
    function identificationComplete(f) {
      return f;
    }

    return identificationComplete;
  }(),
  transitionToStage: function () {
    function transitionToStage(f) {
      return f;
    }

    return transitionToStage;
  }()
};


function mapStateToProps(state) {
  return {
    identificationVerificationToken: state.checkoutReducer.identificationVerificationToken
  };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    transitionToStage: _actions.transitionToStage,
    identificationInit: _actions2.identificationInit,
    identificationComplete: _actions2.identificationComplete
  }, dispatch);
}

exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(IdentificationStage);

/***/ }),

/***/ 699:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"backButton":"EZF-h"};

/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonalInfoStageComponent = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(23);

var _redux = __webpack_require__(27);

var _GenericNameField = __webpack_require__(135);

var _GenericNameField2 = _interopRequireDefault(_GenericNameField);

var _PhoneNumberField = __webpack_require__(278);

var _PhoneNumberField2 = _interopRequireDefault(_PhoneNumberField);

var _DateField = __webpack_require__(701);

var _DateField2 = _interopRequireDefault(_DateField);

var _AccountPinField = __webpack_require__(702);

var _AccountPinField2 = _interopRequireDefault(_AccountPinField);

var _EmailField = __webpack_require__(162);

var _EmailField2 = _interopRequireDefault(_EmailField);

var _CollapsiblePanel = __webpack_require__(703);

var _CollapsiblePanel2 = _interopRequireDefault(_CollapsiblePanel);

var _BrandedButton = __webpack_require__(47);

var _BrandedButton2 = _interopRequireDefault(_BrandedButton);

var _BackButton = __webpack_require__(134);

var _BackButton2 = _interopRequireDefault(_BackButton);

var _WithInputAnalytics = __webpack_require__(126);

var _WithInputAnalytics2 = _interopRequireDefault(_WithInputAnalytics);

var _formValidator = __webpack_require__(61);

var _actions = __webpack_require__(31);

var _constants = __webpack_require__(29);

var _actions2 = __webpack_require__(170);

var _constants2 = __webpack_require__(163);

var _styles = __webpack_require__(705);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-danger */


var TrackedGenericNameField = (0, _WithInputAnalytics2['default'])(_constants2.GA_CATEGORY)(_GenericNameField2['default']);
var TrackedDateField = (0, _WithInputAnalytics2['default'])(_constants2.GA_CATEGORY)(_DateField2['default']);
var TrackedPhoneNumberField = (0, _WithInputAnalytics2['default'])(_constants2.GA_CATEGORY)(_PhoneNumberField2['default']);
var TrackedAccountPinField = (0, _WithInputAnalytics2['default'])(_constants2.GA_CATEGORY)(_AccountPinField2['default']);
var TrackedEmailField = (0, _WithInputAnalytics2['default'])(_constants2.GA_CATEGORY)(_EmailField2['default']);

var _ref = _jsx('legend', {}, void 0, 'Enter your personal information');

var _ref2 = _jsx('legend', {}, void 0, 'Choose an account PIN');

var PersonalInfoStageComponent = exports.PersonalInfoStageComponent = function (_Component) {
  _inherits(PersonalInfoStageComponent, _Component);

  function PersonalInfoStageComponent(props) {
    var _extends3;

    _classCallCheck(this, PersonalInfoStageComponent);

    var _this = _possibleConstructorReturn(this, (PersonalInfoStageComponent.__proto__ || Object.getPrototypeOf(PersonalInfoStageComponent)).call(this, props));

    _this.onFieldChange = function (value, fieldname) {
      var fieldValues = _extends({}, _this.state.fieldValues, _defineProperty({}, fieldname, value));
      _this.setState({
        fieldValues: fieldValues
      });
    };

    _this.onFieldFocus = function (event) {
      if (_this.props.fieldError[event.target.name]) {
        _this.props.clearFieldError(event.target.name);
      }
    };

    _this.onFieldChangeHandler = function (event) {
      return _this.onFieldChange(event.target.value, event.target.name);
    };

    _this.onFieldBlur = function (event) {
      if (_this.props.fieldValues[event.target.name] !== _this.state.fieldValues[event.target.name]) {
        _this.props.setFieldValues(_this.state.fieldValues);
      }
    };

    _this.onPersonalInfoSumit = function (event) {
      // We're setting the props equivalent to the state, so state is safe to use as source of truth
      event.preventDefault();
      var valid = (0, _formValidator.validatePersonalInfoForm)(_this.state.fieldValues);

      if (valid === true) {
        _this.props.setFieldErrors({});
        _this.props.submitPersonalInfo(_this.state.fieldValues);
      } else {
        _this.props.setFieldErrors(Object.assign({}, valid === true ? {} : valid));
      }
    };

    _this.onBack = function (event) {
      event.preventDefault();
      _this.props.transitionToStage(_constants.STAGE_MODEM_SELECT);
    };

    _this.state = {
      fieldValues: _extends((_extends3 = {}, _defineProperty(_extends3, _constants2.FIRST_NAME_KEY, ''), _defineProperty(_extends3, _constants2.MIDDLE_NAME_KEY, ''), _defineProperty(_extends3, _constants2.LAST_NAME_KEY, ''), _defineProperty(_extends3, _constants2.PHONE_KEY, ''), _defineProperty(_extends3, _constants2.DATE_BIRTH_KEY, ''), _defineProperty(_extends3, _constants2.ACCOUNT_PIN_KEY, ''), _defineProperty(_extends3, _constants2.EMAIL_KEY, ''), _extends3), props.fieldValues)
    };
    return _this;
  }

  _createClass(PersonalInfoStageComponent, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        if (!this.props.fieldValues[_constants2.ACCOUNT_PIN_KEY]) {
          this.props.loadDetails();
        }
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        // Eg. when the initial state is loaded from the server
        this.setState({
          fieldValues: _extends({}, this.state.fieldValues, nextProps.fieldValues)
        });
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        // When moving to next step, scroll position is below fold
        window.scrollTo(0, 0);
      }

      return componentWillUnmount;
    }()

    /* Field Handlers */


    /* Handle Submission */

  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            fieldError = _props.fieldError,
            isLoading = _props.isLoading,
            askEmail = _props.askEmail,
            title = _props.title,
            text = _props.text,
            buttonText = _props.buttonText,
            accountPinTitle = _props.accountPinTitle,
            accountPinText = _props.accountPinText,
            accountPinInfoTitle = _props.accountPinInfoTitle,
            accountPinInfoText = _props.accountPinInfoText,
            qffImage = _props.qffImage,
            qffInfo = _props.qffInfo;


        var firstNameElement = _jsx(TrackedGenericNameField, {
          fieldName: _constants2.FIRST_NAME_KEY,
          onChange: this.onFieldChangeHandler,
          onBlur: this.onFieldBlur,
          onFocus: this.onFieldFocus,
          value: this.state.fieldValues[_constants2.FIRST_NAME_KEY],
          labelText: 'First Name',
          errorMessage: fieldError[_constants2.FIRST_NAME_KEY],
          loading: isLoading,
          isRequired: true
        });
        var middleNameElement = _jsx(TrackedGenericNameField, {
          fieldName: _constants2.MIDDLE_NAME_KEY,
          onChange: this.onFieldChangeHandler,
          onBlur: this.onFieldBlur,
          onFocus: this.onFieldFocus,
          value: this.state.fieldValues[_constants2.MIDDLE_NAME_KEY],
          labelText: 'Middle Name',
          errorMessage: fieldError[_constants2.MIDDLE_NAME_KEY],
          loading: isLoading
        });
        var lastNameElement = _jsx(TrackedGenericNameField, {
          fieldName: _constants2.LAST_NAME_KEY,
          onChange: this.onFieldChangeHandler,
          onBlur: this.onFieldBlur,
          onFocus: this.onFieldFocus,
          value: this.state.fieldValues[_constants2.LAST_NAME_KEY],
          labelText: 'Last Name',
          errorMessage: fieldError[_constants2.LAST_NAME_KEY],
          loading: isLoading,
          isRequired: true
        });
        var phoneNumberElement = _jsx(TrackedPhoneNumberField, {
          fieldName: _constants2.PHONE_KEY,
          onChange: this.onFieldChangeHandler,
          onBlur: this.onFieldBlur,
          onFocus: this.onFieldFocus,
          value: this.state.fieldValues[_constants2.PHONE_KEY],
          errorMessage: fieldError[_constants2.PHONE_KEY],
          labelText: 'Contact Number',
          loading: isLoading,
          isRequired: true
        });

        // For people coming from NBN's website where they skip email entry eariler in the flow.
        var emailElement = askEmail && _jsx(TrackedEmailField, {
          fieldName: _constants2.EMAIL_KEY,
          onChange: this.onFieldChangeHandler,
          onBlur: this.onFieldBlur,
          onFocus: this.onFieldFocus,
          value: this.state.fieldValues[_constants2.EMAIL_KEY],
          errorMessage: fieldError[_constants2.EMAIL_KEY],
          labelText: 'Email',
          loading: isLoading,
          isRequired: true
        });

        var dateOfBirthElement = _jsx(TrackedDateField, {
          fieldName: _constants2.DATE_BIRTH_KEY,
          onChange: this.onFieldChangeHandler,
          onBlur: this.onFieldBlur,
          onFocus: this.onFieldFocus,
          value: this.state.fieldValues[_constants2.DATE_BIRTH_KEY],
          errorMessage: fieldError[_constants2.DATE_BIRTH_KEY],
          labelText: 'Date of Birth (DD/MM/YYYY)',
          loading: isLoading,
          isRequired: true
        });

        var accountPinElement = _jsx(TrackedAccountPinField, {
          fieldName: _constants2.ACCOUNT_PIN_KEY,
          onChange: this.onFieldChangeHandler,
          onBlur: this.onFieldBlur,
          onFocus: this.onFieldFocus,
          value: this.state.fieldValues[_constants2.ACCOUNT_PIN_KEY],
          labelText: 'PIN',
          errorMessage: fieldError[_constants2.ACCOUNT_PIN_KEY],
          loading: isLoading,
          isRequired: true
        });

        return _jsx('div', {
          className: _styles2['default'].container
        }, void 0, _jsx('h2', {}, void 0, title), _jsx('div', {
          dangerouslySetInnerHTML: { __html: text }
        }), _jsx('form', {
          className: _styles2['default'].formContainer,
          onSubmit: this.onPersonalInfoSumit,
          method: 'POST'
        }, void 0, _jsx('fieldset', {}, void 0, _ref, _jsx('div', {
          className: _styles2['default'].nameFieldWrapper
        }, void 0, _jsx('div', {
          className: _styles2['default'].col
        }, void 0, firstNameElement), _jsx('div', {
          className: _styles2['default'].col
        }, void 0, middleNameElement), _jsx('div', {
          className: _styles2['default'].col
        }, void 0, lastNameElement)), emailElement, phoneNumberElement, dateOfBirthElement), _jsx('fieldset', {}, void 0, _ref2, _jsx('h2', {}, void 0, accountPinTitle), _jsx('div', {
          dangerouslySetInnerHTML: { __html: accountPinText }
        }), _jsx('div', {
          className: _styles2['default'].accountPinFieldWrapper
        }, void 0, accountPinElement), accountPinInfoTitle && _jsx(_CollapsiblePanel2.default, {
          title: accountPinInfoTitle
        }, void 0, _jsx('div', {
          dangerouslySetInnerHTML: { __html: accountPinInfoText }
        }))), _jsx('div', {
          className: _styles2['default'].btnWrap
        }, void 0, _jsx(_BrandedButton2.default, {
          labelText: buttonText,
          className: _styles2['default'].submitBtn
        }), _jsx(_BackButton2.default, {
          onClick: this.onBack
        })), qffImage && _jsx('div', {
          className: _styles2['default'].qffInfoWrapper
        }, void 0, _jsx('img', {
          src: qffImage,
          alt: 'qff'
        }), _jsx('div', {
          dangerouslySetInnerHTML: { __html: qffInfo }
        }))));
      }

      return render;
    }()
  }]);

  return PersonalInfoStageComponent;
}(_react.Component);

PersonalInfoStageComponent.defaultProps = {
  isLoading: false,
  fieldError: {},
  fieldValues: {},
  askEmail: false,
  loadDetails: function () {
    function loadDetails(f) {
      return f;
    }

    return loadDetails;
  }(),
  setFieldErrors: function () {
    function setFieldErrors(f) {
      return f;
    }

    return setFieldErrors;
  }(),
  clearFieldError: function () {
    function clearFieldError(f) {
      return f;
    }

    return clearFieldError;
  }(),
  setFieldValues: function () {
    function setFieldValues(f) {
      return f;
    }

    return setFieldValues;
  }(),
  submitPersonalInfo: function () {
    function submitPersonalInfo(f) {
      return f;
    }

    return submitPersonalInfo;
  }(),
  title: 'Personal Information',
  text: '',
  buttonText: 'Continue',
  accountPinTitle: '4 Digit Account PIN',
  accountPinText: '',
  accountPinInfoTitle: '',
  accountPinInfoText: '',
  qffImage: '',
  qffInfo: '',
  transitionToStage: function () {
    function transitionToStage(f) {
      return f;
    }

    return transitionToStage;
  }()
};


function mapStateToProps(state) {
  return {
    fieldValues: state.checkoutReducer.personalFieldValues,
    fieldError: state.checkoutReducer.personalFieldError,
    isLoading: state.checkoutReducer.isLoading,
    askEmail: !state.checkoutReducer.email
  };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    loadDetails: _actions2.loadDetails,
    setFieldErrors: _actions2.setFieldErrors,
    clearFieldError: _actions2.clearFieldError,
    setFieldValues: _actions2.setFieldValues,
    submitPersonalInfo: _actions2.submitPersonalInfo,
    transitionToStage: _actions.transitionToStage
  }, dispatch);
}

exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PersonalInfoStageComponent);

/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _FormFieldLayout = __webpack_require__(43);

var _FormFieldLayout2 = _interopRequireDefault(_FormFieldLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var DateField = function () {
  function DateField(_ref) {
    var onBlur = _ref.onBlur,
        onFocus = _ref.onFocus,
        onChange = _ref.onChange,
        value = _ref.value,
        loading = _ref.loading,
        errorMessage = _ref.errorMessage,
        fieldName = _ref.fieldName,
        labelText = _ref.labelText,
        isRequired = _ref.isRequired;

    var hasError = !!errorMessage;
    var errorObject = {
      status: hasError,
      message: errorMessage
    };
    var fieldElement = _jsx('input', {
      type: 'text',
      name: fieldName,
      className: 'form-input',
      id: fieldName,
      maxLength: '140',
      value: value,
      onChange: onChange,
      onBlur: onBlur,
      onFocus: onFocus,
      disabled: loading,
      required: isRequired
    });
    return _jsx(_FormFieldLayout2.default, {
      fieldName: fieldName,
      labelText: labelText,
      fieldElement: fieldElement,
      error: errorObject
    });
  }

  return DateField;
}();

DateField.defaultProps = {
  value: '',
  fieldName: 'date',
  labelText: 'Date Field',
  loading: false,
  onBlur: function () {
    function onBlur(f) {
      return f;
    }

    return onBlur;
  }(),
  onFocus: function () {
    function onFocus(f) {
      return f;
    }

    return onFocus;
  }(),
  onChange: function () {
    function onChange(f) {
      return f;
    }

    return onChange;
  }(),
  errorMessage: '',
  isRequired: false
};

exports['default'] = DateField;

/***/ }),

/***/ 702:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _FormFieldLayout = __webpack_require__(43);

var _FormFieldLayout2 = _interopRequireDefault(_FormFieldLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var AccountPinField = function () {
  function AccountPinField(_ref) {
    var onBlur = _ref.onBlur,
        onFocus = _ref.onFocus,
        onChange = _ref.onChange,
        value = _ref.value,
        loading = _ref.loading,
        errorMessage = _ref.errorMessage,
        fieldName = _ref.fieldName,
        labelText = _ref.labelText,
        isRequired = _ref.isRequired;

    var hasError = !!errorMessage;
    var errorObject = {
      status: hasError,
      message: errorMessage
    };
    var onPinChange = function () {
      function onPinChange(event) {
        if (/^\d{0,4}$/.test(event.target.value)) {
          onChange(event);
        }
      }

      return onPinChange;
    }();
    var fieldElement = _jsx('input', {
      type: 'tel',
      name: fieldName,
      className: 'form-input',
      id: fieldName,
      maxLength: '4',
      value: value,
      onChange: onPinChange,
      onBlur: onBlur,
      onFocus: onFocus,
      disabled: loading,
      required: isRequired,
      autoComplete: 'off'
    });
    return _jsx(_FormFieldLayout2.default, {
      fieldName: fieldName,
      labelText: labelText,
      fieldElement: fieldElement,
      error: errorObject
    });
  }

  return AccountPinField;
}();

AccountPinField.defaultProps = {
  value: '',
  fieldName: 'accountPinField',
  labelText: 'PIN',
  loading: false,
  onFocus: undefined,
  onBlur: function () {
    function onBlur(f) {
      return f;
    }

    return onBlur;
  }(),
  onChange: function () {
    function onChange(f) {
      return f;
    }

    return onChange;
  }(),
  errorMessage: '',
  isRequired: false
};

exports['default'] = AccountPinField;

/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(37);

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = __webpack_require__(704);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CollapsiblePanel = function (_PureComponent) {
  _inherits(CollapsiblePanel, _PureComponent);

  function CollapsiblePanel() {
    _classCallCheck(this, CollapsiblePanel);

    return _possibleConstructorReturn(this, (CollapsiblePanel.__proto__ || Object.getPrototypeOf(CollapsiblePanel)).apply(this, arguments));
  }

  _createClass(CollapsiblePanel, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            className = _props.className,
            title = _props.title,
            children = _props.children;

        return _jsx('div', {
          className: (0, _classnames2['default'])(_styles2['default'].panel, className)
        }, void 0, _jsx('input', {
          id: 'collapsible',
          className: _styles2['default'].panel__checkbox,
          type: 'checkbox'
        }), _jsx('label', {
          htmlFor: 'collapsible',
          className: _styles2['default'].panel__label
        }, void 0, title), _jsx('div', {
          className: _styles2['default'].panel__content
        }, void 0, children));
      }

      return render;
    }()
  }]);

  return CollapsiblePanel;
}(_react.PureComponent);

CollapsiblePanel.defaultProps = {
  className: '',
  title: '',
  children: null
};
exports['default'] = CollapsiblePanel;

/***/ }),

/***/ 704:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"panel":"_3jUv1","panel__checkbox":"_15Igv","panel__label":"vMNBw","panel__content":"_3gm1s"};

/***/ }),

/***/ 705:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3WM-W","formContainer":"_1-Uky","btnWrap":"_1ZBWE","nameFieldWrapper":"_31e5e","col":"gfUPW","accountPinFieldWrapper":"_2901u","qffInfoWrapper":"_15X_G"};

/***/ }),

/***/ 706:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModemStageComponent = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(23);

var _redux = __webpack_require__(27);

var _AddressForm = __webpack_require__(256);

var _AddressForm2 = _interopRequireDefault(_AddressForm);

var _BrandedButton = __webpack_require__(47);

var _BrandedButton2 = _interopRequireDefault(_BrandedButton);

var _BackButton = __webpack_require__(134);

var _BackButton2 = _interopRequireDefault(_BackButton);

var _ChoiceField = __webpack_require__(279);

var _ChoiceField2 = _interopRequireDefault(_ChoiceField);

var _FullNameField = __webpack_require__(259);

var _FullNameField2 = _interopRequireDefault(_FullNameField);

var _WithInputAnalytics = __webpack_require__(126);

var _WithInputAnalytics2 = _interopRequireDefault(_WithInputAnalytics);

var _constants = __webpack_require__(29);

var _actions = __webpack_require__(31);

var _formValidator = __webpack_require__(61);

var _constants2 = __webpack_require__(280);

var _actions2 = __webpack_require__(171);

var _styles = __webpack_require__(708);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Add form analytics to fields
var TrackedFullNameField = (0, _WithInputAnalytics2['default'])(_constants2.GA_CATEGORY)(_FullNameField2['default']);
var TrackedChoiceField = (0, _WithInputAnalytics2['default'])(_constants2.GA_CATEGORY)(_ChoiceField2['default']);

var _ref2 = _jsx('div', {}, void 0, 'Use a different address');

var _ref3 = _jsx('span', {}, void 0, 'Where should we deliver your modem to?');

var _ref4 = _jsx('h2', {}, void 0, 'Modem');

var ModemStageComponent = exports.ModemStageComponent = function (_Component) {
  _inherits(ModemStageComponent, _Component);

  function ModemStageComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ModemStageComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ModemStageComponent.__proto__ || Object.getPrototypeOf(ModemStageComponent)).call.apply(_ref, [this].concat(args))), _this), _this.onRequireModemChange = function (event) {
      _this.props.setModemRequired(event.target.value === 'true');
    }, _this.onAddressOptionChange = function (event) {
      _this.props.setDeliverySameAsInstall(event.target.value === 'true');
    }, _this.onFullNameChange = function (event) {
      _this.props.setFieldValues(_defineProperty({}, event.target.name, event.target.value));
    }, _this.onSubmitForm = function (event) {
      event.preventDefault();

      var valid = _this.validate();
      if (valid !== true) {
        _this.props.setFieldErrors(valid);
        return;
      }
      _this.props.submitData();
    }, _this.onBack = function (event) {
      event.preventDefault();
      _this.props.transitionToStage(_constants.STAGE_PLAN_SELECT);
    }, _this.validate = function () {
      var _this$props = _this.props,
          sameAsInstallAddress = _this$props.sameAsInstallAddress,
          modemRequired = _this$props.modemRequired,
          fieldValues = _this$props.fieldValues,
          manualAddress = _this$props.manualAddress;


      if (modemRequired && !sameAsInstallAddress) {
        return (0, _formValidator.validateAddressForm)(fieldValues, manualAddress);
      }
      return true;
    }, _this.renderModemChoice = function () {
      var _this$props2 = _this.props,
          isLoading = _this$props2.isLoading,
          modemSettings = _this$props2.modemSettings,
          modemRequired = _this$props2.modemRequired;


      return _jsx(_react.Fragment, {}, void 0, _jsx(TrackedChoiceField, {
        name: _constants2.REQUIRES_MODEM,
        value: modemRequired,
        onChange: _this.onRequireModemChange,
        loading: isLoading,
        required: true
      }), !modemRequired ? _jsx(_react.Fragment, {}, void 0, _jsx('div', {
        title: 'Modem Compatibility Information'
      }, void 0, ' ', _jsx('div', {
        dangerouslySetInnerHTML: { __html: modemSettings.disclaimer }
      }))) : null);
    }, _this.renderAddressChoice = function () {
      var _this$props3 = _this.props,
          isLoading = _this$props3.isLoading,
          installAddress = _this$props3.installAddress,
          modemRequired = _this$props3.modemRequired,
          sameAsInstallAddress = _this$props3.sameAsInstallAddress;


      if (!modemRequired) return null;

      var address = _jsx('div', {}, void 0, installAddress.length >= 1 && _jsx('div', {}, void 0, installAddress[0], ','), installAddress.length >= 2 && _jsx('div', {
        className: _styles2['default'].addressLine2
      }, void 0, installAddress[1]));

      var diffAddress = _ref2;

      var options = [{ label: address, value: true }, { label: diffAddress, value: false }];

      return _jsx(_react.Fragment, {}, void 0, _ref3, _jsx(TrackedChoiceField, {
        name: _constants2.SAME_AS_INSTALL_ADDRESS,
        options: options,
        value: sameAsInstallAddress,
        onChange: _this.onAddressOptionChange,
        loading: isLoading,
        required: true
      }));
    }, _this.renderAddressSelection = function () {
      var _this$props4 = _this.props,
          modemRequired = _this$props4.modemRequired,
          sameAsInstallAddress = _this$props4.sameAsInstallAddress,
          manualAddress = _this$props4.manualAddress,
          isLoading = _this$props4.isLoading,
          fieldValues = _this$props4.fieldValues,
          fieldErrors = _this$props4.fieldErrors;


      if (!modemRequired) return null;
      if (sameAsInstallAddress) return null;

      return _jsx('div', {
        className: _styles2['default'].modemAddress
      }, void 0, _jsx(TrackedFullNameField, {
        name: _constants2.ATTENTION_TO_KEY,
        onChange: _this.onFullNameChange,
        onBlur: _this.onFullNameChange,
        value: fieldValues[_constants2.ATTENTION_TO_KEY],
        errorMessage: fieldErrors[_constants2.ATTENTION_TO_KEY],
        loading: isLoading,
        required: true
      }), _jsx(_AddressForm2.default, {
        loading: isLoading,
        manual: manualAddress,
        fieldErrors: fieldErrors,
        fieldValues: fieldValues,
        onAddressSelected: _this.props.setFieldValues,
        onFieldUpdated: _this.props.setFieldValues,
        onManualEntry: _this.props.setManualAddress,
        gaCategory: _constants2.GA_CATEGORY
      }));
    }, _this.renderResponseBlock = function () {
      var modemResponseMessage = _this.props.modemResponseMessage;

      return modemResponseMessage ? _jsx('p', {
        className: _styles2['default'].form_error
      }, void 0, modemResponseMessage) : null;
    }, _this.renderButtons = function () {
      return _jsx('div', {
        className: _styles2['default'].btnWrap
      }, void 0, _jsx(_BrandedButton2.default, {
        className: _styles2['default'].submitBtn,
        labelText: 'Continue',
        iconName: 'arrowRight',
        fitContent: true
      }), _jsx(_BackButton2.default, {
        onClick: _this.onBack
      }));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ModemStageComponent, [{
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        // When moving to next step, scroll position is below fold
        window.scrollTo(0, 0);
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var modemChoiceBlock = this.renderModemChoice();
        var addressChoiceBlock = this.renderAddressChoice();
        var addressBlock = this.renderAddressSelection();
        var buttonBlock = this.renderButtons();
        var responseBlock = this.renderResponseBlock();

        return _jsx('div', {
          className: _styles2['default'].container
        }, void 0, _ref4, _jsx('form', {
          className: _styles2['default'].formContainer,
          onSubmit: this.onSubmitForm,
          method: 'POST'
        }, void 0, _jsx('fieldset', {}, void 0, modemChoiceBlock, addressChoiceBlock, addressBlock, buttonBlock, responseBlock)));
      }

      return render;
    }()
  }]);

  return ModemStageComponent;
}(_react.Component);

ModemStageComponent.defaultProps = {

  modemSettings: {
    disclaimer: _constants2.MODEM_DISCLAIMER
  },

  // redux state
  isLoading: false,
  fieldValues: {},
  fieldErrors: {},
  modemRequired: false,
  modemResponseMessage: '',
  sameAsInstallAddress: true,
  manualAddress: false,
  installAddress: [],

  // actions
  transitionToStage: function () {
    function transitionToStage(f) {
      return f;
    }

    return transitionToStage;
  }(),
  setDeliverySameAsInstall: function () {
    function setDeliverySameAsInstall(f) {
      return f;
    }

    return setDeliverySameAsInstall;
  }(),
  setManualAddress: function () {
    function setManualAddress(f) {
      return f;
    }

    return setManualAddress;
  }(),
  setModemRequired: function () {
    function setModemRequired(f) {
      return f;
    }

    return setModemRequired;
  }(),
  setFieldValues: function () {
    function setFieldValues(f) {
      return f;
    }

    return setFieldValues;
  }(),
  setFieldErrors: function () {
    function setFieldErrors(f) {
      return f;
    }

    return setFieldErrors;
  }(),
  submitData: function () {
    function submitData(f) {
      return f;
    }

    return submitData;
  }()
};


function mapStateToProps(state) {
  var _state$checkoutReduce = state.checkoutReducer,
      isLoading = _state$checkoutReduce.isLoading,
      modemRequired = _state$checkoutReduce.modemRequired,
      modemSameAsInstallAddress = _state$checkoutReduce.modemSameAsInstallAddress,
      modemManualAddress = _state$checkoutReduce.modemManualAddress,
      modemResponseMessage = _state$checkoutReduce.modemResponseMessage,
      modemFields = _state$checkoutReduce.modemFields,
      modemErrors = _state$checkoutReduce.modemErrors,
      installAddress = _state$checkoutReduce.installAddress;


  return {
    isLoading: isLoading,
    modemRequired: modemRequired,
    modemResponseMessage: modemResponseMessage,
    installAddress: installAddress,
    fieldValues: modemFields,
    fieldErrors: modemErrors,
    manualAddress: modemManualAddress,
    sameAsInstallAddress: modemSameAsInstallAddress
  };
}

// Anything returned from this function will end up as props
function mapDispatchToProps(dispatch) {
  // bind dispatch to action creators which are then passed through props
  return (0, _redux.bindActionCreators)({
    setDeliverySameAsInstall: _actions2.setDeliverySameAsInstall,
    setManualAddress: _actions2.setManualAddress,
    setModemRequired: _actions2.setModemRequired,
    setFieldValues: _actions2.setFieldValues,
    setFieldErrors: _actions2.setFieldErrors,
    submitData: _actions2.submitData,
    transitionToStage: _actions.transitionToStage
  }, dispatch);
}

exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ModemStageComponent);

/***/ }),

/***/ 707:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"isLoading":"_2Cl4t","wrapper":"_3S7gg","icon":"V0c2o","labelText":"_6Csfk","option":"_2KCe1","error":"_3GnGL","errorText":"_1e0FU"};

/***/ }),

/***/ 708:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"p2K98","formContainer":"_3eVJv","btnWrap":"_9cYir","form_error":"HKcks","choiceImageContainer":"JsUU_","disclaimer":"_3mDYT","addressLine2":"_2CXg9","modemAddress":"r0ouM"};

/***/ }),

/***/ 709:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(23);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _OrderSummaryPaymentScreen = __webpack_require__(272);

var _OrderSummaryPaymentScreen2 = _interopRequireDefault(_OrderSummaryPaymentScreen);

var _QantasFrequentFlyer = __webpack_require__(281);

var _QantasFrequentFlyer2 = _interopRequireDefault(_QantasFrequentFlyer);

var _GoogleMarketing = __webpack_require__(715);

var _GoogleMarketing2 = _interopRequireDefault(_GoogleMarketing);

var _styles = __webpack_require__(717);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-danger */


var SuccessStage = function (_PureComponent) {
  _inherits(SuccessStage, _PureComponent);

  function SuccessStage() {
    _classCallCheck(this, SuccessStage);

    return _possibleConstructorReturn(this, (SuccessStage.__proto__ || Object.getPrototypeOf(SuccessStage)).apply(this, arguments));
  }

  _createClass(SuccessStage, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            title = _props.title,
            successText = _props.successText,
            referenceNumber = _props.referenceNumber,
            nextStepsText = _props.nextStepsText,
            email = _props.email,
            isAppointmentRequired = _props.isAppointmentRequired,
            appointmentRequiredText = _props.appointmentRequiredText,
            footerText = _props.footerText,
            stageSettings = _props.stageSettings,
            referenceTitle = _props.referenceTitle,
            summarySettings = _props.summarySettings,
            qffText = _props.qffText,
            qffSuccessText = _props.qffSuccessText,
            successConversionTracking = _props.successConversionTracking;


        var nextStepsWithEmail = nextStepsText.replace('[EMAIL]', email);

        return _jsx('div', {
          className: _styles2['default'].wrapper
        }, void 0, _jsx(_GoogleMarketing2.default, {
          successConversionTracking: successConversionTracking
        }), _jsx('div', {
          className: _styles2['default'].content
        }, void 0, _jsx('div', {
          className: _styles2['default'].congratulations
        }, void 0, _jsx('h2', {}, void 0, _jsx('i', {
          className: _styles2['default'].greenTick + ' kgn kgn-icon-checkmark'
        }), ' ', title), _jsx('div', {
          dangerouslySetInnerHTML: { __html: successText }
        })), _jsx('div', {
          className: _styles2['default'].referenceWrapper
        }, void 0, _jsx('div', {
          className: _styles2['default'].referenceTitle
        }, void 0, referenceTitle), _jsx('div', {
          className: _styles2['default'].referenceNumber
        }, void 0, referenceNumber)), _jsx('div', {
          className: _styles2['default'].whatsNextWrapper,
          dangerouslySetInnerHTML: { __html: nextStepsWithEmail }
        }), isAppointmentRequired && _jsx('div', {
          className: _styles2['default'].appointmentRequiredText,
          dangerouslySetInnerHTML: { __html: appointmentRequiredText }
        }), _jsx(_QantasFrequentFlyer2.default, {
          isSimplePage: true,
          qffText: qffText,
          successText: qffSuccessText
        }), footerText && _jsx('div', {
          className: _styles2['default'].footerText,
          dangerouslySetInnerHTML: { __html: footerText }
        })), _jsx('div', {
          className: _styles2['default'].orderSummary
        }, void 0, _jsx(_OrderSummaryPaymentScreen2.default, {
          stageSettings: stageSettings,
          summarySettings: summarySettings
        })));
      }

      return render;
    }()
  }]);

  return SuccessStage;
}(_react.PureComponent);

SuccessStage.defaultProps = {
  referenceNumber: 'XXYY3456',
  email: 'test@gmail.com',
  isAppointmentRequired: true,
  title: 'Order Successful',
  successText: 'Thanks for placing an order with Kogan Internet',
  nextStepsText: "<h2>WHAT'S NEXT?</h2>" + "<div>We've just sent a confirmation email for your order to [EMAIL]</div>" + '<div>If you have any questions or need more help' + ' please call us on <strong>1300 000 000</strong></div>',
  appointmentRequiredText: 'An appointment will be required for installation',
  qffText: '<p style="text-align: center;">You can link your Qantas Frequent Flyer number to earn Qantas Points' + ' on this order and future orders from Kogan Internet.</p>',
  qffSuccessText: 'You have successfully linked you Qantas Frequent Flyer number to Kogan Internet.',
  footerText: '',
  referenceTitle: 'Customer Reference',
  successConversionTracking: [],
  stageSettings: {},
  summarySettings: {}
};

function mapStateToProps(state) {
  // whatever is returned will show up as props
  return {
    email: state.checkoutReducer.email,
    isAppointmentRequired: state.checkoutReducer.appointmentRequired,
    referenceNumber: state.checkoutReducer.reference
  };
}

exports['default'] = (0, _reactRedux.connect)(mapStateToProps)(SuccessStage);

/***/ }),

/***/ 710:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(37);

var _classnames2 = _interopRequireDefault(_classnames);

var _scrollToElement = __webpack_require__(255);

var _scrollToElement2 = _interopRequireDefault(_scrollToElement);

var _GenericNameField = __webpack_require__(135);

var _GenericNameField2 = _interopRequireDefault(_GenericNameField);

var _EmailField = __webpack_require__(162);

var _EmailField2 = _interopRequireDefault(_EmailField);

var _QantasFrequentFlyerNumberField = __webpack_require__(711);

var _QantasFrequentFlyerNumberField2 = _interopRequireDefault(_QantasFrequentFlyerNumberField);

var _BrandedButton = __webpack_require__(47);

var _BrandedButton2 = _interopRequireDefault(_BrandedButton);

var _constants = __webpack_require__(97);

var _styles = __webpack_require__(712);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx('legend', {}, void 0, 'Start earning Qantas Points');

var QantasFrequentFlyerDetailed = function (_PureComponent) {
  _inherits(QantasFrequentFlyerDetailed, _PureComponent);

  function QantasFrequentFlyerDetailed() {
    _classCallCheck(this, QantasFrequentFlyerDetailed);

    return _possibleConstructorReturn(this, (QantasFrequentFlyerDetailed.__proto__ || Object.getPrototypeOf(QantasFrequentFlyerDetailed)).apply(this, arguments));
  }

  _createClass(QantasFrequentFlyerDetailed, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            qffReducer = _props.qffReducer,
            fieldError = _props.fieldError,
            firstNameLabel = _props.firstNameLabel,
            lastNameLabel = _props.lastNameLabel,
            emailLabel = _props.emailLabel,
            referenceLabel = _props.referenceLabel,
            qffLabel = _props.qffLabel,
            submitLabel = _props.submitLabel,
            termsText = _props.termsText,
            successText = _props.successText,
            onSubmit = _props.onSubmit,
            onFieldChangeHandler = _props.onFieldChangeHandler,
            onFieldBlur = _props.onFieldBlur,
            clearEmailErrors = _props.clearEmailErrors,
            fieldValues = _props.fieldValues,
            isFormComplete = _props.isFormComplete;
        var isLoading = qffReducer.isLoading,
            success = qffReducer.success,
            message = qffReducer.message;


        var isFormCompleteClass = isFormComplete ? _styles2['default'].form_complete : '';

        var responseMessageElement = message && !success && Object.keys(fieldError).length === 0 ? _jsx('p', {
          className: _styles2['default'].form_error
        }, void 0, message) : null;
        var termsConditionsElement = !termsText ? null :
        // eslint-disable-next-line react/no-danger
        _jsx('div', {
          className: _styles2['default'].terms,
          dangerouslySetInnerHTML: { __html: termsText }
        });

        if (success) {
          (0, _scrollToElement2['default'])(document.getElementById(_constants.QFF_SUCCESS_CONTAINER_ID), {
            offset: -100,
            ease: 'linear',
            duration: 250
          });
        }

        return _jsx('form', {
          className: (0, _classnames2['default'])(_styles2['default'].container, isFormCompleteClass),
          onSubmit: onSubmit,
          method: 'POST'
        }, void 0, _jsx('fieldset', {
          className: _styles2['default'].form_container
        }, void 0, _ref, _jsx('div', {
          className: (0, _classnames2['default'])(_styles2['default'].field, _styles2['default'].field_name)
        }, void 0, _jsx(_GenericNameField2.default, {
          labelText: firstNameLabel,
          fieldName: _constants.QFF_FIRST_NAME_KEY,
          onChange: onFieldChangeHandler,
          onBlur: onFieldBlur,
          value: fieldValues[_constants.QFF_FIRST_NAME_KEY],
          errorMessage: fieldError[_constants.QFF_FIRST_NAME_KEY],
          loading: isLoading,
          isRequired: true
        })), _jsx('div', {
          className: (0, _classnames2['default'])(_styles2['default'].field, _styles2['default'].field_name)
        }, void 0, _jsx(_GenericNameField2.default, {
          labelText: lastNameLabel,
          fieldName: _constants.QFF_LAST_NAME_KEY,
          onChange: onFieldChangeHandler,
          onBlur: onFieldBlur,
          value: fieldValues[_constants.QFF_LAST_NAME_KEY],
          errorMessage: fieldError[_constants.QFF_LAST_NAME_KEY],
          loading: isLoading,
          isRequired: true
        })), _jsx('div', {
          className: (0, _classnames2['default'])(_styles2['default'].field, _styles2['default'].field_email)
        }, void 0, _jsx(_EmailField2.default, {
          labelText: emailLabel,
          fieldName: _constants.QFF_EMAIL_KEY,
          onChange: onFieldChangeHandler,
          onBlur: onFieldBlur,
          onFocus: clearEmailErrors,
          value: fieldValues[_constants.QFF_EMAIL_KEY],
          errorMessage: fieldError[_constants.QFF_EMAIL_KEY],
          loading: isLoading,
          isRequired: true
        })), _jsx('div', {
          className: (0, _classnames2['default'])(_styles2['default'].field, _styles2['default'].field_reference)
        }, void 0, _jsx(_GenericNameField2.default, {
          labelText: referenceLabel,
          fieldName: _constants.QFF_REFERENCE_KEY,
          onChange: onFieldChangeHandler,
          onBlur: onFieldBlur,
          value: fieldValues[_constants.QFF_REFERENCE_KEY],
          errorMessage: fieldError[_constants.QFF_REFERENCE_KEY],
          loading: isLoading,
          isRequired: true
        })), _jsx('div', {
          className: (0, _classnames2['default'])(_styles2['default'].field, _styles2['default'].field_qff)
        }, void 0, _jsx(_QantasFrequentFlyerNumberField2.default, {
          labelText: qffLabel,
          fieldName: _constants.QFF_NUMBER_KEY,
          onChange: onFieldChangeHandler,
          onBlur: onFieldBlur,
          value: fieldValues[_constants.QFF_NUMBER_KEY],
          errorMessage: fieldError[_constants.QFF_NUMBER_KEY],
          loading: isLoading,
          isRequired: true
        })), _jsx('div', {
          className: _styles2['default'].field_submit
        }, void 0, _jsx(_BrandedButton2.default, {
          labelText: submitLabel,
          iconName: 'arrowRight',
          loading: isLoading,
          fitContent: true
        })), termsConditionsElement, responseMessageElement), _jsx('div', {
          className: _styles2['default'].success_container,
          id: _constants.QFF_SUCCESS_CONTAINER_ID,
          dangerouslySetInnerHTML: { __html: successText }
        }));
      }

      return render;
    }()
  }]);

  return QantasFrequentFlyerDetailed;
}(_react.PureComponent);

exports['default'] = QantasFrequentFlyerDetailed;


QantasFrequentFlyerDetailed.defaultProps = {
  qffReducer: {
    isLoading: false,
    success: false,
    message: ''
  },
  fieldValues: {},
  fieldError: {},
  firstNameLabel: 'Your First Name',
  lastNameLabel: 'Your Last Name',
  emailLabel: 'Your Email',
  referenceLabel: 'Your Kogan Internet Customer Reference',
  qffLabel: 'Your Qantas Frequent Flyer Number (only the digits)',
  submitLabel: 'Register Details',
  termsText: null,
  successText: null,
  isFormComplete: false,

  onSubmit: function () {
    function onSubmit(f) {
      return f;
    }

    return onSubmit;
  }(),
  onFieldChangeHandler: function () {
    function onFieldChangeHandler(f) {
      return f;
    }

    return onFieldChangeHandler;
  }(),
  onFieldBlur: function () {
    function onFieldBlur(f) {
      return f;
    }

    return onFieldBlur;
  }(),
  clearEmailErrors: function () {
    function clearEmailErrors(f) {
      return f;
    }

    return clearEmailErrors;
  }()
};

/***/ }),

/***/ 711:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _FormFieldLayout = __webpack_require__(43);

var _FormFieldLayout2 = _interopRequireDefault(_FormFieldLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var QantasFrequentFlyerNumberField = function () {
  function QantasFrequentFlyerNumberField(_ref) {
    var onBlur = _ref.onBlur,
        onFocus = _ref.onFocus,
        onChange = _ref.onChange,
        value = _ref.value,
        loading = _ref.loading,
        errorMessage = _ref.errorMessage,
        fieldName = _ref.fieldName,
        labelText = _ref.labelText,
        isRequired = _ref.isRequired;

    var hasError = !!errorMessage;
    var errorObject = {
      status: hasError,
      message: errorMessage
    };
    var fieldElement = _jsx('input', {
      type: 'text',
      name: fieldName,
      className: 'form-input',
      id: fieldName,
      maxLength: '140',
      value: value,
      onChange: onChange,
      onBlur: onBlur,
      onFocus: onFocus,
      disabled: loading,
      required: isRequired,
      placeholder: labelText
    });
    return _jsx(_FormFieldLayout2.default, {
      fieldName: fieldName,
      labelText: labelText,
      fieldElement: fieldElement,
      error: errorObject
    });
  }

  return QantasFrequentFlyerNumberField;
}();

QantasFrequentFlyerNumberField.defaultProps = {
  value: '',
  fieldName: 'QantasFrequentFlyerNumberField',
  labelText: 'Your Qantas Frequent Flyer Number (only the digits)',
  loading: false,
  onFocus: undefined,
  onBlur: function () {
    function onBlur(f) {
      return f;
    }

    return onBlur;
  }(),
  onChange: function () {
    function onChange(f) {
      return f;
    }

    return onChange;
  }(),
  errorMessage: '',
  isRequired: false
};

exports['default'] = QantasFrequentFlyerNumberField;

/***/ }),

/***/ 712:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"form_complete":"Xzeop","form_container":"hb5ZH","success_container":"EjXfL","container":"yp3s8","field":"_13LxZ","terms":"_2R_oa","field_submit":"JNEy6","form_error":"u1-l2"};

/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(37);

var _classnames2 = _interopRequireDefault(_classnames);

var _GenericNameField = __webpack_require__(135);

var _GenericNameField2 = _interopRequireDefault(_GenericNameField);

var _BrandedButton = __webpack_require__(47);

var _BrandedButton2 = _interopRequireDefault(_BrandedButton);

var _constants = __webpack_require__(97);

var _styles = __webpack_require__(714);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx('legend', {}, void 0, 'Signup for QFF:');

var QantasFrequentFlyerSimple = function (_PureComponent) {
  _inherits(QantasFrequentFlyerSimple, _PureComponent);

  function QantasFrequentFlyerSimple() {
    _classCallCheck(this, QantasFrequentFlyerSimple);

    return _possibleConstructorReturn(this, (QantasFrequentFlyerSimple.__proto__ || Object.getPrototypeOf(QantasFrequentFlyerSimple)).apply(this, arguments));
  }

  _createClass(QantasFrequentFlyerSimple, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            qffReducer = _props.qffReducer,
            fieldError = _props.fieldError,
            lastNameLabel = _props.lastNameLabel,
            qffLabel = _props.qffLabel,
            submitLabel = _props.submitLabel,
            successText = _props.successText,
            onSubmit = _props.onSubmit,
            onFieldChangeHandler = _props.onFieldChangeHandler,
            onFieldBlur = _props.onFieldBlur,
            fieldValues = _props.fieldValues,
            isFormComplete = _props.isFormComplete,
            qffText = _props.qffText;
        var isLoading = qffReducer.isLoading,
            success = qffReducer.success,
            message = qffReducer.message;


        var isFormCompleteClass = isFormComplete ? _styles2['default'].form_complete : '';

        var responseMessageElement = message && !success && Object.keys(fieldError).length === 0 ? _jsx('p', {
          className: _styles2['default'].form_error
        }, void 0, message) : null;

        var successComponent = null;
        if (success) {
          successComponent = _jsx('div', {
            className: _styles2['default'].success_fields
          }, void 0, _jsx('div', {
            className: _styles2['default'].success_field
          }, void 0, _jsx('div', {
            className: (0, _classnames2['default'])(_styles2['default'].field, _styles2['default'].field_title)
          }, void 0, 'Qantas Frequent Flyer Number'), _jsx('div', {
            className: (0, _classnames2['default'])(_styles2['default'].field, _styles2['default'].field_value)
          }, void 0, fieldValues[_constants.QFF_NUMBER_KEY])), _jsx('div', {
            className: _styles2['default'].success_field
          }, void 0, _jsx('div', {
            className: (0, _classnames2['default'])(_styles2['default'].field, _styles2['default'].field_title)
          }, void 0, 'Last Name'), _jsx('div', {
            className: (0, _classnames2['default'])(_styles2['default'].field, _styles2['default'].field_value)
          }, void 0, fieldValues[_constants.QFF_LAST_NAME_KEY])));
        }

        return _jsx('div', {}, void 0, _jsx('div', {
          dangerouslySetInnerHTML: { __html: qffText }
        }), _jsx('form', {
          className: (0, _classnames2['default'])(_styles2['default'].container, isFormCompleteClass),
          onSubmit: onSubmit,
          method: 'POST'
        }, void 0, _jsx('fieldset', {
          className: _styles2['default'].form_container
        }, void 0, _ref, _jsx('div', {
          className: (0, _classnames2['default'])(_styles2['default'].field, _styles2['default'].field_qff)
        }, void 0, _jsx(_GenericNameField2.default, {
          labelText: qffLabel,
          fieldName: _constants.QFF_NUMBER_KEY,
          onChange: onFieldChangeHandler,
          onBlur: onFieldBlur,
          value: fieldValues[_constants.QFF_NUMBER_KEY],
          errorMessage: fieldError[_constants.QFF_NUMBER_KEY],
          loading: isLoading,
          isRequired: true
        })), _jsx('div', {
          className: (0, _classnames2['default'])(_styles2['default'].field, _styles2['default'].field_name)
        }, void 0, _jsx(_GenericNameField2.default, {
          labelText: lastNameLabel,
          fieldName: _constants.QFF_LAST_NAME_KEY,
          onChange: onFieldChangeHandler,
          onBlur: onFieldBlur,
          value: fieldValues[_constants.QFF_LAST_NAME_KEY],
          errorMessage: fieldError[_constants.QFF_LAST_NAME_KEY],
          loading: isLoading,
          isRequired: true
        })), _jsx('div', {
          className: _styles2['default'].field_submit
        }, void 0, _jsx(_BrandedButton2.default, {
          labelText: submitLabel,
          loading: isLoading
        })), responseMessageElement), _jsx('div', {
          className: _styles2['default'].success_container,
          id: _constants.QFF_SUCCESS_CONTAINER_ID,
          dangerouslySetInnerHTML: { __html: successText }
        }), successComponent));
      }

      return render;
    }()
  }]);

  return QantasFrequentFlyerSimple;
}(_react.PureComponent);

exports['default'] = QantasFrequentFlyerSimple;


QantasFrequentFlyerSimple.defaultProps = {
  qffReducer: {
    isLoading: false,
    success: false,
    message: ''
  },
  fieldValues: {},
  fieldError: {},
  qffLabel: 'Qantas Frequent Flyer Number',
  lastNameLabel: 'Last Name',
  submitLabel: 'Link Account',
  successText: null,
  isFormComplete: false,
  qffText: '',

  onSubmit: function () {
    function onSubmit(f) {
      return f;
    }

    return onSubmit;
  }(),
  onFieldChangeHandler: function () {
    function onFieldChangeHandler(f) {
      return f;
    }

    return onFieldChangeHandler;
  }(),
  onFieldBlur: function () {
    function onFieldBlur(f) {
      return f;
    }

    return onFieldBlur;
  }()
};

/***/ }),

/***/ 714:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"form_complete":"_3XfqZ","form_container":"_2b58N","success_container":"_3c9NU","success_fields":"l9g9h","container":"_37gRB","image":"_1pCIx","field":"OOCet","terms":"_2ch2L","field_submit":"BD2_s","success_field":"_1wueJ","field_title":"_292x6","field_value":"N_7Fj","form_error":"_1g1-y","field_qff":"_38oPY","field_name":"_22EIr"};

/***/ }),

/***/ 715:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _jsCookie = __webpack_require__(716);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var GoogleMarketing = function () {
  function GoogleMarketing(_ref) {
    var successConversionTracking = _ref.successConversionTracking;

    (0, _react.useEffect)(function () {
      var googleMarketing = _jsCookie2['default'].get('googlemarketing');
      if (googleMarketing !== undefined) {
        var trackings = successConversionTracking.filter(function (tracking) {
          return tracking.floodlightConfigID === googleMarketing;
        });
        if (trackings.length !== 0) {
          var _trackings$ = trackings[0],
              floodlightConfigID = _trackings$.floodlightConfigID,
              activityGroupTagString = _trackings$.activityGroupTagString,
              activityTagString = _trackings$.activityTagString,
              countingMethod = _trackings$.countingMethod;


          var script = document.createElement('script');
          script.src = 'https://www.googletagmanager.com/gtag/js?id=DC-' + floodlightConfigID;
          script.async = true;
          document.body.appendChild(script);

          window.dataLayer = window.dataLayer || [];
          window.gtag = function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            window.dataLayer.push(args);
          };
          window.gtag('js', new Date());
          window.gtag('config', 'DC-' + floodlightConfigID);
          window.gtag('event', 'conversion', {
            allow_custom_scripts: true,
            send_to: 'DC-' + floodlightConfigID + '/' + activityGroupTagString + '/' + activityTagString + '+' + countingMethod
          });
        }
      }
    }, []);
    return null;
  }

  return GoogleMarketing;
}();

GoogleMarketing.propTypes = {
  successConversionTracking: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
    activityGroupTagString: _propTypes2['default'].string,
    activityTagString: _propTypes2['default'].string,
    countingMethod: _propTypes2['default'].string,
    floodlightConfigID: _propTypes2['default'].string
  }))
};

GoogleMarketing.defaultProps = {
  successConversionTracking: []
};

exports['default'] = GoogleMarketing;

/***/ }),

/***/ 717:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2Awg3","content":"_3VY3h","orderSummary":"_2YbBv","greenTick":"_2A5yK","congratulations":"_2Hr6e","referenceWrapper":"_15Rsk","referenceTitle":"_12nDl","referenceNumber":"_1Q-oq","whatsNextWrapper":"_12SIJ","appointmentRequiredText":"_3jnk2"};

/***/ }),

/***/ 718:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(23);

var _redux = __webpack_require__(27);

var _GenericStatusLoading = __webpack_require__(79);

var _GenericStatusLoading2 = _interopRequireDefault(_GenericStatusLoading);

var _ErrorScreen = __webpack_require__(133);

var _ErrorScreen2 = _interopRequireDefault(_ErrorScreen);

var _styles = __webpack_require__(719);

var _styles2 = _interopRequireDefault(_styles);

var _actions = __webpack_require__(283);

var _constants = __webpack_require__(284);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddressCheckStage = function (_PureComponent) {
  _inherits(AddressCheckStage, _PureComponent);

  function AddressCheckStage() {
    _classCallCheck(this, AddressCheckStage);

    return _possibleConstructorReturn(this, (AddressCheckStage.__proto__ || Object.getPrototypeOf(AddressCheckStage)).apply(this, arguments));
  }

  _createClass(AddressCheckStage, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        if (!this.props.result) {
          this.props.checkAddress();
        }
      }

      return componentDidMount;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            result = _props.result,
            avaiabilityDate = _props.avaiabilityDate,
            isLoading = _props.isLoading,
            queued = _props.queued,
            phoneNumber = _props.phoneNumber,
            notFoundMessage = _props.notFoundMessage,
            notServiceableMessage = _props.notServiceableMessage,
            notServiceableYetMessage = _props.notServiceableYetMessage,
            itsComplicatedMessage = _props.itsComplicatedMessage,
            errorMessage = _props.errorMessage,
            loadingMessage = _props.loadingMessage,
            queuedMessage = _props.queuedMessage,
            estimatedDateTitle = _props.estimatedDateTitle;


        if (isLoading) {
          return _jsx('div', {
            className: _styles2['default'].loadingWrapper
          }, void 0, _jsx(_GenericStatusLoading2.default, {
            extraClassName: _styles2['default'].loader
          }), _jsx('div', {
            dangerouslySetInnerHTML: { __html: loadingMessage }
          }), queued && _jsx('div', {
            dangerouslySetInnerHTML: { __html: queuedMessage }
          }));
        }

        if (result === _constants.API_RESPONSE_NOT_FOUND) {
          return _jsx(_ErrorScreen2.default, {
            text: notFoundMessage,
            textClass: _styles2['default'].headingAddressNotFound,
            linkTarget: '/',
            linkText: 'Try Another Address'
          });
        }
        if (result === _constants.API_RESPONSE_NOT_AVAILABLE) {
          if (avaiabilityDate) {
            return _jsx(_ErrorScreen2.default, {
              text: notServiceableYetMessage,
              textClass: _styles2['default'].headingNbnNotAvailable,
              linkTarget: '/',
              linkText: 'Try Another Address'
            }, void 0, _jsx('div', {
              className: _styles2['default'].date
            }, void 0, _jsx('span', {}, void 0, estimatedDateTitle), _jsx('h2', {
              className: _styles2['default'].dateHeading
            }, void 0, avaiabilityDate)));
          }
          return _jsx(_ErrorScreen2.default, {
            text: notServiceableMessage,
            textClass: _styles2['default'].headingNbnNotAvailable,
            linkTarget: '/',
            linkText: 'Try Another Address'
          });
        }
        if (result === _constants.API_RESPONSE_CONTACT_US) {
          return _jsx(_ErrorScreen2.default, {
            text: itsComplicatedMessage,
            textClass: _styles2['default'].headingContactUs,
            phoneNumber: phoneNumber,
            linkTarget: '/',
            linkText: 'Try Another Address'
          });
        }

        // Something went wrong...
        return _jsx(_ErrorScreen2.default, {
          text: errorMessage
        });
      }

      return render;
    }()
  }]);

  return AddressCheckStage;
}(_react.PureComponent);

AddressCheckStage.defaultProps = {
  result: '',
  avaiabilityDate: null,
  isLoading: true,
  queued: false,
  phoneNumber: undefined,
  notFoundMessage: '<h2>Address not found</h2>' + '<p>Unfortunately, we can\'t find your address in our database. ' + 'Please try another address or call us on the number below to find out if ' + 'we can service your address.</p>',
  notServiceableMessage: '<h2>Not Serviceable Yet</h2>' + '<p>Unfortunately, Kogan Internet is not available in your area yet. We\'ve ' + 'saved your details and will let you know when it\'s available</p>',
  notServiceableYetMessage: '<h2>Not Serviceable Yet</h2>' + '<p>Unfortunately, Kogan Internet is not available in your area yet. We\'ve ' + 'saved your details and will let you know when it\'s available</p>',
  itsComplicatedMessage: '<h2>It\'s Complicated...</h2>' + '<p>That address is in a bit of a tricky situation. Call us on the number ' + 'below to find out if we can service your address.</p>',
  errorMessage: '<h2>Something went wrong...</h2>' + '<p>We are having issues validating your address. Please check your address ' + 'and try again or if the issue persists, please contact customer service on ' + 'the number below.</p>',
  estimatedDateTitle: 'Estimated Rollout Date',
  loadingMessage: '<h3>Checking your Addresses</h3><h3>Please wait while we search</h3>',
  queuedMessage: '',
  checkAddress: function () {
    function checkAddress(f) {
      return f;
    }

    return checkAddress;
  }()
};


function mapStateToProps(state) {
  return {
    result: state.checkoutReducer.addressResult,
    avaiabilityDate: state.checkoutReducer.addressAvailabilityDate,
    queued: state.checkoutReducer.addressTaskQueued
  };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({ checkAddress: _actions.checkAddress }, dispatch);
}

exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AddressCheckStage);

/***/ }),

/***/ 719:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loadingWrapper":"_3Ef5K","loader":"_3Ovwl","headingAddressNotFound":"_2j9Dr","headingNbnNotAvailable":"_3TJQ6","headingContactUs":"_2_S4t","date":"-iBjd","dateHeading":"_2ChBL"};

/***/ }),

/***/ 720:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(23);

var _PlanDisplay = __webpack_require__(285);

var _PlanDisplay2 = _interopRequireDefault(_PlanDisplay);

var _VoucherCodeField = __webpack_require__(737);

var _VoucherCodeField2 = _interopRequireDefault(_VoucherCodeField);

var _styles = __webpack_require__(738);

var _styles2 = _interopRequireDefault(_styles);

var _actions = __webpack_require__(136);

var planActions = _interopRequireWildcard(_actions);

var _constants = __webpack_require__(173);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-danger */


var _ref = _jsx('strong', {}, void 0, 'Use purchased voucher code');

var _ref2 = _jsx('strong', {}, void 0, 'Have you already purchased a voucher code?');

var PlanSelectionStage = function (_PureComponent) {
  _inherits(PlanSelectionStage, _PureComponent);

  function PlanSelectionStage(props) {
    _classCallCheck(this, PlanSelectionStage);

    var _this = _possibleConstructorReturn(this, (PlanSelectionStage.__proto__ || Object.getPrototypeOf(PlanSelectionStage)).call(this, props));

    _this.onFieldChange = function (event) {
      return _this.props.setFieldValues(_defineProperty({}, event.target.name, event.target.value));
    };

    _this.onPlanSelect = function (plan) {
      if (plan.redirectLink) {
        window.open(plan.redirectLink, '_self');
        return;
      }

      if (_this.canContinueWithVoucher()) {
        // A voucher was entered, force selection of that one
        _this.props.selectPlan(_this.props.planSelected, _this.props.voucher);
      } else {
        // Non-voucher selection
        _this.props.selectPlan(plan);
      }
    };

    _this.handleUseVoucherClick = function () {
      _this.setState({ useVoucher: true });
    };

    _this.handleCancelVoucher = function () {
      _this.setState({ useVoucher: false }, function () {
        _this.props.clearVoucher();
      });
    };

    _this.canContinueWithVoucher = function () {
      var _this$props = _this.props,
          planSelected = _this$props.planSelected,
          voucher = _this$props.voucher,
          fieldValues = _this$props.fieldValues;

      var inputValue = fieldValues[_constants.VOUCHER_CODE] || '';
      return !!planSelected && !!voucher && inputValue.length === _VoucherCodeField.VOUCHER_LENGTH;
    };

    _this.state = {
      useVoucher: !!_this.props.voucher
    };
    return _this;
  }

  _createClass(PlanSelectionStage, [{
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        // When moving to next step, scroll position is below fold
        window.scrollTo(0, 0);
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props = this.props,
            allPlans = _props.plans,
            mainTitle = _props.mainTitle,
            tagLine = _props.tagLine,
            terms = _props.terms,
            fieldValues = _props.fieldValues,
            fieldErrors = _props.fieldErrors,
            buttonText = _props.buttonText,
            planSelected = _props.planSelected,
            enableVouchers = _props.enableVouchers,
            installAddressClass = _props.installAddressClass,
            productFeatureAvailability = _props.productFeatureAvailability;

        var showDisclaimer = installAddressClass === null;
        var plans = allPlans.filter(function (plan) {
          if (plan.availableProductFeatures.length > 0) {
            if (productFeatureAvailability) {
              return plan.availableProductFeatures.some(function (pfa) {
                return productFeatureAvailability.includes(pfa);
              });
            }
            return false;
          }

          return showDisclaimer || plan.serviceClasses.length === 0 || plan.serviceClasses.includes(installAddressClass);
        });
        var buttonTexts = plans.map(function () {
          return buttonText;
        });
        var onButtonClicks = plans.map(function (plan) {
          return function () {
            return _this2.onPlanSelect(plan);
          };
        });

        var showVoucherPlan = this.canContinueWithVoucher();
        return _jsx('div', {
          className: _styles2['default'].planWrapper
        }, void 0, _jsx('h1', {
          className: _styles2['default'].pageTitle
        }, void 0, mainTitle), _jsx('div', {
          dangerouslySetInnerHTML: { __html: tagLine }
        }), enableVouchers && _jsx('div', {
          className: _styles2['default'].voucherWrapper
        }, void 0, _jsx('div', {
          className: 'l-page--width'
        }, void 0, this.state.useVoucher ? _jsx(_react.Fragment, {}, void 0, _jsx('p', {}, void 0, _ref, _jsx('button', {
          onClick: this.handleCancelVoucher,
          className: _styles2['default'].cancelButton
        }, void 0, 'Cancel')), _jsx('div', {
          className: _styles2['default'].inputWrap
        }, void 0, _jsx(_VoucherCodeField2.default, {
          name: _constants.VOUCHER_CODE,
          label: 'Enter your voucher code',
          onChange: this.onFieldChange,
          onBlur: this.onFieldChange,
          value: fieldValues[_constants.VOUCHER_CODE],
          errorMessage: fieldErrors[_constants.VOUCHER_CODE],
          required: true,
          focusOnMount: true
        }))) : _jsx(_react.Fragment, {}, void 0, _ref2, _jsx('button', {
          onClick: this.handleUseVoucherClick,
          className: _styles2['default'].linkButton
        }, void 0, 'Use Purchased Voucher')))), _jsx(_PlanDisplay2.default, {
          plans: showVoucherPlan ? [planSelected] : plans,
          summary: showVoucherPlan,
          buttonTexts: buttonTexts,
          onButtonClicks: onButtonClicks,
          showEligibility: false
        }), _jsx('div', {
          className: _styles2['default'].terms,
          dangerouslySetInnerHTML: {
            __html: terms
          }
        }));
      }

      return render;
    }()
  }]);

  return PlanSelectionStage;
}(_react.PureComponent);

PlanSelectionStage.defaultProps = {
  mainTitle: 'Kogan Internet is Available!',
  tagLine: 'Select your internet package to continue',
  buttonText: 'Choose Plan',
  terms: '',
  voucher: '',
  plans: [],
  enableVouchers: true,
  selectPlan: function () {
    function selectPlan(f) {
      return f;
    }

    return selectPlan;
  }(),
  setFieldValues: function () {
    function setFieldValues(f) {
      return f;
    }

    return setFieldValues;
  }(),
  clearVoucher: function () {
    function clearVoucher(f) {
      return f;
    }

    return clearVoucher;
  }(),
  fieldValues: {},
  fieldErrors: {},
  planSelected: {},
  installAddressClass: null,
  productFeatureAvailability: []
};


function mapStateToProps(state) {
  var _state$checkoutReduce = state.checkoutReducer,
      planFields = _state$checkoutReduce.planFields,
      planErrors = _state$checkoutReduce.planErrors,
      voucher = _state$checkoutReduce.voucher,
      planSelected = _state$checkoutReduce.planSelected,
      installAddressClass = _state$checkoutReduce.installAddressClass,
      productFeatureAvailability = _state$checkoutReduce.productFeatureAvailability;


  return {
    fieldValues: planFields,
    fieldErrors: planErrors,
    voucher: voucher,
    planSelected: planSelected,
    installAddressClass: installAddressClass,
    productFeatureAvailability: productFeatureAvailability
  };
}

exports['default'] = (0, _reactRedux.connect)(mapStateToProps, {
  selectPlan: planActions.selectPlan,
  setFieldValues: planActions.setFieldValues,
  clearVoucher: planActions.clearVoucher
})(PlanSelectionStage);

/***/ }),

/***/ 730:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _templateObject = _taggedTemplateLiteral(['\n  background-color: ', ';\n'], ['\n  background-color: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  ', '\n'], ['\n  ', '\n']);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(172);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _classnames = __webpack_require__(37);

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = __webpack_require__(289);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PlanTitle = _styledComponents2['default'].h2(_templateObject, function (props) {
  return props.planColor;
});
var PlanBase = _styledComponents2['default'].div(_templateObject2, function (props) {
  return '\n    background-color: ' + props.secondaryPlanColor + ';\n    border: 1px solid ' + props.planColor + '\n   ';
});

var displayPrice = function () {
  function displayPrice(price) {
    var priceInFloat = parseFloat(price);

    if (Number.isNaN(priceInFloat)) {
      return null;
    }

    var wholeNumber = Math.floor(priceInFloat);
    var decimalPart = (priceInFloat - wholeNumber).toFixed(2) * 100;
    if (!decimalPart) return price;

    return _jsx('span', {}, void 0, wholeNumber, _jsx('sup', {}, void 0, '.', decimalPart));
  }

  return displayPrice;
}();

var _ref2 = _jsx('svg', {
  width: '26',
  height: '29',
  viewBox: '0 0 26 29',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, void 0, _jsx('path', {
  d: 'M6.05033 27.4333C2.86543 25.4106 0.87169 21.848 2.32234 16.7417C2.32958 16.7152 2.37303 16.7176 2.37785 16.7442C3.30955 21.7188 9.65523 20.2078 8.97335 16.5824C8.58474 14.8916 7.84735 13.4241 7.48409 11.7212C7.16185 10.215 7.69167 8.6618 8.8768 7.54545C10.6799 5.84739 13.1431 4.18072 11.6647 1.11408C11.6429 1.06943 11.7009 1.02719 11.7443 1.05615C13.8503 2.41146 14.607 4.35813 13.7936 6.99391C13.6355 7.50804 13.3929 7.99802 13.102 8.46387C11.6103 10.8535 11.7069 12.6263 13.4713 13.7487C14.4875 14.3956 15.9864 14.2327 16.7323 13.3432C17.3743 12.5769 17.5059 11.4822 16.6985 10.3695C16.6804 10.3442 16.7033 10.3092 16.7371 10.314C18.3289 10.53 19.4875 11.6403 19.9449 13.2093C20.2961 14.4125 20.1296 15.6881 19.5491 16.8202C19.2787 17.3464 18.9698 17.9039 18.7296 18.4844C18.166 19.847 19.041 21.3857 20.6353 21.7152C22.2537 22.0495 24.1677 21.3568 24.9257 19.9629C24.9317 19.952 24.9498 19.9556 24.9498 19.9677C25.0258 23.6571 23.5341 26.0744 21.1977 27.5407',
  stroke: '#E71333',
  strokeWidth: '1.99333',
  strokeMiterlimit: '10',
  strokeLinecap: 'round'
}));

var PlanItem = function (_PureComponent) {
  _inherits(PlanItem, _PureComponent);

  function PlanItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PlanItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PlanItem.__proto__ || Object.getPrototypeOf(PlanItem)).call.apply(_ref, [this].concat(args))), _this), _this.handlePlanClick = function () {
      _this.props.onButtonClick(_this.props);
    }, _this.togglePlan = function (event) {
      event.preventDefault();
      if (event.currentTarget.parentNode.getAttribute('data-active')) {
        event.currentTarget.parentNode.removeAttribute('data-active');
      } else {
        event.currentTarget.parentNode.setAttribute('data-active', true);
      }
      window.dispatchEvent(new Event('resize'));
    }, _this.renderHeader = function () {
      var _this$props = _this.props,
          planColor = _this$props.planColor,
          isPromo = _this$props.isPromo,
          promoText = _this$props.promoText,
          rate = _this$props.rate,
          rateRrp = _this$props.rateRrp,
          title = _this$props.title,
          headerPill = _this$props.headerPill,
          interval = _this$props.interval,
          limit = _this$props.limit,
          pricingInfo = _this$props.pricingInfo;


      var formattedRate = parseFloat(rate).toFixed(2);
      var promoTextVisible = isPromo ? promoText : '';

      return _jsx('header', {
        className: _styles2['default'].planHeader
      }, void 0, _jsx(PlanTitle, {
        planColor: planColor,
        className: _styles2['default'].planTitle,
        onClick: _this.togglePlan
      }, void 0, title), headerPill && _jsx('div', {
        className: _styles2['default'].headerPill
      }, void 0, _jsx('div', {
        className: _styles2['default'].headerPillIcon
      }, void 0, _ref2), _jsx('span', {}, void 0, headerPill)), _jsx('div', {
        className: _styles2['default'].limit
      }, void 0, limit), _jsx('div', {
        className: _styles2['default'].rate
      }, void 0, _jsx('div', {
        className: _styles2['default'].wasPrice
      }, void 0, _jsx('div', {
        className: !rateRrp ? '' : _styles2['default'].strikethrough
      }), rateRrp && '$', displayPrice(rateRrp)), formattedRate && _jsx('div', {
        className: _styles2['default'].price
      }, void 0, '$', displayPrice(formattedRate)), _jsx('p', {
        className: _styles2['default'].interval
      }, void 0, 'per ', interval), promoTextVisible && _jsx('div', {}, void 0, promoTextVisible), _jsx('div', {
        className: _styles2['default'].pricing,
        dangerouslySetInnerHTML: { __html: pricingInfo }
      })));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PlanItem, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            planColor = _props.planColor,
            secondaryPlanColor = _props.secondaryPlanColor,
            title = _props.title,
            speedDisclaimer = _props.speedDisclaimer,
            highlightedFeature = _props.highlightedFeature,
            features = _props.features,
            buttonText = _props.buttonText,
            terms = _props.terms,
            eligibilityDisclaimer = _props.eligibilityDisclaimer,
            showEligibility = _props.showEligibility;

        var defaultClassNames = (0, _classnames2['default'])('planItem', _styles2['default'].planItem, this.props.active ? '' : _styles2['default'].inactive);
        return _jsx(_react.Fragment, {}, void 0, _jsx(PlanBase, {
          className: defaultClassNames,
          planColor: planColor,
          secondaryPlanColor: secondaryPlanColor
        }, title + '-plan', this.renderHeader(), _jsx('section', {
          className: _styles2['default'].disclaimer,
          dangerouslySetInnerHTML: { __html: speedDisclaimer }
        }), _jsx('section', {
          className: _styles2['default'].content
        }, void 0, _jsx('div', {
          className: _styles2['default'].highlightedFeature,
          dangerouslySetInnerHTML: { __html: highlightedFeature }
        }), _jsx('div', {
          className: _styles2['default'].features,
          dangerouslySetInnerHTML: { __html: features }
        }), _jsx('button', {
          className: _styles2['default'].genericButton,
          onClick: this.handlePlanClick
        }, void 0, buttonText))), _jsx('div', {
          className: _styles2['default'].terms,
          dangerouslySetInnerHTML: { __html: showEligibility ? terms + eligibilityDisclaimer : terms }
        }, title + '-terms'));
      }

      return render;
    }()
  }]);

  return PlanItem;
}(_react.PureComponent);

PlanItem.defaultProps = {
  active: false,
  planColor: '',
  secondaryPlanColor: '',
  isPromo: false,
  promoText: '',
  rate: 0.0,
  rateRrp: '',
  title: '',
  headerPill: '',
  interval: '',
  limit: '',
  terms: '',
  eligibilityDisclaimer: '',
  speedDisclaimer: '',
  highlightedFeature: '',
  features: '',
  buttonText: '',
  pricingInfo: '',
  onButtonClick: function () {
    function onButtonClick(f) {
      return f;
    }

    return onButtonClick;
  }(),
  showEligibility: true
};

exports['default'] = PlanItem;

/***/ }),

/***/ 735:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  background-color: ', ';\n'], ['\n  background-color: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\nbackground-color: ', ';\n\n', '\n'], ['\nbackground-color: ', ';\n\n', '\n']);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(172);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _classnames = __webpack_require__(37);

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = __webpack_require__(289);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PlanTitle = _styledComponents2['default'].h2(_templateObject, function (props) {
  return props.planColor;
});

var PlanContent = _styledComponents2['default'].div(_templateObject2, function (props) {
  return props.secondaryPlanColor;
}, function (props) {
  return props.rounded ? '\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px;\n  ' : '';
});

var StyledDisclaimerSection = _styledComponents2['default'].section(_templateObject, function (props) {
  return props.secondaryPlanColor;
});

var _ref2 = _jsx('i', {
  className: 'kgnIcon kgn-icon-arrow-right'
});

var PlanSummary = function (_PureComponent) {
  _inherits(PlanSummary, _PureComponent);

  function PlanSummary() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PlanSummary);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PlanSummary.__proto__ || Object.getPrototypeOf(PlanSummary)).call.apply(_ref, [this].concat(args))), _this), _this.handlePlanClick = function () {
      _this.props.onButtonClick(_this.props);
    }, _this.renderHeader = function () {
      var _this$props = _this.props,
          planColor = _this$props.planColor,
          title = _this$props.title;


      return _jsx(_react2.default.Fragment, {}, void 0, _jsx('header', {
        className: _styles2['default'].planHeader
      }, title + '-header', _jsx(PlanTitle, {
        planColor: planColor,
        className: _styles2['default'].planTitle
      }, void 0, title)));
    }, _this.renderLimit = function () {
      var _this$props2 = _this.props,
          secondaryPlanColor = _this$props2.secondaryPlanColor,
          limit = _this$props2.limit;

      return _jsx(PlanContent, {
        secondaryPlanColor: secondaryPlanColor,
        className: (0, _classnames2['default'])(_styles2['default'].limit, _styles2['default'].small)
      }, void 0, limit);
    }, _this.renderDisclaimer = function () {
      var _this$props3 = _this.props,
          title = _this$props3.title,
          speedDisclaimer = _this$props3.speedDisclaimer,
          planColor = _this$props3.planColor,
          secondaryPlanColor = _this$props3.secondaryPlanColor;


      return _jsx(StyledDisclaimerSection, {
        className: _styles2['default'].disclaimer,
        planColor: planColor,
        secondaryPlanColor: secondaryPlanColor
      }, title + '-disclaimer', _jsx('div', {
        dangerouslySetInnerHTML: {
          __html: speedDisclaimer
        }
      }));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PlanSummary, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            buttonText = _props.buttonText,
            secondaryPlanColor = _props.secondaryPlanColor;

        var defaultClassNames = (0, _classnames2['default'])('planItem', _styles2['default'].planItem, _styles2['default'].planSummary);

        var planDetails = [this.renderHeader(), this.renderLimit(), this.renderDisclaimer()];
        return _jsx('div', {
          className: defaultClassNames
        }, void 0, planDetails, _jsx(PlanContent, {
          rounded: true,
          className: _styles2['default'].content,
          secondaryPlanColor: secondaryPlanColor
        }, void 0, _jsx('button', {
          className: _styles2['default'].genericButton,
          onClick: this.handlePlanClick
        }, void 0, buttonText, ' ', _ref2)));
      }

      return render;
    }()
  }]);

  return PlanSummary;
}(_react.PureComponent);

PlanSummary.defaultProps = {
  planColor: '',
  secondaryPlanColor: '',
  title: '',
  speedDisclaimer: '',
  buttonText: '',
  limit: '',
  onButtonClick: function () {
    function onButtonClick(f) {
      return f;
    }

    return onButtonClick;
  }()
};

exports['default'] = PlanSummary;

/***/ }),

/***/ 736:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"homepage-plan-display":"_1vv_M","planWrapper":"_3Y9EJ","planList":"_2l2Gu","carouselButton":"_2c843"};

/***/ }),

/***/ 737:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VOUCHER_LENGTH = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(23);

var _FormFieldLayout = __webpack_require__(43);

var _FormFieldLayout2 = _interopRequireDefault(_FormFieldLayout);

var _actions = __webpack_require__(136);

var planActions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var VOUCHER_LENGTH = exports.VOUCHER_LENGTH = 12;

var VoucherCodeField = function () {
  function VoucherCodeField(_ref) {
    var onBlur = _ref.onBlur,
        onChange = _ref.onChange,
        value = _ref.value,
        loading = _ref.loading,
        errorMessage = _ref.errorMessage,
        name = _ref.name,
        label = _ref.label,
        checkVoucher = _ref.checkVoucher,
        onError = _ref.onError,
        focusOnMount = _ref.focusOnMount;

    // Focus on mount
    var inputRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(function () {
      if (focusOnMount) {
        inputRef.current.focus();
      }
    }, [inputRef]);

    // Lookup voucher on length limit
    (0, _react.useEffect)(function () {
      if (value.length === VOUCHER_LENGTH) {
        checkVoucher(value, function (err) {
          return onError(_defineProperty({}, name, err));
        });
      }
    }, [value, checkVoucher]);

    var hasValueClass = value ? 'has-value' : '';
    var hasError = !!errorMessage;

    var errorObject = {
      status: hasError,
      message: errorMessage
    };
    var fieldElement = _react2['default'].createElement('input', {
      ref: inputRef,
      type: 'text',
      name: name,
      className: 'form-input ' + hasValueClass,
      id: name,
      maxLength: '' + VOUCHER_LENGTH,
      value: value,
      onChange: onChange,
      onBlur: onBlur,
      disabled: loading,
      required: true
    });
    return _jsx(_FormFieldLayout2.default, {
      fieldName: name,
      labelText: label,
      fieldElement: fieldElement,
      error: errorObject
    });
  }

  return VoucherCodeField;
}();

VoucherCodeField.defaultProps = {
  value: '',
  loading: false,
  onBlur: function () {
    function onBlur(f) {
      return f;
    }

    return onBlur;
  }(),
  onChange: function () {
    function onChange(f) {
      return f;
    }

    return onChange;
  }(),
  errorMessage: '',
  name: 'voucher',
  label: 'Enter your voucher code',
  checkVoucher: function () {
    function checkVoucher(f) {
      return f;
    }

    return checkVoucher;
  }(),
  onError: function () {
    function onError(f) {
      return f;
    }

    return onError;
  }(),
  focusOnMount: false
};

exports['default'] = (0, _reactRedux.connect)(function (state) {
  return {
    loading: state.checkoutReducer.voucherLoading
  };
}, {
  checkVoucher: planActions.loadVoucher,
  onError: planActions.setFieldErrors
})(VoucherCodeField);

/***/ }),

/***/ 738:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"voucherWrapper":"_25jKW","planWrapper":"_2HlNQ","planList":"_3NZw6","featureList":"a1032","marginOffset":"uNIP2","pageTitle":"_2CZbf","terms":"_1ZWfa","inputWrap":"Stf3o","voucherButton":"E5JF7","linkButton":"_1GfoQ","cancelButton":"_2r26d"};

/***/ }),

/***/ 739:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(23);

var _redux = __webpack_require__(27);

var _PhoneNumberField = __webpack_require__(278);

var _PhoneNumberField2 = _interopRequireDefault(_PhoneNumberField);

var _BrandedButton = __webpack_require__(47);

var _BrandedButton2 = _interopRequireDefault(_BrandedButton);

var _ChoiceField = __webpack_require__(279);

var _ChoiceField2 = _interopRequireDefault(_ChoiceField);

var _GenericNameField = __webpack_require__(135);

var _GenericNameField2 = _interopRequireDefault(_GenericNameField);

var _formValidator = __webpack_require__(61);

var _WithInputAnalytics = __webpack_require__(126);

var _WithInputAnalytics2 = _interopRequireDefault(_WithInputAnalytics);

var _actions = __webpack_require__(290);

var _constants = __webpack_require__(164);

var _styles = __webpack_require__(740);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TrackedPhoneNumberField = (0, _WithInputAnalytics2['default'])(_constants.GA_EVENT_CATEGORY)(_PhoneNumberField2['default']);
var AvcIdField = (0, _WithInputAnalytics2['default'])(_constants.GA_EVENT_CATEGORY)(_GenericNameField2['default']);

var OwnerCheckStage = function (_PureComponent) {
  _inherits(OwnerCheckStage, _PureComponent);

  function OwnerCheckStage(props) {
    _classCallCheck(this, OwnerCheckStage);

    var _this = _possibleConstructorReturn(this, (OwnerCheckStage.__proto__ || Object.getPrototypeOf(OwnerCheckStage)).call(this, props));

    _this.onPhoneChange = function (event) {
      _this.setState({ phone: event.target.value });
    };

    _this.onServiceOwnerChange = function (event) {
      _this.setState({ serviceOwner: event.target.value === 'true' });
      if (_this.props.fieldError[_constants.OWNS_SERVICE_KEY]) {
        _this.props.clearFieldError(_constants.OWNS_SERVICE_KEY);
      }
    };

    _this.onKnowsAvcIdChange = function (event) {
      _this.setState({ knowsAvcId: event.target.value === 'true' });
      if (_this.props.fieldError[_constants.KNOWS_AVC_ID_KEY]) {
        _this.props.clearFieldError(_constants.KNOWS_AVC_ID_KEY);
      }
    };

    _this.onAvcIdChange = function (event) {
      _this.setState({ avcId: event.target.value });
      if (_this.props.fieldError[_constants.AVC_ID_KEY]) {
        _this.props.clearFieldError(_constants.AVC_ID_KEY);
      }
    };

    _this.onSubmit = function () {
      var _data;

      var data = (_data = {}, _defineProperty(_data, _constants.OWNS_SERVICE_KEY, _this.state.serviceOwner), _defineProperty(_data, _constants.AVC_ID_KEY, _this.state.avcId), _data);

      // Move validation checks here
      if (_this.state.serviceOwner == null) {
        _this.props.setFieldErrors(_defineProperty({}, _constants.OWNS_SERVICE_KEY, 'This is required'));
        return;
      }
      if (_this.state.serviceOwner === true && _this.state.knowsAvcId == null) {
        _this.props.setFieldErrors(_defineProperty({}, _constants.KNOWS_AVC_ID_KEY, 'This is required'));
        return;
      }
      if (_this.state.knowsAvcId === true && !_this.state.avcId) {
        _this.props.setFieldErrors(_defineProperty({}, _constants.AVC_ID_KEY, 'This is required'));
        return;
      }

      var errors = (0, _formValidator.validateOwnerForm)(data);
      if (errors === true) {
        _this.props.submitForm(data);
      } else {
        _this.props.setFieldErrors(errors);
      }
    };

    _this.onFocusPhone = function () {
      if (_this.props.fieldError[_constants.LANDLINE_KEY]) {
        _this.props.clearFieldError(_constants.LANDLINE_KEY);
      }
    };

    _this.state = {
      phone: '',
      serviceOwner: null,
      knowsAvcId: null,
      avcId: ''
    };
    return _this;
  }

  _createClass(OwnerCheckStage, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            title = _props.title,
            preText = _props.preText,
            phoneNumberText = _props.phoneNumberText,
            notOwnerText = _props.notOwnerText,
            ownerLabel = _props.ownerLabel,
            ownerNotLabel = _props.ownerNotLabel,
            landlineFieldName = _props.landlineFieldName,
            isLoading = _props.isLoading,
            askLandline = _props.askLandline,
            fieldError = _props.fieldError,
            avcIdSubtitle = _props.avcIdSubtitle;


        var options = [{ label: ownerLabel, value: 'true' }, { label: ownerNotLabel, value: 'false' }];

        return _jsx('div', {
          className: _styles2['default'].wrapper
        }, void 0, _jsx('h2', {}, void 0, title), _jsx('div', {
          className: _styles2['default'].preText,
          dangerouslySetInnerHTML: { __html: preText }
        }), _jsx(_ChoiceField2.default, {
          name: _constants.OWNS_SERVICE_KEY,
          options: options,
          value: this.state.serviceOwner !== null && this.state.serviceOwner.toString(),
          onChange: this.onServiceOwnerChange,
          loading: isLoading,
          errorMessage: fieldError[_constants.OWNS_SERVICE_KEY],
          required: true
        }), this.state.serviceOwner === true && askLandline && _jsx(TrackedPhoneNumberField, {
          labelText: landlineFieldName,
          fieldName: _constants.LANDLINE_KEY,
          value: this.state.phone,
          isRequired: false,
          loading: isLoading,
          onChange: this.onPhoneChange,
          onFocus: this.onFocusPhone,
          errorMessage: fieldError[_constants.LANDLINE_KEY]
        }), this.state.serviceOwner === true && askLandline && _jsx('div', {
          className: _styles2['default'].postText,
          dangerouslySetInnerHTML: { __html: phoneNumberText }
        }), this.state.serviceOwner === true && _jsx(_react2.default.Fragment, {}, void 0, avcIdSubtitle && _jsx('h3', {}, void 0, avcIdSubtitle), _jsx('div', {
          className: _styles2['default'].preText,
          dangerouslySetInnerHTML: { __html: this.props.avcIdDescription }
        }), _jsx(_ChoiceField2.default, {
          name: _constants.KNOWS_AVC_ID_KEY,
          options: [{ label: this.props.knowsAvcIdLabel, value: 'true' }, { label: this.props.doesNotKnowAvcIdLabel, value: 'false' }],
          value: this.state.knowsAvcId !== null && this.state.knowsAvcId.toString(),
          onChange: this.onKnowsAvcIdChange,
          loading: isLoading,
          errorMessage: fieldError[_constants.KNOWS_AVC_ID_KEY],
          required: true
        }), this.state.knowsAvcId && _jsx(AvcIdField, {
          labelText: 'AVC ID',
          fieldName: _constants.AVC_ID_KEY,
          value: this.state.avcId,
          isRequired: true,
          loading: isLoading,
          onChange: this.onAvcIdChange,
          errorMessage: fieldError[_constants.AVC_ID_KEY],
          maxLength: 15,
          description: this.props.avcIdInputDescription
        }), this.state.knowsAvcId === false && _jsx('div', {
          className: _styles2['default'].postText,
          dangerouslySetInnerHTML: { __html: this.props.ownerAvcFootnote }
        })), this.state.serviceOwner === false && _jsx('div', {
          className: _styles2['default'].postText,
          dangerouslySetInnerHTML: { __html: notOwnerText }
        }), _jsx('div', {
          className: _styles2['default'].buttonWrapper
        }, void 0, _jsx(_BrandedButton2.default, {
          labelText: 'Continue',
          loading: isLoading,
          onClick: this.onSubmit,
          fitContent: true
        })));
      }

      return render;
    }()
  }]);

  return OwnerCheckStage;
}(_react.PureComponent);

OwnerCheckStage.defaultProps = {
  isLoading: false,
  askLandline: false,
  fieldError: {},
  title: 'Installation',
  preText: '<p>As part of the installation of your nbn service the current internet and/or ' + 'landline phone service at this address will be disconnected.</p>',
  phoneNumberText: '<p>This will help us process your order quicker. To check the number, ' + 'call your mobile phone from the landline phone or view a recent phone bill.</p>',
  notOwnerText: '<p>That\'s fine, you can still place your order for a new nbn service.</p>',
  ownerLabel: 'Yes. I am the owner of this service',
  ownerNotLabel: 'No, I am not the owner of this service',
  landlineFieldName: 'Landline Phone Number (Optional)',
  avcIdSubtitle: 'I want to transfer to Kogan Internet',
  avcIdDescription: "<p>To transfer your current nbn service to Kogan, you'll need to provide your AVC ID. " + 'You can find it on a recent bill or by logging into your account with your current provider.</p>',
  knowsAvcIdLabel: 'I know my AVC ID',
  doesNotKnowAvcIdLabel: "I don't know my AVC ID",
  avcIdInputDescription: 'e.g. AVC123456789012',
  ownerAvcFootnote: '<p>If you can\'t find your AVC ID right now, that\'s okay - but you will need to provide' + ' your AVC ID later to finalise your order. We will call you to assist if needed.</p>',
  submitForm: function () {
    function submitForm(f) {
      return f;
    }

    return submitForm;
  }(),
  clearFieldError: function () {
    function clearFieldError(f) {
      return f;
    }

    return clearFieldError;
  }(),
  setFieldErrors: function () {
    function setFieldErrors(f) {
      return f;
    }

    return setFieldErrors;
  }()
};


function mapStateToProps(state) {
  // whatever is returned will show up as props
  return {
    fieldValues: state.checkoutReducer.ownerFieldValues,
    fieldError: state.checkoutReducer.ownerFieldError,
    isLoading: state.checkoutReducer.isLoading,
    askLandline: state.checkoutReducer.ownerAskLandline
  };
}

// Anything returned from this function will end up as props
function mapDispatchToProps(dispatch) {
  // Whenever dispatch is called the result should be passed
  // to all of the reducers
  return (0, _redux.bindActionCreators)({
    setFieldErrors: _actions.setFieldErrors,
    clearFieldError: _actions.clearFieldError,
    setFieldValues: _actions.setFieldValues,
    submitForm: _actions.submitForm
  }, dispatch);
}

// To promote a component to a container (smart component) - it needs
// to know about this new dispatch method. Make it available
// as a prop.
exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(OwnerCheckStage);

/***/ }),

/***/ 740:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2Zd7x","postText":"LHRLY","buttonWrapper":"_3cJvu"};

/***/ }),

/***/ 741:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(23);

var _redux = __webpack_require__(27);

var _GenericStatusLoading = __webpack_require__(79);

var _GenericStatusLoading2 = _interopRequireDefault(_GenericStatusLoading);

var _styles = __webpack_require__(742);

var _styles2 = _interopRequireDefault(_styles);

var _actions = __webpack_require__(174);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubmitStage = function (_PureComponent) {
  _inherits(SubmitStage, _PureComponent);

  function SubmitStage() {
    _classCallCheck(this, SubmitStage);

    return _possibleConstructorReturn(this, (SubmitStage.__proto__ || Object.getPrototypeOf(SubmitStage)).apply(this, arguments));
  }

  _createClass(SubmitStage, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        this.props.submitLead();
      }

      return componentDidMount;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var loadingMessage = this.props.loadingMessage;


        return _jsx('div', {
          className: _styles2['default'].loadingWrapper
        }, void 0, _jsx(_GenericStatusLoading2.default, {
          extraClassName: _styles2['default'].loader
        }), _jsx('div', {
          dangerouslySetInnerHTML: { __html: loadingMessage }
        }));
      }

      return render;
    }()
  }]);

  return SubmitStage;
}(_react.PureComponent);

SubmitStage.defaultProps = {
  loadingMessage: '<h3>Finalising your order</h3>',
  submitLead: function () {
    function submitLead(f) {
      return f;
    }

    return submitLead;
  }()
};


function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    submitLead: _actions.submitLead
  }, dispatch);
}

exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SubmitStage);

/***/ }),

/***/ 742:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loadingWrapper":"_1jzje","loader":"_3EltM"};

/***/ }),

/***/ 743:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(37);

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = __webpack_require__(744);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var StageIndicator = function () {
  function StageIndicator(_ref) {
    var stages = _ref.stages,
        currentStage = _ref.currentStage,
        settings = _ref.settings;

    var activeIdx = stages.findIndex(function (stage) {
      return stage.id === currentStage;
    });
    var firstVisible = stages.findIndex(function (stage) {
      return stage.visible !== false;
    });

    if (activeIdx <= 0 || activeIdx < firstVisible) {
      // Hide the first stage (address search)
      // Also hide if the stage was not found or is not visible
      return null;
    }

    var stagesFiltered = stages.map(function (stage, idx) {
      return _extends({}, stage, { idx: idx });
    }).filter(function (stage) {
      return stage.visible !== false;
    });
    var stageElements = stagesFiltered.map(function (stage) {
      var _classNames;

      return _jsx('div', {
        className: (0, _classnames2['default'])(_styles2['default'].stage, (_classNames = {}, _defineProperty(_classNames, _styles2['default'].current, stage.id.indexOf(currentStage) !== -1), _defineProperty(_classNames, _styles2['default'].complete, stage.idx < activeIdx), _classNames))
      }, stage.id, _jsx('div', {
        className: _styles2['default'].icon
      }), _jsx('span', {
        className: _styles2['default'].title
      }, void 0, settings[stage.id]));
    });

    return _jsx('div', {
      className: 'stageIndicatorGlobal ' + _styles2['default'].wrapper
    }, void 0, stageElements);
  }

  return StageIndicator;
}();

StageIndicator.defaultProps = {
  currentStage: null,
  settings: {}
};

exports['default'] = StageIndicator;

/***/ }),

/***/ 744:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"stage":"_3T2rH","icon":"NjZ57","complete":"_2lUh3","current":"_37gZm","title":"_25ks0","incomplete":"_31Lbm","wrapper":"_1ZqAQ"};

/***/ }),

/***/ 745:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(23);

var _redux = __webpack_require__(27);

var _pricing = __webpack_require__(273);

var _OrderSummaryItem = __webpack_require__(275);

var _OrderSummaryItem2 = _interopRequireDefault(_OrderSummaryItem);

var _OrderSummaryItemLarge = __webpack_require__(276);

var _OrderSummaryItemLarge2 = _interopRequireDefault(_OrderSummaryItemLarge);

var _constants = __webpack_require__(29);

var _actions = __webpack_require__(31);

var _OrderSummaryTotal = __webpack_require__(274);

var _OrderSummaryTotal2 = _interopRequireDefault(_OrderSummaryTotal);

var _utils = __webpack_require__(168);

var _styles = __webpack_require__(746);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx('div', {
  className: 'clearfix'
});

var OrderSummary = function (_PureComponent) {
  _inherits(OrderSummary, _PureComponent);

  function OrderSummary(props) {
    _classCallCheck(this, OrderSummary);

    var _this = _possibleConstructorReturn(this, (OrderSummary.__proto__ || Object.getPrototypeOf(OrderSummary)).call(this, props));

    _this.getCollapsedButtonText = function () {
      return _this.state.collapsed ? 'Order Details' : 'Hide Details';
    };

    _this.isStageEditable = function (targetStage) {
      var currentStageIndex = _constants.STAGES.findIndex(function (s) {
        return s.id === _this.props.currentStage;
      });
      var targetStageIndex = _constants.STAGES.findIndex(function (s) {
        return s.id === targetStage;
      });
      return targetStageIndex < currentStageIndex && targetStageIndex > -1;
    };

    _this.identificationVerified = function () {
      var verifiedAndCorrectStage = _this.props.identificationVerified && _this.props.currentStage !== _constants.STAGE_IDENTIFICATION;
      return verifiedAndCorrectStage ? 'Verified' : null;
    };

    _this.purchaseCostShouldShow = function () {
      var summarySettings = _this.props.summarySettings;


      var shouldShow = _this.props.planSelected && (_this.props.currentStage === _constants.STAGE_PAYMENT || _this.props.currentStage === _constants.STAGE_SUCCESS);
      return shouldShow ? summarySettings.costHeading : null;
    };

    _this.leadDetailsProvided = function () {
      /* Mandatory fields provided and not on personal details page */
      var _this$props$detailsPr = _this.props.detailsProvided,
          firstName = _this$props$detailsPr.first_name,
          middleName = _this$props$detailsPr.middle_name,
          lastName = _this$props$detailsPr.last_name;

      var fullName = [firstName, middleName, lastName].filter(function (x) {
        return !!x;
      }).join(' ');
      return fullName.length > 1 ? fullName : null;
    };

    _this.toggleCollapsed = function () {
      _this.setState({ collapsed: !_this.state.collapsed });
    };

    _this.state = { collapsed: true };
    return _this;
  }

  _createClass(OrderSummary, [{
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props = this.props,
            currentStage = _props.currentStage,
            installAddress = _props.installAddress,
            planSelected = _props.planSelected,
            deliveryAddress = _props.deliveryAddress,
            stageSettings = _props.stageSettings,
            summarySettings = _props.summarySettings,
            email = _props.email,
            modemRequired = _props.modemRequired,
            totalUpfront = _props.totalUpfront;
        var costText = summarySettings.costText,
            planInfoText = summarySettings.planInfoText,
            modemInfoText = summarySettings.modemInfoText;


        var planRate = (0, _pricing.decimalDisplay)(planSelected.rate);
        var totalDisplay = (0, _pricing.decimalDisplay)(totalUpfront);

        var wrapperExpandedStyle = !this.state.collapsed ? _styles2['default'].wrapperExpanded : '';
        var summaryExpandedStyle = !this.purchaseCostShouldShow() ? '' : _styles2['default'].collapsed;
        var installAddressStreet = installAddress.length >= 1 && installAddress[0] ? installAddress[0] + ',' : null;
        var installAddressCity = installAddress.length >= 2 && installAddress[1] ? installAddress[1] : null;

        var installAddressCollapsedViewStyle = this.state.collapsed ? _styles2['default'].installAddress : '';
        var planCollapsedViewStyle = this.state.collapsed ? _styles2['default'].selectedPlan + ' ' + _styles2['default'].selectedPlan__collapsed_view : _styles2['default'].selectedPlan;
        var deliveryAddressSplit = deliveryAddress.split(',');
        var disclaimers = planSelected.orderSummaryDisclaimer ? _jsx('div', {
          dangerouslySetInnerHTML: { __html: planSelected.orderSummaryDisclaimer }
        }) : null;

        // Don't show the mobile summary button until there is enough information.
        // Mostly used for NBN leads that dont have contact details yet (location ID referrals).
        var showMobileExpander = !this.state.collapsed || this.props.detailsProvided && this.props.detailsProvided.first_name || this.props.planSelected && this.props.planSelected.title;

        return _jsx('div', {
          className: _styles2['default'].breakout + ' ' + _styles2['default'].boxShadow
        }, void 0, _jsx('div', {
          className: _styles2['default'].wrapper,
          'data-stage': currentStage
        }, void 0, _jsx('div', {
          className: _styles2['default'].scrollWrapper + ' ' + wrapperExpandedStyle
        }, void 0, _jsx('div', {
          className: summaryExpandedStyle
        }, void 0, _jsx(_OrderSummaryItem2.default, {
          extraClass: _styles2['default'].stepSummaryItem + ' ' + installAddressCollapsedViewStyle,
          icon: 'house',
          title: stageSettings.landline_check,
          primaryInfo: installAddressStreet,
          secondaryInfo: installAddressCity
        }), _jsx(_OrderSummaryItem2.default, {
          extraClass: _styles2['default'].stepSummaryItem + ' ' + planCollapsedViewStyle + ' ' + _styles2['default'].hidePlanIconMobile,
          icon: 'plan',
          title: stageSettings.plan_select,
          primaryInfo: planSelected.title,
          secondaryInfo: planSelected.marketingTagline,
          stageEditable: this.isStageEditable(_constants.STAGE_PLAN_SELECT),
          onClick: function () {
            function onClick() {
              return _this2.props.transitionToStage(_constants.STAGE_PLAN_SELECT);
            }

            return onClick;
          }()
        }), modemRequired && _jsx(_OrderSummaryItem2.default, {
          icon: 'truck',
          title: stageSettings.modem_delivery,
          extraClass: '' + _styles2['default'].stepSummaryItem,
          primaryInfo: deliveryAddressSplit[0],
          secondaryInfo: deliveryAddressSplit[1],
          stageEditable: this.isStageEditable(_constants.STAGE_MODEM_SELECT),
          onClick: function () {
            function onClick() {
              return _this2.props.transitionToStage(_constants.STAGE_MODEM_SELECT);
            }

            return onClick;
          }()
        }), _jsx(_OrderSummaryItem2.default, {
          icon: 'person',
          title: stageSettings.personal,
          extraClass: _styles2['default'].stepSummaryItem + ' ' + _styles2['default'].personalDetails,
          primaryInfo: this.leadDetailsProvided(),
          secondaryInfo: email,
          stageEditable: this.isStageEditable(_constants.STAGE_PERSONAL),
          onClick: function () {
            function onClick() {
              return _this2.props.transitionToStage(_constants.STAGE_PERSONAL);
            }

            return onClick;
          }()
        }), _jsx(_OrderSummaryItem2.default, {
          icon: 'identification',
          title: stageSettings.identification,
          extraClass: _styles2['default'].stepSummaryItem + ' ' + _styles2['default'].identification,
          primaryInfo: this.identificationVerified(),
          stageEditable: this.isStageEditable(_constants.STAGE_IDENTIFICATION),
          onClick: function () {
            function onClick() {
              return _this2.props.transitionToStage(_constants.STAGE_IDENTIFICATION);
            }

            return onClick;
          }()
        })), _jsx(_OrderSummaryTotal2.default, {
          title: this.purchaseCostShouldShow(),
          headingClass: _styles2['default'].heading,
          extraClass: _styles2['default'].totalCost,
          primaryInfo: costText,
          planRate: planRate,
          planUpfront: totalDisplay,
          planInterval: planSelected.interval
        }, void 0, _jsx(_OrderSummaryItemLarge2.default, {
          icon: 'plan',
          iconColor: planSelected.planColor,
          title: planSelected.title,
          subtitle: planSelected.marketingTagline,
          primaryInfo: '$' + planRate,
          secondaryInfo: planInfoText,
          extraClass: _styles2['default'].summaryItemLarge
        }, void 0, disclaimers), _jsx(_OrderSummaryItemLarge2.default, {
          secondaryInfo: modemInfoText,
          extraClass: _styles2['default'].summaryItemLarge
        })), showMobileExpander && _jsx('button', {
          className: _styles2['default'].hyperlinkButton,
          onClick: this.toggleCollapsed
        }, void 0, this.getCollapsedButtonText()), _ref)));
      }

      return render;
    }()
  }]);

  return OrderSummary;
}(_react.PureComponent);

OrderSummary.defaultProps = {
  currentStage: '',
  installAddress: [],
  identificationVerified: false,
  deliveryAddress: '',
  planSelected: {
    interval: '',
    marketingTagline: '',
    rate: 0,
    title: '',
    orderSummaryDisclaimer: ''
  },
  totalUpfront: 0,
  stageSettings: {
    identification: 'Identification',
    landline_check: 'Install Address',
    modem_delivery: 'Modem',
    payment: 'Payment',
    personal: 'Your Details',
    modem_select: 'Modem',
    plan_select: 'Plan'
  },
  summarySettings: { costHeading: 'Total Cost' },
  detailsProvided: {
    first_name: '',
    middle_name: '',
    last_name: '',
    phone: ''
  },
  email: '',
  modemRequired: false,
  transitionToStage: function () {
    function transitionToStage(f) {
      return f;
    }

    return transitionToStage;
  }()
};


function mapStateToProps(state) {
  // whatever is returned will show up as props
  return {
    currentStage: state.checkoutReducer.currentStage,
    installAddress: state.checkoutReducer.installAddress,
    identificationVerified: state.checkoutReducer.identityVerified,
    deliveryAddress: state.checkoutReducer.modemDeliveryAddress,
    detailsProvided: state.checkoutReducer.personalFieldValues,
    planSelected: state.checkoutReducer.planSelected,
    email: state.checkoutReducer.email,
    modemRequired: state.checkoutReducer.modemRequired,
    totalUpfront: (0, _utils.calculateUpfront)(state)
  };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({ transitionToStage: _actions.transitionToStage }, dispatch);
}

exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(OrderSummary);

/***/ }),

/***/ 746:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1o-Bw","breakout":"_161-k","boxShadow":"_1vJMC","redLine":"_2h_Y7","verticalDivider":"_1dZVo","lineBreak":"FlJUk","expandedDisplay":"_3XVTX","extraInfo":"_2qv6v","planSecondaryInfoDisplay":"pG3sM","icon":"MduTd","scrollWrapper":"_3hYK8","heading":"_1cTJ-","ownsService":"_2fxh7","hyperlinkButton":"_1m0sV","hidePlanIconMobile":"_1ssBe","extraOrderSummary__hide":"_1ARYP","extraOrderSummary__show":"_1QEUQ","wrapperExpanded":"_3yoaU","stepSummaryItem":"_8GGKr","identification":"_3Lts6","collapsed":"_2B17A","totalCost":"ttTrR","summaryItemLarge":"_12wms","installAddress":"_2C2eO","selectedPlan":"_3t0Xe","selectedPlan__collapsed_view":"MM5-_","itemContainer":"_2A9Da","personalDetails":"_24h9z"};

/***/ }),

/***/ 747:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DialogPlan = __webpack_require__(748);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function () {
    function get() {
      return _interopRequireDefault(_DialogPlan)['default'];
    }

    return get;
  }()
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/***/ }),

/***/ 748:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactModal = __webpack_require__(749);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _styles = __webpack_require__(757);

var _styles2 = _interopRequireDefault(_styles);

var _ModalCard = __webpack_require__(758);

var _ModalCard2 = _interopRequireDefault(_ModalCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _ref = _jsx('i', {
  className: 'kgnIcon kgn-icon-close2'
});

function DialogPlan(props) {
  var onClose = props.onClose,
      isOpen = props.isOpen,
      modalTitle = props.modalTitle,
      modalHelpText = props.modalHelpText,
      cards = props.cards;


  return _jsx(_reactModal2.default, {
    appElement: document.body,
    className: _styles2['default'].root,
    onRequestClose: onClose,
    overlayClassName: _styles2['default'].overlay,
    isOpen: isOpen,
    shouldCloseOnOverlayClick: true,
    contentLabel: 'DialogPlan'
  }, void 0, _jsx('button', {
    className: _styles2['default'].buttonClose,
    onClick: onClose
  }, void 0, _ref), _jsx('hgroup', {
    className: _styles2['default'].header
  }, void 0, _jsx('h3', {
    className: _styles2['default'].subtitle
  }, void 0, modalTitle), _jsx('h2', {
    className: _styles2['default'].title
  }, void 0, modalHelpText)), _jsx('div', {
    className: _styles2['default'].cardLayout
  }, void 0, cards.map(function (card) {
    return _jsx('div', {
      className: _styles2['default'].content
    }, card.title, _jsx('h2', {
      className: _styles2['default'].headertext,
      dangerouslySetInnerHTML: {
        __html: card.headerText
      }
    }), _react2['default'].createElement(_ModalCard2['default'], _extends({
      className: _styles2['default'].card
    }, card, {
      onClose: onClose
    })));
  })));
}

DialogPlan.defaultProps = {
  isOpen: false,
  modalTitle: 'Great news!',
  modalHelpText: 'Special offers available for you at your address',
  cards: []
};

exports['default'] = DialogPlan;

/***/ }),

/***/ 757:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"_2gDK2","headertext":"HRFUv","title":"_1ZOkN","subtitle":"_1aGcM","content":"ATCLS","root":"_3FIiq","overlay":"_2Yq1E","card":"DPzxS","cardLayout":"_2hgu6","buttonClose":"_3jWZr"};

/***/ }),

/***/ 758:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModalCard = __webpack_require__(759);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function () {
    function get() {
      return _interopRequireDefault(_ModalCard)['default'];
    }

    return get;
  }()
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/***/ }),

/***/ 759:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalCardTitleSD = exports.ModalCardSD = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _templateObject = _taggedTemplateLiteral(['\n  border: 1px solid ', ';\n  background-color: ', ';\n'], ['\n  border: 1px solid ', ';\n  background-color: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background-color: ', ';\n'], ['\n  background-color: ', ';\n']);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(172);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(37);

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = __webpack_require__(760);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ModalCardSD = exports.ModalCardSD = _styledComponents2['default'].article(_templateObject, function (_ref) {
  var cardColor = _ref.cardColor;
  return cardColor;
}, function (_ref2) {
  var cardSecondaryColor = _ref2.cardSecondaryColor;
  return cardSecondaryColor;
});

ModalCardSD.propTypes = {
  cardColor: _propTypes2['default'].string,
  cardSecondaryColor: _propTypes2['default'].string
};

var ModalCardTitleSD = exports.ModalCardTitleSD = _styledComponents2['default'].h3(_templateObject2, function (_ref3) {
  var cardColor = _ref3.cardColor;
  return cardColor;
});

ModalCardTitleSD.propTypes = {
  cardColor: _propTypes2['default'].string
};

function ModalCard(props) {
  var className = props.className,
      title = props.title,
      rate = props.rate,
      interval = props.interval,
      optionalSubtext = props.optionalSubtext,
      redirectButtonText = props.redirectButtonText,
      cardColor = props.cardColor,
      cardSecondaryColor = props.cardSecondaryColor,
      redirectLink = props.redirectLink,
      onClose = props.onClose;

  var formattedRate = parseFloat(rate).toFixed(2);

  var handleRedirect = function () {
    function handleRedirect() {
      if (!redirectLink) {
        onClose();
      } else {
        window.location.assign(redirectLink);
      }
    }

    return handleRedirect;
  }();

  return _jsx(ModalCardSD, {
    className: (0, _classnames2['default'])(className, _styles2['default'].root),
    cardColor: cardColor,
    cardSecondaryColor: cardSecondaryColor
  }, void 0, _jsx(ModalCardTitleSD, {
    className: _styles2['default'].title,
    cardColor: cardColor,
    dangerouslySetInnerHTML: { __html: title }
  }), _jsx('div', {
    className: _styles2['default'].content
  }, void 0, _jsx('div', {
    className: _styles2['default'].price
  }, void 0, 'from ', _jsx('span', {}, void 0, '$', formattedRate), '/', interval), _jsx('div', {
    className: _styles2['default'].priceInfo
  }, void 0, _jsx('div', {
    dangerouslySetInnerHTML: { __html: optionalSubtext }
  })), _jsx('button', {
    className: _styles2['default'].modalButton,
    onClick: handleRedirect
  }, void 0, redirectButtonText)));
}

ModalCard.defaultProps = {
  className: '',
  redirectLink: '',
  optionalSubtext: ''
};

exports['default'] = ModalCard;

/***/ }),

/***/ 760:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_3ciIn","title":"_11vOp","content":"_3xDhL","price":"_1PgGM","priceInfo":"_2VYx_","features":"_37Q5Y","modalButton":"K6sAN"};

/***/ }),

/***/ 761:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultipleAddressStageComponent = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = __webpack_require__(27);

var _reactRedux = __webpack_require__(23);

var _AddressScrollPicker = __webpack_require__(762);

var _AddressScrollPicker2 = _interopRequireDefault(_AddressScrollPicker);

var _BrandedButton = __webpack_require__(47);

var _BrandedButton2 = _interopRequireDefault(_BrandedButton);

var _GenericStatusLoading = __webpack_require__(79);

var _GenericStatusLoading2 = _interopRequireDefault(_GenericStatusLoading);

var _formValidator = __webpack_require__(61);

var _actions = __webpack_require__(176);

var _styles = __webpack_require__(764);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx('div', {
  className: 'clearfix'
});

var MultipleAddressStageComponent = exports.MultipleAddressStageComponent = function (_Component) {
  _inherits(MultipleAddressStageComponent, _Component);

  function MultipleAddressStageComponent(props) {
    _classCallCheck(this, MultipleAddressStageComponent);

    var _this = _possibleConstructorReturn(this, (MultipleAddressStageComponent.__proto__ || Object.getPrototypeOf(MultipleAddressStageComponent)).call(this, props));

    _this.onContinue = function (event) {
      event.preventDefault();
      var valid = (0, _formValidator.validateMultiAddressForm)(_this.props.selectedAddress);
      if (valid === true) {
        _this.props.onContinueAction(_this.props.selectedAddress);
      } else {
        _this.setState({ error: valid });
      }
    };

    _this.state = { error: '' };
    return _this;
  }

  _createClass(MultipleAddressStageComponent, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        if (this.props.addresses.length === 0) {
          this.props.loadAddresses();
        }
      }

      return componentDidMount;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        if (this.props.isLoading && this.props.addresses.length === 0) {
          return _jsx('div', {
            className: _styles2['default'].loadingWrapper
          }, void 0, _jsx(_GenericStatusLoading2.default, {
            extraClassName: _styles2['default'].loader
          }));
        }
        return _jsx('div', {
          className: _styles2['default'].wrapper
        }, void 0, _jsx('h3', {}, void 0, this.props.title), _jsx('div', {
          dangerouslySetInnerHTML: { __html: this.props.subHeading }
        }), _jsx(_AddressScrollPicker2.default, {
          addresses: this.props.addresses,
          disabled: this.props.isLoading,
          error: this.state.error
        }), _jsx('div', {
          className: _styles2['default'].helpText,
          dangerouslySetInnerHTML: { __html: this.props.helpText }
        }), _jsx('div', {}, void 0, _jsx('div', {
          className: _styles2['default'].buttonWrapper
        }, void 0, _jsx(_BrandedButton2.default, {
          onClick: this.onContinue,
          labelText: 'Continue',
          fitContent: true
        })), _jsx('a', {
          className: _styles2['default'].backButton,
          href: '/'
        }, void 0, 'Back'), _ref));
      }

      return render;
    }()
  }]);

  return MultipleAddressStageComponent;
}(_react.Component);

MultipleAddressStageComponent.defaultProps = {
  addresses: [],
  title: 'Multiple addresses found at this location',
  subHeading: '<p>Please confirm your address</p>',
  helpText: '<p>Can\'t find your address? Please go back and try again or contact us on 1300 123 455</p>',
  selectedAddress: null,
  onContinueAction: function () {
    function onContinueAction(f) {
      return f;
    }

    return onContinueAction;
  }(),
  loadAddresses: function () {
    function loadAddresses(f) {
      return f;
    }

    return loadAddresses;
  }(),
  isLoading: false
};


function mapStateToProps(state) {
  // whatever is returned will show up as props
  return {
    isLoading: state.checkoutReducer.isLoading,
    selectedAddress: state.checkoutReducer.multiAddressStageSelectedId,
    addresses: state.checkoutReducer.multiAddressStageAddresses
  };
}

// Anything returned from this function will end up as props
function mapDispatchToProps(dispatch) {
  // Whenever dispatch is called the result should be passed
  // to all of the reducers
  return (0, _redux.bindActionCreators)({ onContinueAction: _actions.updateAddress, loadAddresses: _actions.loadAddresses }, dispatch);
}

exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MultipleAddressStageComponent);

/***/ }),

/***/ 762:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressScrollPickerComponent = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(23);

var _redux = __webpack_require__(27);

var _constants = __webpack_require__(29);

var _actions = __webpack_require__(176);

var _styles = __webpack_require__(763);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref2 = _jsx('br', {});

var AddressScrollPickerComponent = exports.AddressScrollPickerComponent = function (_PureComponent) {
  _inherits(AddressScrollPickerComponent, _PureComponent);

  function AddressScrollPickerComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AddressScrollPickerComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddressScrollPickerComponent.__proto__ || Object.getPrototypeOf(AddressScrollPickerComponent)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (event) {
      _this.props.makeSelection(event.target.value);
    }, _this.getMappedElements = function () {
      var mapped = _this.props.addresses.slice(0, _this.props.numAddressesToShow).map(function (item) {
        var _item$address$split = item.address.split(','),
            _item$address$split2 = _slicedToArray(_item$address$split, 2),
            street = _item$address$split2[0],
            suburb = _item$address$split2[1];

        return _jsx('div', {
          className: _styles2['default'].option
        }, item.id, _jsx('input', {
          id: item.id,
          onChange: _this.onChange,
          type: 'radio',
          value: item.id,
          checked: item.id === _this.props.selectedAddress
        }), _jsx('label', {
          htmlFor: item.id
        }, void 0, _jsx('span', {
          className: _styles2['default'].icon
        }), _jsx('div', {
          className: _styles2['default'].labelText
        }, void 0, _jsx('span', {
          className: _styles2['default'].labelTextMain
        }, void 0, street), _ref2, _jsx('span', {
          className: _styles2['default'].labelTextSecondary
        }, void 0, suburb))));
      });
      return mapped;
    }, _this.viewMoreComponent = function () {
      return _this.props.numAddressesToShow < _this.props.addresses.length ? _jsx('div', {
        className: _styles2['default'].option
      }, void 0, _jsx('button', {
        type: 'button',
        className: _styles2['default'].viewMore,
        onClick: _this.props.viewMore
      }, void 0, 'View More')) : null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AddressScrollPickerComponent, [{
    key: 'render',
    value: function () {
      function render() {
        var mappedElements = this.getMappedElements();
        var viewMore = this.viewMoreComponent();
        var errorMessage = this.props.error ? _jsx('p', {
          className: _styles2['default'].error
        }, void 0, ' ', this.props.error) : null;
        return _jsx('div', {}, void 0, _jsx('div', {
          className: _styles2['default'].wrapper
        }, void 0, mappedElements, viewMore), errorMessage);
      }

      return render;
    }()
  }]);

  return AddressScrollPickerComponent;
}(_react.PureComponent);

AddressScrollPickerComponent.defaultProps = {
  viewMore: function () {
    function viewMore(f) {
      return f;
    }

    return viewMore;
  }(),
  makeSelection: function () {
    function makeSelection(f) {
      return f;
    }

    return makeSelection;
  }(),
  selectedAddress: null,
  addresses: [],
  error: null,
  numAddressesToShow: _constants.DEFAULT_MULTI_ADDRESS_STAGE_NUMBER_OF_ADDRESSES_TO_SHOW
};


function mapStateToProps(state) {
  // whatever is returned will show up as props
  return {
    selectedAddress: state.checkoutReducer.multiAddressStageSelectedId,
    numAddressesToShow: state.checkoutReducer.multiAddressStageNumAddressesToShow
  };
}

// Anything returned from this function will end up as props
function mapDispatchToProps(dispatch) {
  // Whenever dispatch is called the result should be passed
  // to all of the reducers
  return (0, _redux.bindActionCreators)({
    viewMore: _actions.displayMoreAddresses,
    makeSelection: _actions.selectSingleAddress
  }, dispatch);
}

exports['default'] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AddressScrollPickerComponent);

/***/ }),

/***/ 763:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"isLoading":"_6ZulX","wrapper":"_2kdwh","icon":"_2eLX_","labelText":"_52t0D","labelTextMain":"_34ltp","labelTextSecondary":"_3GEcq","option":"kRvVB","viewMore":"_1dcw8","error":"sd1KG"};

/***/ }),

/***/ 764:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"helpText":"_3yvWe","wrapper":"_2WUFs","backButton":"_2pjTp","buttonWrapper":"_3wAaR"};

/***/ }),

/***/ 765:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_22-d-"};

/***/ }),

/***/ 766:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(67);

var _styles = __webpack_require__(767);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx('rect', {
  stroke: '#ED193A',
  strokeWidth: '2',
  x: '101',
  y: '13',
  width: '26',
  height: '26',
  rx: '4'
});

var _ref2 = _jsx('rect', {
  stroke: '#F8E71C',
  strokeWidth: '2',
  x: '58',
  y: '1',
  width: '26',
  height: '26',
  rx: '4'
});

var _ref3 = _jsx('rect', {
  stroke: '#518DD6',
  strokeWidth: '2',
  x: '41',
  y: '39',
  width: '26',
  height: '26',
  rx: '4'
});

var _ref4 = _jsx('rect', {
  stroke: '#ED193A',
  strokeWidth: '2',
  x: '1',
  y: '25',
  width: '26',
  height: '26',
  rx: '4'
});

var _ref5 = _jsx('rect', {
  stroke: '#ED193A',
  strokeWidth: '2',
  x: '81',
  y: '51',
  width: '26',
  height: '26',
  rx: '4'
});

var _ref6 = _jsx('rect', {
  stroke: '#F8E71C',
  strokeWidth: '2',
  x: '40',
  y: '1',
  width: '26',
  height: '26',
  rx: '4'
});

var _ref7 = _jsx('rect', {
  stroke: '#518DD6',
  strokeWidth: '2',
  x: '81',
  y: '12',
  width: '26',
  height: '26',
  rx: '4'
});

var _ref8 = _jsx('rect', {
  stroke: '#ED193A',
  strokeWidth: '2',
  x: '1',
  y: '1',
  width: '26',
  height: '26',
  rx: '4'
});

var _ref9 = _jsx('rect', {
  stroke: '#ED193A',
  strokeWidth: '2',
  x: '1',
  y: '81',
  width: '26',
  height: '26',
  rx: '4'
});

var _ref10 = _jsx('rect', {
  stroke: '#F8E71C',
  strokeWidth: '2',
  x: '52',
  y: '40',
  width: '26',
  height: '26',
  rx: '4'
});

var _ref11 = _jsx('rect', {
  stroke: '#518DD6',
  strokeWidth: '2',
  x: '38',
  y: '81',
  width: '26',
  height: '26',
  rx: '4'
});

var _ref12 = _jsx('rect', {
  stroke: '#ED193A',
  strokeWidth: '2',
  x: '52',
  y: '1',
  width: '26',
  height: '26',
  rx: '4'
});

var _ref13 = _jsx('rect', {
  stroke: '#ED193A',
  strokeWidth: '2',
  x: '27',
  y: '101',
  width: '26',
  height: '26',
  rx: '4'
});

var _ref14 = _jsx('rect', {
  stroke: '#F8E71C',
  strokeWidth: '2',
  x: '39',
  y: '58',
  width: '26',
  height: '26',
  rx: '4'
});

var _ref15 = _jsx('rect', {
  stroke: '#518DD6',
  strokeWidth: '2',
  x: '1',
  y: '41',
  width: '26',
  height: '26',
  rx: '4'
});

var _ref16 = _jsx('rect', {
  stroke: '#ED193A',
  strokeWidth: '2',
  x: '14',
  y: '1',
  width: '26',
  height: '26',
  rx: '4'
});

var _ref17 = _jsx('title', {}, void 0, 'Kogan Pattern');

var BGAnimationContainer = function (_PureComponent) {
  _inherits(BGAnimationContainer, _PureComponent);

  function BGAnimationContainer() {
    _classCallCheck(this, BGAnimationContainer);

    return _possibleConstructorReturn(this, (BGAnimationContainer.__proto__ || Object.getPrototypeOf(BGAnimationContainer)).apply(this, arguments));
  }

  _createClass(BGAnimationContainer, [{
    key: 'render',
    value: function () {
      function render() {
        // IE doesn't do SVG stroke animation properly, this class is appended and makes the css rules invalid
        var ieFixClass = _constants.isIE || _constants.isEdge ? '-isIE' : '';

        var layer1 = _jsx('g', {
          className: '' + _styles2['default'].layer1 + ieFixClass
        }, void 0, _jsx('rect', {
          className: '' + _styles2['default'].layer1RootNode + ieFixClass,
          x: '1195',
          y: '63',
          width: '26',
          height: '26',
          rx: '4',
          strokeWidth: '2',
          stroke: '#ED193A'
        }), _jsx('g', {
          className: '' + _styles2['default'].layer1Group + ieFixClass,
          transform: 'translate(1219.000000, 1.000000)',
          opacity: '0.5'
        }, void 0, _ref, _ref2, _ref3, _ref4), _jsx('path', {
          className: '' + _styles2['default'].layer1Path + ieFixClass,
          d: 'M1194,76 L1032,76 L1032,76 C1025.37258,76 1020,81.372583 1020,88 L1020,372',
          stroke: '#ED193A',
          strokeWidth: '2'
        }));

        var layer2 = _jsx('g', {
          className: '' + _styles2['default'].layer2 + ieFixClass
        }, void 0, _jsx('rect', {
          className: '' + _styles2['default'].layer2RootNode + ieFixClass,
          fill: '#ED193A',
          x: '1006',
          y: '372',
          width: '28',
          height: '28',
          rx: '4'
        }), _jsx('g', {
          className: '' + _styles2['default'].layer2Group + ieFixClass,
          transform: 'translate(966.000000, 406.000000)',
          opacity: '0.5'
        }, void 0, _ref5, _ref6, _ref7, _ref8), _jsx('path', {
          className: '' + _styles2['default'].layer2Path + ieFixClass,
          d: 'M1006,386 L425,386 L425,386 C418.372583,386 413,391.372583 413,398 L413,608',
          stroke: '#ED193A',
          strokeWidth: '2'
        }));

        var layer3 = _jsx('g', {
          className: '' + _styles2['default'].layer3 + ieFixClass
        }, void 0, _jsx('g', {
          className: '' + _styles2['default'].layer3RootNode + ieFixClass,
          transform: 'translate(399.000000, 594.000000)'
        }, void 0, _jsx('rect', {
          className: '' + _styles2['default'].layer3RootNodeBorderStart + ieFixClass,
          stroke: '#518DD6',
          strokeWidth: '2',
          x: '1',
          y: '1',
          width: '26',
          height: '26',
          rx: '4'
        }), _jsx('rect', {
          className: '' + _styles2['default'].layer3RootNodeFill + ieFixClass,
          fill: '#ED193A',
          x: '6',
          y: '6',
          width: '16',
          height: '16',
          rx: '2'
        }), _jsx('rect', {
          className: '' + _styles2['default'].layer3RootNodeBorderEnd + ieFixClass,
          stroke: '#518DD6',
          strokeWidth: '2',
          x: '-332',
          y: '1',
          width: '26',
          height: '26',
          rx: '4'
        })), _jsx('path', {
          className: '' + _styles2['default'].layer3Path + ieFixClass,
          d: 'M399,608 L94,608',
          stroke: '#518DD6',
          strokeWidth: '2',
          strokeLinecap: 'square'
        }));

        var layer4 = _jsx('g', {
          className: '' + _styles2['default'].layer4 + ieFixClass
        }, void 0, _jsx('rect', {
          className: '' + _styles2['default'].layer4RootNodeStart + ieFixClass,
          fill: '#ED193A',
          x: '65',
          y: '325',
          width: '28',
          height: '28',
          rx: '4'
        }), _jsx('path', {
          className: '' + _styles2['default'].layer4PathStart + ieFixClass,
          d: 'M94,341 L258,341 L258,341 C264.627417,341 270,346.372583 270,353 L270,934',
          stroke: '#F8E71C',
          strokeWidth: '2'
        }), _jsx('rect', {
          className: '' + _styles2['default'].layer4RootNodeEnd + ieFixClass,
          fill: '#ED193A',
          x: '256',
          y: '934',
          width: '28',
          height: '28',
          rx: '4'
        }), _jsx('g', {
          className: '' + _styles2['default'].layer4Group + ieFixClass,
          transform: 'translate(170.000000, 895.000000)',
          opacity: '0.5'
        }, void 0, _ref9, _ref10, _ref11, _ref12), _jsx('path', {
          className: '' + _styles2['default'].layer4PathFinish + ieFixClass,
          d: 'M284,948 L568,948 L568,948 C574.627417,948 580,953.372583 580,960 L580,1123',
          stroke: '#F8E71C',
          strokeWidth: '2'
        }));

        var layer5 = _jsx('g', {
          className: '' + _styles2['default'].layer5 + ieFixClass
        }, void 0, _jsx('rect', {
          className: '' + _styles2['default'].layer5RootNode + ieFixClass,
          fill: '#ED193A',
          x: '566',
          y: '1123',
          width: '28',
          height: '28',
          rx: '4'
        }), _jsx('g', {
          className: '' + _styles2['default'].layer5Group + ieFixClass,
          transform: 'translate(587.000000, 1148.000000)',
          opacity: '0.5'
        }, void 0, _ref13, _ref14, _ref15, _ref16));

        return _jsx('svg', {
          className: _styles2['default'].wrapper,
          width: '1180px',
          height: '1180px',
          viewBox: '0 0 1440 1440',
          version: '1.1',
          xmlns: 'http://www.w3.org/2000/svg',
          xlinkHref: 'http://www.w3.org/1999/xlink'
        }, void 0, _ref17, _jsx('g', {
          className: 'kgn-internet-bg',
          stroke: 'none',
          strokeWidth: '1',
          fill: 'none',
          fillRule: 'evenodd'
        }, void 0, layer1, layer2, layer3, layer4, layer5));
      }

      return render;
    }()
  }]);

  return BGAnimationContainer;
}(_react.PureComponent);

exports['default'] = BGAnimationContainer;

/***/ }),

/***/ 767:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 768:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = __webpack_require__(31);

var _constants = __webpack_require__(29);

var _actions2 = __webpack_require__(174);

var _actions3 = __webpack_require__(170);

var _actions4 = __webpack_require__(169);

var _actions5 = __webpack_require__(136);

var _actions6 = __webpack_require__(171);

var _tracking = __webpack_require__(28);

var _tracking2 = _interopRequireDefault(_tracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function buildItems(state) {
  var planSelected = state.planSelected;

  var items = [{
    id: planSelected.id,
    name: planSelected.title,
    price: planSelected.rate,
    quantity: 1
  }];
  return items;
}

exports['default'] = function (store) {
  return function (next) {
    return function (action) {
      var returnValue = next(action);
      if (!action) return returnValue;

      var state = store.getState().checkoutReducer;
      var newStageId = action.payload ? action.payload.next || action.payload.nextStage || action.payload : action;

      switch (action.type) {
        case _actions5.PLAN_SELECT_SUCCESS:
          (0, _tracking2['default'])('begin_checkout', {
            items: buildItems(state),
            checkout_step: 1 // Modem delivery
          });
          if (newStageId) {
            (0, _tracking.gaPageView)(newStageId);
          }
          break;
        case _actions.PAYMENT_SUCCESS:
        case _actions3.PERSONAL_SUBMIT_SUCCESS:
        case _actions6.MODEM_DELIVERY_SUCCESS:
        case _actions4.IDENTIFICATION_SUCCESS:
          {
            var stage = _constants.STAGES.find(function (s) {
              return s.id === newStageId;
            });
            if (stage && stage.gaId) {
              (0, _tracking2['default'])('checkout_progress', {
                checkout_step: stage.gaId,
                items: buildItems(state)
              });
            }
            (0, _tracking.gaPageView)(newStageId);
            break;
          }
        case _actions2.SUBMIT_LEAD_SUCCESS:
          (0, _tracking2['default'])('purchase', {
            transaction_id: action.payload.reference,
            value: state.planSelected.rate,
            currency: 'AUD',
            items: buildItems(state)
          });
          (0, _tracking.gaPageView)(_constants.STAGE_SUCCESS);
          break;
        default:
          break;
      }

      return returnValue;
    };
  };
};

/***/ }),

/***/ 769:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(27);

var _reducer = __webpack_require__(770);

var _reducer2 = _interopRequireDefault(_reducer);

var _reducer3 = __webpack_require__(771);

var _reducer4 = _interopRequireDefault(_reducer3);

var _reducer5 = __webpack_require__(772);

var _reducer6 = _interopRequireDefault(_reducer5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// a function that returns a piece of the application state
// because application can have many different pieces of state == many reducers
var rootReducer = (0, _redux.combineReducers)({
  leadGenReducer: _reducer2['default'],
  checkoutReducer: _reducer4['default'],
  qffReducer: _reducer6['default']
});

exports['default'] = rootReducer;

/***/ }),

/***/ 770:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports['default'] = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_APP_SCHEMA;
  var action = arguments[1];

  switch (action.type) {
    case _actions.SET_LEAD_DETAILS:
      return Object.assign({}, state, {
        fieldValues: Object.assign({}, state.fieldValues, action.payload)
      });
    case _actions.IS_LOADING:
      return Object.assign({}, state, { isLoading: action.payload });
    case _actions.IS_SUCCESS:
      return Object.assign({}, state, { success: action.payload });
    case _actions.SET_RESPONSE_MESSAGE:
      return Object.assign({}, state, { message: action.payload });
    case _actions.SET_FIELD_ERRORS:
      return Object.assign({}, state, { fieldError: action.payload });
    case _actions.CLEAR_FIELD_ERROR:
      if (!state.fieldError[action.payload]) return state;
      return Object.assign({}, state, {
        fieldError: _lodash2['default'].omit(state.fieldError, action.payload)
      });
    case _actions.SET_MANUAL_ADDRESS:
      return Object.assign({}, state, { manualAddress: action.payload });
    case _actions.REDIRECT_PAGE:
      window.location.href = action.payload;
      return state;
    default:
      return state;
  }
};

var _lodash = __webpack_require__(159);

var _lodash2 = _interopRequireDefault(_lodash);

var _actions = __webpack_require__(261);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var DEFAULT_APP_SCHEMA = {
  isLoading: false,
  success: false,
  message: '',
  fieldError: {},
  fieldValues: {},
  manualAddress: false
};

/***/ }),

/***/ 771:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_APP_SCHEMA;
  var action = arguments[1];

  switch (action.type) {
    case _actions9.IS_LOADING:
      return _extends({}, state, {
        isLoading: action.payload
      });
    case _actions9.SET_ERROR:
      return _extends({}, state, {
        error: action.payload,
        isLoading: false
      });

    case _actions.MODEM_REQUIRED:
      return _extends({}, state, {
        modemRequired: action.payload
      });

    case _actions.MODEM_ADDRESS_SAME_AS_INSTALL:
      return _extends({}, state, {
        modemSameAsInstallAddress: action.payload
      });

    case _actions.MODEM_ADDRESS_MANUAL:
      return _extends({}, state, {
        modemManualAddress: action.payload
      });

    case _actions.MODEM_SET_FIELDS:
      return _extends({}, state, {
        modemFields: _extends({}, state.modemFields, action.payload),
        // and clear any errors for updated fields
        modemErrors: _lodash2['default'].omit(state.modemErrors, Object.keys(action.payload))
      });

    case _actions.MODEM_SET_ERRORS:
      return _extends({}, state, {
        modemErrors: _extends({}, state.modemErrors, action.payload)
      });

    case _actions.MODEM_RESPONSE_MESSAGE:
      return _extends({}, state, {
        modemResponseMessage: action.payload
      });

    case _actions.MODEM_CLEAR_ERROR:
      if (!state.modemErrors[action.payload]) return state;
      return _extends({}, state, {
        modemErrors: _lodash2['default'].omit(state.modemErrors, action.payload)
      });

    case _actions.MODEM_DELIVERY_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        currentStage: action.payload.next,
        modemDeliveryAddress: action.payload.address

        // Plan Selection
      });case _actions4.PLAN_SELECT_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        currentStage: action.payload.nextStage,
        planSelected: action.payload.plan
      });

    case _constants.PLAN_SET_FIELDS:
      {
        return _extends({}, state, {
          planFields: _extends({}, state.planFields, action.payload)
        });
      }
    case _constants.PLAN_SET_ERRORS:
      {
        var _1 = state.voucher,
            rest = _objectWithoutProperties(state, ['voucher']);

        return _extends({}, rest, {
          planErrors: _extends({}, state.planErrors, action.payload)
        });
      }
    case _constants.CLEAR_VOUCHER:
      {
        var _2 = state.voucher,
            _rest = _objectWithoutProperties(state, ['voucher']);

        return _extends({}, _rest);
      }
    case _constants.LOAD_VOUCHER_REQUEST:
      return _extends({}, state, { voucherLoading: true });

    case _constants.LOAD_VOUCHER_FAILURE:
      return _extends({}, state, {
        voucherLoading: false
      });

    case _constants.LOAD_VOUCHER_SUCCESS:
      return _extends({}, state, {
        voucherLoading: false,
        voucher: action.payload.code,
        planSelected: action.payload.plan,
        planErrors: _lodash2['default'].omit(state.planErrors, _constants.VOUCHER_CODE)

        // Identification
      });case _actions3.IDENTIFICATION_INIT_LOADING:
      return _extends({}, state, {
        identificationVerificationToken: null,
        error: false
      });
    case _actions3.IDENTIFICATION_INIT_DONE:
      return _extends({}, state, {
        identificationVerificationToken: action.verificationToken,
        isLoading: false,
        currentStage: 'identification'
      });
    case _actions3.IDENTIFICATION_SUCCESS:
      return _extends({}, state, {
        currentStage: 'payment',
        identityVerified: true,
        identificationVerificationToken: null
      });
    case _actions3.IDENTIFICATION_ERROR:
      return _extends({}, state, {
        identificationError: action.payload
        // Payment
      });case _actions9.PAYMENT_SUCCESS:
      return _extends({}, state, {
        paymentProcessing: false,
        currentStage: action.payload
      });
    case _actions9.PAYMENT_PROCESSING:
      return _extends({}, state, {
        paymentProcessing: true,
        paymentError: false,
        paymentDeclined: false
      });
    case _actions9.PAYMENT_ERROR:
      return _extends({}, state, {
        paymentError: action.payload.error,
        paymentProcessing: false
      });
    case _actions9.PAYMENT_DECLINED:
      return _extends({}, state, {
        paymentDeclined: action.payload.declined,
        paymentProcessing: false
      });
    case _actions2.PERSONAL_SET_FIELDS:
      return _extends({}, state, {
        isLoading: false,
        personalFieldValues: action.payload
      });
    case _actions2.PERSONAL_FIELD_ERRORS:
      return _extends({}, state, {
        personalFieldError: action.payload,
        isLoading: false
      });
    case _actions2.PERSONAL_CLEAR_FIELD_ERROR:
      if (!state.personalFieldError[action.payload]) return state;
      return _extends({}, state, {
        personalFieldError: _lodash2['default'].omit(state.personalFieldError, action.payload)
      });
    case _actions2.PERSONAL_SUBMIT_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        currentStage: action.payload.next
      });
    case _actions8.ADDRESS_CHECK_INIT:
      return _extends({}, state, {
        isLoading: true,
        addressTaskQueued: false,
        addressResult: ''
      });
    case _actions8.ADDRESS_CHECK_TASK_QUEUED:
      return _extends({}, state, {
        addressTaskQueued: true
      });
    case _actions8.ADDRESS_CHECK_FAILED:
      return _extends({}, state, {
        isLoading: false,
        addressTaskQueued: false,
        addressResult: action.payload.reason,
        addressAvailabilityDate: action.payload.date
      });
    case _actions8.ADDRESS_CHECK_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        addressTaskQueued: false,
        currentStage: action.payload.nextStage,
        ownerAskLandline: action.payload.askLandline,
        appointmentRequired: action.payload.appointmentRequired,
        addressResult: 'success',
        installAddress: action.payload.installAddress,
        installAddressClass: action.payload.serviceClass,
        productFeatureAvailability: action.payload.productFeatureAvailability
      });
    case _actions8.ADDRESS_CHECK_ERROR:
      return _extends({}, state, {
        isLoading: false,
        addressTaskQueued: false,
        addressResult: 'error'
      });
    case _actions8.ADDRESS_CHECK_MULTIPLE:
      return _extends({}, state, {
        isLoading: false,
        addressTaskQueued: false,
        multiAddressStageAddresses: action.payload.addresses,
        currentStage: action.payload.nextStage,
        addressResult: 'success'
      });
    case _actions5.MULTI_ADDRESS_SELECT_SINGLE_OF_MULTIPLE:
      return _extends({}, state, {
        isLoading: false,
        multiAddressStageSelectedId: action.payload
      });
    case _actions5.MULTI_ADDRESS_SHOW_MORE_ADDRESSES:
      return _extends({}, state, {
        isLoading: false,
        multiAddressStageNumAddressesToShow: state.multiAddressStageNumAddressesToShow + 5
      });
    case _actions5.MULTI_ADDRESS_UPDATE_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        currentStage: action.payload.nextStage,
        installAddress: action.payload.address,
        addressResult: ''
      });
    case _actions5.MULTI_ADDRESS_LOADED:
      return _extends({}, state, {
        multiAddressStageAddresses: action.payload,
        isLoading: false
      });
    case _actions6.OWNER_FIELD_ERRORS:
      return _extends({}, state, {
        ownerFieldError: action.payload,
        isLoading: false
      });
    case _actions6.OWNER_CLEAR_FIELD_ERROR:
      if (!state.ownerFieldError[action.payload]) return state;
      return _extends({}, state, {
        ownerFieldError: _lodash2['default'].omit(state.ownerFieldError, action.payload)
      });
    case _actions6.OWNER_SUBMIT_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        currentStage: action.payload.nextStage,
        ownsService: action.payload.isOwner
      });
    case _actions7.SUBMIT_LEAD_SUCCESS:
      return _extends({}, state, {
        currentStage: action.payload.next,
        reference: action.payload.reference
      });
    case _actions9.ORDER_SUMMARY_FETCH_SUCCESS:
      {
        return _extends({}, state, {
          isLoading: false,
          reference: action.payload.reference,
          appointmentRequired: action.payload.appointment_required,
          currentStage: action.payload.current_stage,
          installAddress: action.payload.install_address,
          installAddressClass: action.payload.install_address_class,
          modemRequired: action.payload.modem_required,
          modemDeliveryAddress: action.payload.delivery_address,
          modemAddressSameAsDelivery: action.payload.delivery_same_as_install,
          ownsService: action.payload.owns_service,
          planSelected: action.payload.plan_selected,
          personalFieldValues: _extends({}, action.payload.personal_details, {
            addressText: action.payload.delivery_address
          }),
          email: action.payload.email,
          identityVerified: action.payload.identity_verified,
          voucher: action.payload.voucher,
          productFeatureAvailability: action.payload.product_feature_availability
        });
      }
    case _actions9.ORDER_SUMMARY_FETCH_FAILURE:
      return _extends({}, state, {
        isLoading: false,
        error: true
      });
    case _actions9.STAGE_TRANSITION_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        currentStage: action.payload.next
      });
    default:
      return state;
  }
};

var _lodash = __webpack_require__(159);

var _lodash2 = _interopRequireDefault(_lodash);

var _actions = __webpack_require__(171);

var _actions2 = __webpack_require__(170);

var _actions3 = __webpack_require__(169);

var _actions4 = __webpack_require__(136);

var _constants = __webpack_require__(173);

var _actions5 = __webpack_require__(176);

var _actions6 = __webpack_require__(290);

var _actions7 = __webpack_require__(174);

var _actions8 = __webpack_require__(283);

var _actions9 = __webpack_require__(31);

var _constants2 = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DEFAULT_APP_SCHEMA = {
  isLoading: false,
  error: false,
  currentStage: null,
  // Personal stage
  personalFieldError: {},
  personalFieldValues: _constants2.DEFAULT_DETAILS_PROVIDED,
  personalFieldProvided: {},
  // Payment stage
  paymentError: false,
  paymentDeclined: false,
  paymentProcessing: false,
  // Address Check data
  addressTaskQueued: false,
  addressResult: '',
  addressAvailabilityDate: null,
  // Multiple Address stage
  multiAddressStageAddresses: [],
  multiAddressStageSelectedId: null,
  multiAddressStageNumAddressesToShow: _constants2.DEFAULT_MULTI_ADDRESS_STAGE_NUMBER_OF_ADDRESSES_TO_SHOW,
  // Install address
  installAddress: [],
  installAddressClass: null,
  // Product Feature Availability
  productFeatureAvailability: null,
  // Owner check data
  ownsService: false,
  ownerFieldError: {},
  ownerAskLandline: false,
  // Identity/Green Id
  identityVerified: {},
  identificationVerificationToken: null,
  // Plan Selection
  planFields: {},
  planErrors: {},
  voucher: '',
  // Modem Delivery
  modemRequired: false,
  modemSameAsInstallAddress: true,
  modemManualAddress: false,
  modemFields: {},
  modemErrors: {},
  modemResponseMessage: '',
  // Finalised delivery address
  modemDeliveryAddress: '',
  // Success stage
  reference: false
};

/***/ }),

/***/ 772:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_APP_SCHEMA = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_APP_SCHEMA;
  var action = arguments[1];

  switch (action.type) {
    case _actions.SET_QFF_DETAILS:
      return _extends({}, state, {
        fieldValues: _extends({}, state.fieldValues, action.payload)
      });
    case _actions.IS_LOADING:
      return _extends({}, state, {
        isLoading: action.payload
      });
    case _actions.IS_SUCCESS:
      return _extends({}, state, {
        success: action.payload
      });
    case _actions.SET_RESPONSE_MESSAGE:
      return _extends({}, state, {
        message: action.payload
      });
    case _actions.SET_FIELD_ERRORS:
      return _extends({}, state, {
        fieldError: action.payload
      });
    case _actions.CLEAR_FIELD_ERROR:
      {
        if (!state.fieldError[action.payload]) return state;
        // Remove action.payload key from fieldError object using spread

        var _state$fieldError = state.fieldError,
            e = _state$fieldError[action.payload],
            fieldError = _objectWithoutProperties(_state$fieldError, [action.payload]);

        return _extends({}, state, {
          fieldError: fieldError
        });
      }
    case _actions.REDIRECT_PAGE:
      window.location.href = action.payload;
      return state;
    default:
      return state;
  }
};

var _actions = __webpack_require__(282);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DEFAULT_APP_SCHEMA = exports.DEFAULT_APP_SCHEMA = {
  isLoading: false,
  success: false,
  message: '',
  fieldError: {},
  fieldValues: {}
};

/***/ }),

/***/ 773:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"l-grid":"_1hu-E","l-grid--half":"_1wW-G","grid--item":"_1y90-","template-404":"_1wEx7"};

/***/ }),

/***/ 774:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://gist.github.com/iwazaru/4c8819420ce5237aeaf338339df25c32

function smoothScrollTo(endX, endY, duration) {
  var startX = window.scrollX || window.pageXOffset;
  var startY = window.scrollY || window.pageYOffset;
  var distanceX = endX - startX;
  var distanceY = endY - startY;
  var startTime = new Date().getTime();

  var newDuration = typeof duration !== 'undefined' ? duration : 400;

  // Easing function
  function easeInOutQuart(time, from, distance, inOutDuration) {
    var scopedTime = time;
    scopedTime /= inOutDuration / 2;
    if (scopedTime < 1) {
      // eslint-disable-next-line no-mixed-operators
      return distance / 2 * (scopedTime * scopedTime * scopedTime * scopedTime) + from;
    }
    scopedTime -= 2;
    // eslint-disable-next-line no-mixed-operators
    return -distance / 2 * (scopedTime * scopedTime * scopedTime * scopedTime - 2) + from;
  }

  var timer = window.setInterval(function () {
    var time = new Date().getTime() - startTime;
    var newX = easeInOutQuart(time, startX, distanceX, newDuration);
    var newY = easeInOutQuart(time, startY, distanceY, newDuration);
    if (time >= newDuration) {
      window.clearInterval(timer);
    }
    window.scrollTo(newX, newY);
  }, 1000 / 60); // 60 fps
}

window.smoothScrollTo = smoothScrollTo;

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function () { function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; } return createRawReactElement; }(); }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _styles = __webpack_require__(608);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var GenericStatusLoading = function () {
  function GenericStatusLoading(_ref) {
    var extraClassName = _ref.extraClassName;
    return _jsx('div', {
      className: extraClassName + ' ' + _styles2['default'].loader__wrapper
    }, void 0, _jsx('div', {
      className: _styles2['default'].loader
    }, void 0, 'Loading...'));
  }

  return GenericStatusLoading;
}();

GenericStatusLoading.defaultProps = {
  extraClassName: ''
};

exports['default'] = GenericStatusLoading;

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LEAD_NAME_KEY = exports.LEAD_NAME_KEY = 'name';
var LEAD_EMAIL_KEY = exports.LEAD_EMAIL_KEY = 'email';

var EMAIL_ERROR_MESSAGE = exports.EMAIL_ERROR_MESSAGE = 'Enter a valid email';
var REQUIRED_ERROR_MESSAGE = exports.REQUIRED_ERROR_MESSAGE = 'This field is required';

var COOKIE_KEY_EMAIL = exports.COOKIE_KEY_EMAIL = 'prefill_email';
var COOKIE_KEY_NAME = exports.COOKIE_KEY_NAME = 'prefill_name';
var COOKIE_KEY_ADDRESS = exports.COOKIE_KEY_ADDRESS = 'prefill_address';

var LEAD_SUCCESS_CONTAINER_ID = exports.LEAD_SUCCESS_CONTAINER_ID = 'lead_success_container';
var GA_EVENT_CATEGORY = exports.GA_EVENT_CATEGORY = 'Contact Form';
var GA_EVENT_SUBMITTED = exports.GA_EVENT_SUBMITTED = 'Submitted';

var API_POST_URL = exports.API_POST_URL = '/leads/save/';

var DEFAULT_RESPONSE_ERROR = exports.DEFAULT_RESPONSE_ERROR = 'We encountered an issue while trying to save your details, please try again';

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ADDRESS_ERROR_MESSAGE = exports.ADDRESS_ERROR_MESSAGE = 'Please select an address from the dropdown';
var API_SEARCH_URL = exports.API_SEARCH_URL = '/address/autocomplete/';
var DEFAULT_ERROR = exports.DEFAULT_ERROR = 'There was an error finding your address';
var SWITCH_MANUAL_ADDRESS = exports.SWITCH_MANUAL_ADDRESS = 'cantfind';
var ITEM_MONIKER_TOO_SHORT = exports.ITEM_MONIKER_TOO_SHORT = 'tooshort';
var ITEM_MONIKER_TOO_MANY = exports.ITEM_MONIKER_TOO_MANY = 'toomany';
var TOO_MANY_ERROR_STATUS = exports.TOO_MANY_ERROR_STATUS = 'TooManyMatches';
var HAS_RESULTS_STATUS = exports.HAS_RESULTS_STATUS = 'PickList';
var NO_MATCHES_STATUS = exports.NO_MATCHES_STATUS = 'NoMatches';
var ADDRESS_ID_KEY = exports.ADDRESS_ID_KEY = 'address';
var ADDRESS_TEXT_KEY = exports.ADDRESS_TEXT_KEY = 'addressText';

// How many characters before we start checking for results
var AUTOCOMPLETE_MIN_CHARS = exports.AUTOCOMPLETE_MIN_CHARS = 3;

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var QFF_SUCCESS_CONTAINER_ID = exports.QFF_SUCCESS_CONTAINER_ID = 'qff_success_container';

var QFF_FIRST_NAME_KEY = exports.QFF_FIRST_NAME_KEY = 'first_name';
var QFF_LAST_NAME_KEY = exports.QFF_LAST_NAME_KEY = 'last_name';
var QFF_EMAIL_KEY = exports.QFF_EMAIL_KEY = 'email';
var QFF_REFERENCE_KEY = exports.QFF_REFERENCE_KEY = 'reference';
var QFF_NUMBER_KEY = exports.QFF_NUMBER_KEY = 'qff_number';

var QFF_NUMBER_ERROR_MESSAGE = exports.QFF_NUMBER_ERROR_MESSAGE = 'Invalid Qantas Frequent Flyer number';
var QFF_REFERENCE_ERROR_MESSAGE = exports.QFF_REFERENCE_ERROR_MESSAGE = 'Invalid Customer Reference';

var API_POST_URL = exports.API_POST_URL = '/qff/save/';
var DEFAULT_RESPONSE_ERROR = exports.DEFAULT_RESPONSE_ERROR = 'We encountered an issue while trying to save your details, please try again';

/***/ })

},[294]);


// WEBPACK FOOTER //
// main.js?caab2e66